(function () {
  "use strict";

  var MATRIX = {
  "generatedAt": "2026-05-22T23:11:15.593Z",
  "source": "Zepto Product Personalizer canvas-script.php for product 10172372615514",
  "targetHandle": "erinnerungsschmuck-erstelle-deinen-ring",
  "activationParam": "solea_configurator",
  "activationValue": "1",
  "variantId": "51094466101594",
  "basePriceCents": 7999,
  "shopifyBasePriceCents": 7999,
  "currency": "EUR",
  "materials": [
    {
      "value": "Edelstahl-Ring",
      "display": "Edelstahl Ring",
      "cartValue": "Edelstahl Ring",
      "code": "",
      "priceDeltaCents": 0,
      "image": "",
      "imageAsset": "solea-memory-ring-configurator-edelstahl-ring.jpg",
      "thumbnail": "",
      "thumbnailAsset": "solea-memory-ring-configurator-edelstahl-ring-auswahl.jpg"
    },
    {
      "value": "Vergoldeter-Ring",
      "display": "Vergoldeter Ring",
      "cartValue": "Vergoldeter Ring",
      "code": "",
      "priceDeltaCents": 1000,
      "image": "",
      "imageAsset": "solea-memory-ring-configurator-vergoldeter-ring.jpg",
      "thumbnail": "",
      "thumbnailAsset": ""
    },
    {
      "value": "Rosevergoldeter-Ring",
      "display": "Rosevergoldeter Ring",
      "cartValue": "Rosevergoldeter Ring",
      "code": "",
      "priceDeltaCents": 1000,
      "image": "",
      "imageAsset": "solea-memory-ring-configurator-rosevergoldeter-ring.jpg",
      "thumbnail": "",
      "thumbnailAsset": ""
    }
  ],
  "shellRules": [
    {
      "fieldIndex": 2,
      "label": "Wähle den Durchmesser deiner Epoxidschale (Gold)",
      "optionGroup": "Erinnerungsring_Durchmesser der Epoxidschale-Gold",
      "condition": {
        "type": "and",
        "clauses": [
          {
            "fieldIndex": 1,
            "operator": "1",
            "values": [
              "Vergoldeter-Ring"
            ]
          }
        ]
      },
      "options": [
        {
          "value": "8mm-Gold",
          "display": "8mm Gold",
          "cartValue": "8mm Gold",
          "code": "",
          "priceDeltaCents": 0,
          "image": "",
          "imageAsset": "solea-memory-ring-configurator-8mm-gold.webp",
          "thumbnail": "",
          "thumbnailAsset": ""
        },
        {
          "value": "12mm-Gold",
          "display": "12mm Gold",
          "cartValue": "12mm Gold",
          "code": "",
          "priceDeltaCents": 0,
          "image": "",
          "imageAsset": "solea-memory-ring-configurator-12mm-gold.webp",
          "thumbnail": "",
          "thumbnailAsset": ""
        },
        {
          "value": "14mm-Gold",
          "display": "14mm Gold",
          "cartValue": "14mm Gold",
          "code": "",
          "priceDeltaCents": 0,
          "image": "",
          "imageAsset": "solea-memory-ring-configurator-14mm-gold.webp",
          "thumbnail": "",
          "thumbnailAsset": ""
        },
        {
          "value": "20mm-Gold",
          "display": "20mm Gold",
          "cartValue": "20mm Gold",
          "code": "",
          "priceDeltaCents": 0,
          "image": "",
          "imageAsset": "solea-memory-ring-configurator-20mm-gold.webp",
          "thumbnail": "",
          "thumbnailAsset": ""
        },
        {
          "value": "22mm-Gold",
          "display": "22mm Gold",
          "cartValue": "22mm Gold",
          "code": "",
          "priceDeltaCents": 0,
          "image": "",
          "imageAsset": "solea-memory-ring-configurator-22mm-gold.webp",
          "thumbnail": "",
          "thumbnailAsset": ""
        }
      ]
    },
    {
      "fieldIndex": 3,
      "label": "Wähle den Durchmesser deiner Epoxidschale (Edelstahl)",
      "optionGroup": "Erinnerungsring_Durchmesser der Epoxidschale-Edelstahl",
      "condition": {
        "type": "and",
        "clauses": [
          {
            "fieldIndex": 1,
            "operator": "1",
            "values": [
              "Edelstahl-Ring"
            ]
          }
        ]
      },
      "options": [
        {
          "value": "8mm-Silber",
          "display": "8mm Silber",
          "cartValue": "8mm Silber",
          "code": "",
          "priceDeltaCents": 0,
          "image": "",
          "imageAsset": "solea-memory-ring-configurator-8mm-silber.webp",
          "thumbnail": "",
          "thumbnailAsset": ""
        },
        {
          "value": "16mm-Silber",
          "display": "16mm Silber",
          "cartValue": "16mm Silber",
          "code": "",
          "priceDeltaCents": 0,
          "image": "",
          "imageAsset": "solea-memory-ring-configurator-16mm-silber.webp",
          "thumbnail": "",
          "thumbnailAsset": ""
        },
        {
          "value": "18mm-Silber",
          "display": "18mm Silber",
          "cartValue": "18mm Silber",
          "code": "",
          "priceDeltaCents": 0,
          "image": "",
          "imageAsset": "solea-memory-ring-configurator-18mm-silber.webp",
          "thumbnail": "",
          "thumbnailAsset": ""
        },
        {
          "value": "20mm-Silber",
          "display": "20mm Silber",
          "cartValue": "20mm Silber",
          "code": "",
          "priceDeltaCents": 0,
          "image": "",
          "imageAsset": "solea-memory-ring-configurator-20mm-silber.webp",
          "thumbnail": "",
          "thumbnailAsset": ""
        },
        {
          "value": "22mm-Silber",
          "display": "22mm Silber",
          "cartValue": "22mm Silber",
          "code": "",
          "priceDeltaCents": 0,
          "image": "",
          "imageAsset": "solea-memory-ring-configurator-22mm-silber.webp",
          "thumbnail": "",
          "thumbnailAsset": ""
        }
      ]
    },
    {
      "fieldIndex": 4,
      "label": "Wähle den Durchmesser deiner Epoxidschale (Rosegold)",
      "optionGroup": "Erinnerungsring_Durchmesser der Epoxidschale-Rosegold",
      "condition": {
        "type": "and",
        "clauses": [
          {
            "fieldIndex": 1,
            "operator": "1",
            "values": [
              "Rosevergoldeter-Ring"
            ]
          }
        ]
      },
      "options": [
        {
          "value": "14mm-Rosegold",
          "display": "14mm Rosegold",
          "cartValue": "14mm Rosegold",
          "code": "",
          "priceDeltaCents": 0,
          "image": "",
          "imageAsset": "solea-memory-ring-configurator-14mm-rosegold.webp",
          "thumbnail": "",
          "thumbnailAsset": ""
        },
        {
          "value": "18mm-Rosegold",
          "display": "18mm Rosegold",
          "cartValue": "18mm Rosegold",
          "code": "",
          "priceDeltaCents": 0,
          "image": "",
          "imageAsset": "solea-memory-ring-configurator-18mm-rosegold.webp",
          "thumbnail": "",
          "thumbnailAsset": ""
        }
      ]
    }
  ],
  "epoxyRules": [
    {
      "fieldIndex": 5,
      "label": "Epoxid Design (RG14)",
      "optionGroup": "SOLEA_RING_ALL_DESIGNS_5",
      "condition": {
        "type": "and",
        "clauses": [
          {
            "fieldIndex": 4,
            "operator": "1",
            "values": [
              "14mm-Rosegold"
            ]
          }
        ]
      }
    },
    {
      "fieldIndex": 6,
      "label": "Epoxid Design (RG18)",
      "optionGroup": "SOLEA_RING_ALL_DESIGNS_6",
      "condition": {
        "type": "and",
        "clauses": [
          {
            "fieldIndex": 4,
            "operator": "1",
            "values": [
              "18mm-Rosegold"
            ]
          }
        ]
      }
    },
    {
      "fieldIndex": 7,
      "label": "Epoxid Design (ES8)",
      "optionGroup": "SOLEA_RING_8MM_UNICOLOR_7",
      "condition": {
        "type": "and",
        "clauses": [
          {
            "fieldIndex": 3,
            "operator": "1",
            "values": [
              "8mm-Silber"
            ]
          }
        ]
      }
    },
    {
      "fieldIndex": 8,
      "label": "Epoxid Design (ES16)",
      "optionGroup": "SOLEA_RING_ALL_DESIGNS_8",
      "condition": {
        "type": "and",
        "clauses": [
          {
            "fieldIndex": 3,
            "operator": "1",
            "values": [
              "16mm-Silber"
            ]
          }
        ]
      }
    },
    {
      "fieldIndex": 9,
      "label": "Epoxid Design (ES18)",
      "optionGroup": "SOLEA_RING_ALL_DESIGNS_9",
      "condition": {
        "type": "and",
        "clauses": [
          {
            "fieldIndex": 3,
            "operator": "1",
            "values": [
              "18mm-Silber"
            ]
          }
        ]
      }
    },
    {
      "fieldIndex": 10,
      "label": "Epoxid Design (ES20)",
      "optionGroup": "SOLEA_RING_ALL_DESIGNS_10",
      "condition": {
        "type": "and",
        "clauses": [
          {
            "fieldIndex": 3,
            "operator": "1",
            "values": [
              "20mm-Silber"
            ]
          }
        ]
      }
    },
    {
      "fieldIndex": 11,
      "label": "Epoxid Design (ES22)",
      "optionGroup": "SOLEA_RING_ALL_DESIGNS_11",
      "condition": {
        "type": "and",
        "clauses": [
          {
            "fieldIndex": 3,
            "operator": "1",
            "values": [
              "22mm-Silber"
            ]
          }
        ]
      }
    },
    {
      "fieldIndex": 12,
      "label": "Epoxid Design (G8)",
      "optionGroup": "SOLEA_RING_8MM_UNICOLOR_12",
      "condition": {
        "type": "and",
        "clauses": [
          {
            "fieldIndex": 2,
            "operator": "1",
            "values": [
              "8mm-Gold"
            ]
          }
        ]
      }
    },
    {
      "fieldIndex": 13,
      "label": "Epoxid Design (G12)",
      "optionGroup": "SOLEA_RING_ALL_DESIGNS_13",
      "condition": {
        "type": "and",
        "clauses": [
          {
            "fieldIndex": 2,
            "operator": "1",
            "values": [
              "12mm-Gold"
            ]
          }
        ]
      }
    },
    {
      "fieldIndex": 14,
      "label": "Epoxid Design (G14)",
      "optionGroup": "SOLEA_RING_ALL_DESIGNS_14",
      "condition": {
        "type": "and",
        "clauses": [
          {
            "fieldIndex": 2,
            "operator": "1",
            "values": [
              "14mm-Gold"
            ]
          }
        ]
      }
    },
    {
      "fieldIndex": 15,
      "label": "Epoxid Design (G20)",
      "optionGroup": "SOLEA_RING_ALL_DESIGNS_15",
      "condition": {
        "type": "and",
        "clauses": [
          {
            "fieldIndex": 2,
            "operator": "1",
            "values": [
              "20mm-Gold"
            ]
          }
        ]
      }
    },
    {
      "fieldIndex": 16,
      "label": "Epoxid Design (G22)",
      "optionGroup": "SOLEA_RING_ALL_DESIGNS_16",
      "condition": {
        "type": "and",
        "clauses": [
          {
            "fieldIndex": 2,
            "operator": "1",
            "values": [
              "22mm-Gold"
            ]
          }
        ]
      }
    }
  ],
  "epoxyPatternGroups": {
    "SOLEA_RING_ALL_DESIGNS_5": null,
    "SOLEA_RING_ALL_DESIGNS_6": null,
    "SOLEA_RING_8MM_UNICOLOR_7": [
      {
        "value": "UNICOLOR-CABOCHON-91",
        "display": "UNICOLOR Cabochon 91",
        "cartValue": "UNICOLOR-CABOCHON-91",
        "code": "",
        "priceDeltaCents": 0,
        "image": "",
        "imageAsset": "solea-memory-ring-configurator-cabochon-91.webp",
        "thumbnail": "",
        "thumbnailAsset": ""
      },
      {
        "value": "UNICOLOR-CABOCHON-92",
        "display": "UNICOLOR Cabochon 92",
        "cartValue": "UNICOLOR-CABOCHON-92",
        "code": "",
        "priceDeltaCents": 0,
        "image": "",
        "imageAsset": "solea-memory-ring-configurator-cabochon-92.webp",
        "thumbnail": "",
        "thumbnailAsset": ""
      },
      {
        "value": "UNICOLOR-CABOCHON-93",
        "display": "UNICOLOR Cabochon 93",
        "cartValue": "UNICOLOR-CABOCHON-93",
        "code": "",
        "priceDeltaCents": 0,
        "image": "",
        "imageAsset": "solea-memory-ring-configurator-cabochon-93.webp",
        "thumbnail": "",
        "thumbnailAsset": ""
      },
      {
        "value": "UNICOLOR-CABOCHON-94",
        "display": "UNICOLOR Cabochon 94",
        "cartValue": "UNICOLOR-CABOCHON-94",
        "code": "",
        "priceDeltaCents": 0,
        "image": "",
        "imageAsset": "solea-memory-ring-configurator-cabochon-94.webp",
        "thumbnail": "",
        "thumbnailAsset": ""
      },
      {
        "value": "UNICOLOR-CABOCHON-95",
        "display": "UNICOLOR Cabochon 95",
        "cartValue": "UNICOLOR-CABOCHON-95",
        "code": "",
        "priceDeltaCents": 0,
        "image": "",
        "imageAsset": "solea-memory-ring-configurator-cabochon-95.webp",
        "thumbnail": "",
        "thumbnailAsset": ""
      },
      {
        "value": "UNICOLOR-CABOCHON-98",
        "display": "UNICOLOR Cabochon 98",
        "cartValue": "UNICOLOR-CABOCHON-98",
        "code": "",
        "priceDeltaCents": 0,
        "image": "",
        "imageAsset": "solea-memory-ring-configurator-cabochon-98.webp",
        "thumbnail": "",
        "thumbnailAsset": ""
      },
      {
        "value": "UNICOLOR-CABOCHON-34",
        "display": "UNICOLOR Cabochon 34",
        "cartValue": "UNICOLOR-CABOCHON-34",
        "code": "",
        "priceDeltaCents": 0,
        "image": "",
        "imageAsset": "solea-memory-ring-configurator-cabochon-34.webp",
        "thumbnail": "",
        "thumbnailAsset": ""
      },
      {
        "value": "UNICOLOR-RINGFARBE-Black",
        "display": "UNICOLOR Black",
        "cartValue": "UNICOLOR-RINGFARBE-Black",
        "code": "",
        "priceDeltaCents": 0,
        "image": "",
        "imageAsset": "solea-memory-ring-configurator-ringfarbe-black.webp",
        "thumbnail": "",
        "thumbnailAsset": ""
      },
      {
        "value": "UNICOLOR-RINGFARBE-Green",
        "display": "UNICOLOR Green",
        "cartValue": "UNICOLOR-RINGFARBE-Green",
        "code": "",
        "priceDeltaCents": 0,
        "image": "",
        "imageAsset": "solea-memory-ring-configurator-ringfarbe-green.webp",
        "thumbnail": "",
        "thumbnailAsset": ""
      },
      {
        "value": "UNICOLOR-RINGFARBE-Lightblue",
        "display": "UNICOLOR Lightblue",
        "cartValue": "UNICOLOR-RINGFARBE-Lightblue",
        "code": "",
        "priceDeltaCents": 0,
        "image": "",
        "imageAsset": "solea-memory-ring-configurator-ringfarbe-lightblue.webp",
        "thumbnail": "",
        "thumbnailAsset": ""
      },
      {
        "value": "UNICOLOR-RINGFARBE-Lightgreen",
        "display": "UNICOLOR Lightgreen",
        "cartValue": "UNICOLOR-RINGFARBE-Lightgreen",
        "code": "",
        "priceDeltaCents": 0,
        "image": "",
        "imageAsset": "solea-memory-ring-configurator-ringfarbe-lightgreen.webp",
        "thumbnail": "",
        "thumbnailAsset": ""
      },
      {
        "value": "UNICOLOR-RINGFARBE-Orange",
        "display": "UNICOLOR Orange",
        "cartValue": "UNICOLOR-RINGFARBE-Orange",
        "code": "",
        "priceDeltaCents": 0,
        "image": "",
        "imageAsset": "solea-memory-ring-configurator-ringfarbe-orange.webp",
        "thumbnail": "",
        "thumbnailAsset": ""
      },
      {
        "value": "UNICOLOR-RINGFARBE-Pink",
        "display": "UNICOLOR Pink",
        "cartValue": "UNICOLOR-RINGFARBE-Pink",
        "code": "",
        "priceDeltaCents": 0,
        "image": "",
        "imageAsset": "solea-memory-ring-configurator-ringfarbe-pink.webp",
        "thumbnail": "",
        "thumbnailAsset": ""
      },
      {
        "value": "UNICOLOR-RINGFARBE-Red",
        "display": "UNICOLOR Red",
        "cartValue": "UNICOLOR-RINGFARBE-Red",
        "code": "",
        "priceDeltaCents": 0,
        "image": "",
        "imageAsset": "solea-memory-ring-configurator-ringfarbe-red.webp",
        "thumbnail": "",
        "thumbnailAsset": ""
      },
      {
        "value": "UNICOLOR-RINGFARBE-Violet",
        "display": "UNICOLOR Violet",
        "cartValue": "UNICOLOR-RINGFARBE-Violet",
        "code": "",
        "priceDeltaCents": 0,
        "image": "",
        "imageAsset": "solea-memory-ring-configurator-ringfarbe-violet.webp",
        "thumbnail": "",
        "thumbnailAsset": ""
      },
      {
        "value": "UNICOLOR-RINGFARBE-White",
        "display": "UNICOLOR White",
        "cartValue": "UNICOLOR-RINGFARBE-White",
        "code": "",
        "priceDeltaCents": 0,
        "image": "",
        "imageAsset": "solea-memory-ring-configurator-ringfarbe-white.webp",
        "thumbnail": "",
        "thumbnailAsset": ""
      },
      {
        "value": "UNICOLOR-RINGFARBE-Yellow",
        "display": "UNICOLOR Yellow",
        "cartValue": "UNICOLOR-RINGFARBE-Yellow",
        "code": "",
        "priceDeltaCents": 0,
        "image": "",
        "imageAsset": "solea-memory-ring-configurator-ringfarbe-yellow.webp",
        "thumbnail": "",
        "thumbnailAsset": ""
      },
      {
        "value": "UNICOLOR-RINGFARBE-G-Blue",
        "display": "UNICOLOR G Blue",
        "cartValue": "UNICOLOR-RINGFARBE-G-Blue",
        "code": "",
        "priceDeltaCents": 0,
        "image": "",
        "imageAsset": "solea-memory-ring-configurator-ringfarbe-g-blue.webp",
        "thumbnail": "",
        "thumbnailAsset": ""
      }
    ],
    "SOLEA_RING_ALL_DESIGNS_8": null,
    "SOLEA_RING_ALL_DESIGNS_9": null,
    "SOLEA_RING_ALL_DESIGNS_10": null,
    "SOLEA_RING_ALL_DESIGNS_11": null,
    "SOLEA_RING_8MM_UNICOLOR_12": [
      {
        "value": "UNICOLOR-CABOCHON-91",
        "display": "UNICOLOR Cabochon 91",
        "cartValue": "UNICOLOR-CABOCHON-91",
        "code": "",
        "priceDeltaCents": 0,
        "image": "",
        "imageAsset": "solea-memory-ring-configurator-cabochon-91.webp",
        "thumbnail": "",
        "thumbnailAsset": ""
      },
      {
        "value": "UNICOLOR-CABOCHON-92",
        "display": "UNICOLOR Cabochon 92",
        "cartValue": "UNICOLOR-CABOCHON-92",
        "code": "",
        "priceDeltaCents": 0,
        "image": "",
        "imageAsset": "solea-memory-ring-configurator-cabochon-92.webp",
        "thumbnail": "",
        "thumbnailAsset": ""
      },
      {
        "value": "UNICOLOR-CABOCHON-93",
        "display": "UNICOLOR Cabochon 93",
        "cartValue": "UNICOLOR-CABOCHON-93",
        "code": "",
        "priceDeltaCents": 0,
        "image": "",
        "imageAsset": "solea-memory-ring-configurator-cabochon-93.webp",
        "thumbnail": "",
        "thumbnailAsset": ""
      },
      {
        "value": "UNICOLOR-CABOCHON-94",
        "display": "UNICOLOR Cabochon 94",
        "cartValue": "UNICOLOR-CABOCHON-94",
        "code": "",
        "priceDeltaCents": 0,
        "image": "",
        "imageAsset": "solea-memory-ring-configurator-cabochon-94.webp",
        "thumbnail": "",
        "thumbnailAsset": ""
      },
      {
        "value": "UNICOLOR-CABOCHON-95",
        "display": "UNICOLOR Cabochon 95",
        "cartValue": "UNICOLOR-CABOCHON-95",
        "code": "",
        "priceDeltaCents": 0,
        "image": "",
        "imageAsset": "solea-memory-ring-configurator-cabochon-95.webp",
        "thumbnail": "",
        "thumbnailAsset": ""
      },
      {
        "value": "UNICOLOR-CABOCHON-98",
        "display": "UNICOLOR Cabochon 98",
        "cartValue": "UNICOLOR-CABOCHON-98",
        "code": "",
        "priceDeltaCents": 0,
        "image": "",
        "imageAsset": "solea-memory-ring-configurator-cabochon-98.webp",
        "thumbnail": "",
        "thumbnailAsset": ""
      },
      {
        "value": "UNICOLOR-CABOCHON-34",
        "display": "UNICOLOR Cabochon 34",
        "cartValue": "UNICOLOR-CABOCHON-34",
        "code": "",
        "priceDeltaCents": 0,
        "image": "",
        "imageAsset": "solea-memory-ring-configurator-cabochon-34.webp",
        "thumbnail": "",
        "thumbnailAsset": ""
      },
      {
        "value": "UNICOLOR-RINGFARBE-Black",
        "display": "UNICOLOR Black",
        "cartValue": "UNICOLOR-RINGFARBE-Black",
        "code": "",
        "priceDeltaCents": 0,
        "image": "",
        "imageAsset": "solea-memory-ring-configurator-ringfarbe-black.webp",
        "thumbnail": "",
        "thumbnailAsset": ""
      },
      {
        "value": "UNICOLOR-RINGFARBE-Green",
        "display": "UNICOLOR Green",
        "cartValue": "UNICOLOR-RINGFARBE-Green",
        "code": "",
        "priceDeltaCents": 0,
        "image": "",
        "imageAsset": "solea-memory-ring-configurator-ringfarbe-green.webp",
        "thumbnail": "",
        "thumbnailAsset": ""
      },
      {
        "value": "UNICOLOR-RINGFARBE-Lightblue",
        "display": "UNICOLOR Lightblue",
        "cartValue": "UNICOLOR-RINGFARBE-Lightblue",
        "code": "",
        "priceDeltaCents": 0,
        "image": "",
        "imageAsset": "solea-memory-ring-configurator-ringfarbe-lightblue.webp",
        "thumbnail": "",
        "thumbnailAsset": ""
      },
      {
        "value": "UNICOLOR-RINGFARBE-Lightgreen",
        "display": "UNICOLOR Lightgreen",
        "cartValue": "UNICOLOR-RINGFARBE-Lightgreen",
        "code": "",
        "priceDeltaCents": 0,
        "image": "",
        "imageAsset": "solea-memory-ring-configurator-ringfarbe-lightgreen.webp",
        "thumbnail": "",
        "thumbnailAsset": ""
      },
      {
        "value": "UNICOLOR-RINGFARBE-Orange",
        "display": "UNICOLOR Orange",
        "cartValue": "UNICOLOR-RINGFARBE-Orange",
        "code": "",
        "priceDeltaCents": 0,
        "image": "",
        "imageAsset": "solea-memory-ring-configurator-ringfarbe-orange.webp",
        "thumbnail": "",
        "thumbnailAsset": ""
      },
      {
        "value": "UNICOLOR-RINGFARBE-Pink",
        "display": "UNICOLOR Pink",
        "cartValue": "UNICOLOR-RINGFARBE-Pink",
        "code": "",
        "priceDeltaCents": 0,
        "image": "",
        "imageAsset": "solea-memory-ring-configurator-ringfarbe-pink.webp",
        "thumbnail": "",
        "thumbnailAsset": ""
      },
      {
        "value": "UNICOLOR-RINGFARBE-Red",
        "display": "UNICOLOR Red",
        "cartValue": "UNICOLOR-RINGFARBE-Red",
        "code": "",
        "priceDeltaCents": 0,
        "image": "",
        "imageAsset": "solea-memory-ring-configurator-ringfarbe-red.webp",
        "thumbnail": "",
        "thumbnailAsset": ""
      },
      {
        "value": "UNICOLOR-RINGFARBE-Violet",
        "display": "UNICOLOR Violet",
        "cartValue": "UNICOLOR-RINGFARBE-Violet",
        "code": "",
        "priceDeltaCents": 0,
        "image": "",
        "imageAsset": "solea-memory-ring-configurator-ringfarbe-violet.webp",
        "thumbnail": "",
        "thumbnailAsset": ""
      },
      {
        "value": "UNICOLOR-RINGFARBE-White",
        "display": "UNICOLOR White",
        "cartValue": "UNICOLOR-RINGFARBE-White",
        "code": "",
        "priceDeltaCents": 0,
        "image": "",
        "imageAsset": "solea-memory-ring-configurator-ringfarbe-white.webp",
        "thumbnail": "",
        "thumbnailAsset": ""
      },
      {
        "value": "UNICOLOR-RINGFARBE-Yellow",
        "display": "UNICOLOR Yellow",
        "cartValue": "UNICOLOR-RINGFARBE-Yellow",
        "code": "",
        "priceDeltaCents": 0,
        "image": "",
        "imageAsset": "solea-memory-ring-configurator-ringfarbe-yellow.webp",
        "thumbnail": "",
        "thumbnailAsset": ""
      },
      {
        "value": "UNICOLOR-RINGFARBE-G-Blue",
        "display": "UNICOLOR G Blue",
        "cartValue": "UNICOLOR-RINGFARBE-G-Blue",
        "code": "",
        "priceDeltaCents": 0,
        "image": "",
        "imageAsset": "solea-memory-ring-configurator-ringfarbe-g-blue.webp",
        "thumbnail": "",
        "thumbnailAsset": ""
      }
    ],
    "SOLEA_RING_ALL_DESIGNS_13": null,
    "SOLEA_RING_ALL_DESIGNS_14": null,
    "SOLEA_RING_ALL_DESIGNS_15": null,
    "SOLEA_RING_ALL_DESIGNS_16": null
  },
  "memoryObjectOptions": [
    {
      "value": "Asche",
      "display": "Asche",
      "cartValue": "Asche",
      "code": "",
      "priceDeltaCents": 0,
      "image": "",
      "imageAsset": "",
      "thumbnail": "",
      "thumbnailAsset": ""
    },
    {
      "value": "Blüten",
      "display": "Blüten",
      "cartValue": "Blüten",
      "code": "",
      "priceDeltaCents": 0,
      "image": "",
      "imageAsset": "",
      "thumbnail": "",
      "thumbnailAsset": ""
    },
    {
      "value": "Haarsträhne",
      "display": "Haarsträhne",
      "cartValue": "Haarsträhne",
      "code": "",
      "priceDeltaCents": 0,
      "image": "",
      "imageAsset": "",
      "thumbnail": "",
      "thumbnailAsset": ""
    },
    {
      "value": "Sand",
      "display": "Sand",
      "cartValue": "Sand",
      "code": "",
      "priceDeltaCents": 0,
      "image": "",
      "imageAsset": "",
      "thumbnail": "",
      "thumbnailAsset": ""
    },
    {
      "value": "Stoffstück",
      "display": "Stoffstück",
      "cartValue": "Stoffstück",
      "code": "",
      "priceDeltaCents": 0,
      "image": "",
      "imageAsset": "",
      "thumbnail": "",
      "thumbnailAsset": ""
    },
    {
      "value": "Sonstiges",
      "display": "Sonstiges",
      "cartValue": "Sonstiges",
      "code": "",
      "priceDeltaCents": 0,
      "image": "",
      "imageAsset": "",
      "thumbnail": "",
      "thumbnailAsset": ""
    }
  ],
  "memoryVisibilityOptions": [
    {
      "value": "Mein Erinnerungsobjekt soll sichtbar sein",
      "display": "Mein Erinnerungsobjekt soll sichtbar sein",
      "cartValue": "Mein Erinnerungsobjekt soll sichtbar sein",
      "code": "",
      "priceDeltaCents": 0,
      "image": "",
      "imageAsset": "",
      "thumbnail": "",
      "thumbnailAsset": ""
    },
    {
      "value": "Mein Erinnerungsobjekt soll nicht sichtbar sein",
      "display": "Mein Erinnerungsobjekt soll nicht sichtbar sein",
      "cartValue": "Mein Erinnerungsobjekt soll nicht sichtbar sein",
      "code": "",
      "priceDeltaCents": 0,
      "image": "",
      "imageAsset": "",
      "thumbnail": "",
      "thumbnailAsset": ""
    }
  ],
  "previewPlacements": {
    "14mm-Rosegold": {
      "x": 49.46,
      "y": 55.79,
      "size": 28,
      "scaleX": 0.58,
      "scaleY": 0.57,
      "rotate": 0
    },
    "18mm-Rosegold": {
      "x": 49.46,
      "y": 56.54,
      "size": 28,
      "scaleX": 0.68,
      "scaleY": 0.67,
      "rotate": 0
    },
    "8mm-Silber": {
      "x": 49.14,
      "y": 56.03,
      "size": 24.83,
      "scaleX": 0.5,
      "scaleY": 0.5,
      "rotate": 0
    },
    "16mm-Silber": {
      "x": 49.27,
      "y": 55.92,
      "size": 28,
      "scaleX": 0.64,
      "scaleY": 0.62,
      "rotate": 0
    },
    "18mm-Silber": {
      "x": 49.37,
      "y": 56.86,
      "size": 28,
      "scaleX": 0.69,
      "scaleY": 0.68,
      "rotate": 0
    },
    "20mm-Silber": {
      "x": 49.37,
      "y": 57.7,
      "size": 28,
      "scaleX": 0.74,
      "scaleY": 0.73,
      "rotate": 0
    },
    "22mm-Silber": {
      "x": 49.27,
      "y": 57.89,
      "size": 28,
      "scaleX": 0.79,
      "scaleY": 0.78,
      "rotate": 0
    },
    "8mm-Gold": {
      "x": 49.08,
      "y": 55.79,
      "size": 28,
      "scaleX": 0.53,
      "scaleY": 0.53,
      "rotate": 0
    },
    "12mm-Gold": {
      "x": 49.27,
      "y": 55.97,
      "size": 28,
      "scaleX": 0.66,
      "scaleY": 0.66,
      "rotate": 0
    },
    "14mm-Gold": {
      "x": 49.27,
      "y": 55.13,
      "size": 28,
      "scaleX": 0.59,
      "scaleY": 0.57,
      "rotate": 0
    },
    "20mm-Gold": {
      "x": 49.55,
      "y": 56.82,
      "size": 28,
      "scaleX": 0.74,
      "scaleY": 0.73,
      "rotate": 0
    },
    "22mm-Gold": {
      "x": 49.55,
      "y": 57.57,
      "size": 28,
      "scaleX": 0.8,
      "scaleY": 0.78,
      "rotate": 0
    }
  },
  "epoxyPatterns": [
    {
      "value": "LIGHT-v2-194",
      "display": "LIGHT v2 194",
      "cartValue": "LIGHT v2 194",
      "code": "",
      "priceDeltaCents": 0,
      "image": "",
      "imageAsset": "solea-memory-ring-configurator-light-v2-194.webp",
      "thumbnail": "",
      "thumbnailAsset": ""
    },
    {
      "value": "LIGHT-v2-118",
      "display": "LIGHT v2 118",
      "cartValue": "LIGHT v2 118",
      "code": "",
      "priceDeltaCents": 0,
      "image": "",
      "imageAsset": "solea-memory-ring-configurator-light-v2-118.webp",
      "thumbnail": "",
      "thumbnailAsset": ""
    },
    {
      "value": "LIGHT-v2-155",
      "display": "LIGHT v2 155",
      "cartValue": "LIGHT v2 155",
      "code": "",
      "priceDeltaCents": 0,
      "image": "",
      "imageAsset": "solea-memory-ring-configurator-light-v2-155.webp",
      "thumbnail": "",
      "thumbnailAsset": ""
    },
    {
      "value": "LIGHT-v2-132",
      "display": "LIGHT v2 132",
      "cartValue": "LIGHT v2 132",
      "code": "",
      "priceDeltaCents": 0,
      "image": "",
      "imageAsset": "solea-memory-ring-configurator-light-v2-132.webp",
      "thumbnail": "",
      "thumbnailAsset": ""
    },
    {
      "value": "LIGHT-v2-126",
      "display": "LIGHT v2 126",
      "cartValue": "LIGHT v2 126",
      "code": "",
      "priceDeltaCents": 0,
      "image": "",
      "imageAsset": "solea-memory-ring-configurator-light-v2-126.webp",
      "thumbnail": "",
      "thumbnailAsset": ""
    },
    {
      "value": "LIGHT-v2-157",
      "display": "LIGHT v2 157",
      "cartValue": "LIGHT v2 157",
      "code": "",
      "priceDeltaCents": 0,
      "image": "",
      "imageAsset": "solea-memory-ring-configurator-light-v2-157.webp",
      "thumbnail": "",
      "thumbnailAsset": ""
    },
    {
      "value": "LIGHT-v2-123",
      "display": "LIGHT v2 123",
      "cartValue": "LIGHT v2 123",
      "code": "",
      "priceDeltaCents": 0,
      "image": "",
      "imageAsset": "solea-memory-ring-configurator-light-v2-123.webp",
      "thumbnail": "",
      "thumbnailAsset": ""
    },
    {
      "value": "LIGHT-v2-144",
      "display": "LIGHT v2 144",
      "cartValue": "LIGHT v2 144",
      "code": "",
      "priceDeltaCents": 0,
      "image": "",
      "imageAsset": "solea-memory-ring-configurator-light-v2-144.webp",
      "thumbnail": "",
      "thumbnailAsset": ""
    },
    {
      "value": "LIGHT-v3-162",
      "display": "LIGHT v3 162",
      "cartValue": "LIGHT v3 162",
      "code": "",
      "priceDeltaCents": 0,
      "image": "",
      "imageAsset": "solea-memory-ring-configurator-light-v3-162.webp",
      "thumbnail": "",
      "thumbnailAsset": ""
    },
    {
      "value": "LIGHT-v2-202",
      "display": "LIGHT v2 202",
      "cartValue": "LIGHT v2 202",
      "code": "",
      "priceDeltaCents": 0,
      "image": "",
      "imageAsset": "solea-memory-ring-configurator-light-v2-202.webp",
      "thumbnail": "",
      "thumbnailAsset": ""
    },
    {
      "value": "LIGHT-v2-96",
      "display": "LIGHT v2 96",
      "cartValue": "LIGHT v2 96",
      "code": "",
      "priceDeltaCents": 0,
      "image": "",
      "imageAsset": "solea-memory-ring-configurator-light-v2-96.webp",
      "thumbnail": "",
      "thumbnailAsset": ""
    },
    {
      "value": "LIGHT-v2-166",
      "display": "LIGHT v2 166",
      "cartValue": "LIGHT v2 166",
      "code": "",
      "priceDeltaCents": 0,
      "image": "",
      "imageAsset": "solea-memory-ring-configurator-light-v2-166.webp",
      "thumbnail": "",
      "thumbnailAsset": ""
    },
    {
      "value": "LIGHT-v2-151",
      "display": "LIGHT v2 151",
      "cartValue": "LIGHT v2 151",
      "code": "",
      "priceDeltaCents": 0,
      "image": "",
      "imageAsset": "solea-memory-ring-configurator-light-v2-151.webp",
      "thumbnail": "",
      "thumbnailAsset": ""
    },
    {
      "value": "LIGHT-v2-89",
      "display": "LIGHT v2 89",
      "cartValue": "LIGHT v2 89",
      "code": "",
      "priceDeltaCents": 0,
      "image": "",
      "imageAsset": "solea-memory-ring-configurator-light-v2-89.webp",
      "thumbnail": "",
      "thumbnailAsset": ""
    },
    {
      "value": "COPPER-131",
      "display": "COPPER 131",
      "cartValue": "COPPER 131",
      "code": "",
      "priceDeltaCents": 0,
      "image": "",
      "imageAsset": "solea-memory-ring-configurator-copper-131.webp",
      "thumbnail": "",
      "thumbnailAsset": ""
    },
    {
      "value": "COPPER-210",
      "display": "COPPER 210",
      "cartValue": "COPPER 210",
      "code": "",
      "priceDeltaCents": 0,
      "image": "",
      "imageAsset": "solea-memory-ring-configurator-copper-210.webp",
      "thumbnail": "",
      "thumbnailAsset": ""
    },
    {
      "value": "GOLD-119",
      "display": "GOLD 119",
      "cartValue": "GOLD 119",
      "code": "",
      "priceDeltaCents": 0,
      "image": "",
      "imageAsset": "solea-memory-ring-configurator-gold-119.webp",
      "thumbnail": "",
      "thumbnailAsset": ""
    },
    {
      "value": "GOLD-176",
      "display": "GOLD 176",
      "cartValue": "GOLD 176",
      "code": "",
      "priceDeltaCents": 0,
      "image": "",
      "imageAsset": "solea-memory-ring-configurator-gold-176.webp",
      "thumbnail": "",
      "thumbnailAsset": ""
    },
    {
      "value": "YELLOW-113",
      "display": "YELLOW 113",
      "cartValue": "YELLOW 113",
      "code": "",
      "priceDeltaCents": 0,
      "image": "",
      "imageAsset": "solea-memory-ring-configurator-yellow-113.webp",
      "thumbnail": "",
      "thumbnailAsset": ""
    },
    {
      "value": "YELLOW-116",
      "display": "YELLOW 116",
      "cartValue": "YELLOW 116",
      "code": "",
      "priceDeltaCents": 0,
      "image": "",
      "imageAsset": "solea-memory-ring-configurator-yellow-116.webp",
      "thumbnail": "",
      "thumbnailAsset": ""
    },
    {
      "value": "YELLOW-133",
      "display": "YELLOW 133",
      "cartValue": "YELLOW 133",
      "code": "",
      "priceDeltaCents": 0,
      "image": "",
      "imageAsset": "solea-memory-ring-configurator-yellow-133.webp",
      "thumbnail": "",
      "thumbnailAsset": ""
    },
    {
      "value": "YELLOW-160",
      "display": "YELLOW 160",
      "cartValue": "YELLOW 160",
      "code": "",
      "priceDeltaCents": 0,
      "image": "",
      "imageAsset": "solea-memory-ring-configurator-yellow-160.webp",
      "thumbnail": "",
      "thumbnailAsset": ""
    },
    {
      "value": "YELLOW-163",
      "display": "YELLOW 163",
      "cartValue": "YELLOW 163",
      "code": "",
      "priceDeltaCents": 0,
      "image": "",
      "imageAsset": "solea-memory-ring-configurator-yellow-163.webp",
      "thumbnail": "",
      "thumbnailAsset": ""
    },
    {
      "value": "YELLOW-165",
      "display": "YELLOW 165",
      "cartValue": "YELLOW 165",
      "code": "",
      "priceDeltaCents": 0,
      "image": "",
      "imageAsset": "solea-memory-ring-configurator-yellow-165.webp",
      "thumbnail": "",
      "thumbnailAsset": ""
    },
    {
      "value": "YELLOW-172",
      "display": "YELLOW 172",
      "cartValue": "YELLOW 172",
      "code": "",
      "priceDeltaCents": 0,
      "image": "",
      "imageAsset": "solea-memory-ring-configurator-yellow-172.webp",
      "thumbnail": "",
      "thumbnailAsset": ""
    },
    {
      "value": "YELLOW-178",
      "display": "YELLOW 178",
      "cartValue": "YELLOW 178",
      "code": "",
      "priceDeltaCents": 0,
      "image": "",
      "imageAsset": "solea-memory-ring-configurator-yellow-178.webp",
      "thumbnail": "",
      "thumbnailAsset": ""
    },
    {
      "value": "YELLOW-183",
      "display": "YELLOW 183",
      "cartValue": "YELLOW 183",
      "code": "",
      "priceDeltaCents": 0,
      "image": "",
      "imageAsset": "solea-memory-ring-configurator-yellow-183.webp",
      "thumbnail": "",
      "thumbnailAsset": ""
    },
    {
      "value": "YELLOW-184",
      "display": "YELLOW 184",
      "cartValue": "YELLOW 184",
      "code": "",
      "priceDeltaCents": 0,
      "image": "",
      "imageAsset": "solea-memory-ring-configurator-yellow-184.webp",
      "thumbnail": "",
      "thumbnailAsset": ""
    },
    {
      "value": "YELLOW-186",
      "display": "YELLOW 186",
      "cartValue": "YELLOW 186",
      "code": "",
      "priceDeltaCents": 0,
      "image": "",
      "imageAsset": "solea-memory-ring-configurator-yellow-186.webp",
      "thumbnail": "",
      "thumbnailAsset": ""
    },
    {
      "value": "YELLOW-190",
      "display": "YELLOW 190",
      "cartValue": "YELLOW 190",
      "code": "",
      "priceDeltaCents": 0,
      "image": "",
      "imageAsset": "solea-memory-ring-configurator-yellow-190.webp",
      "thumbnail": "",
      "thumbnailAsset": ""
    },
    {
      "value": "YELLOW-199",
      "display": "YELLOW 199",
      "cartValue": "YELLOW 199",
      "code": "",
      "priceDeltaCents": 0,
      "image": "",
      "imageAsset": "solea-memory-ring-configurator-yellow-199.webp",
      "thumbnail": "",
      "thumbnailAsset": ""
    },
    {
      "value": "YELLOW-205",
      "display": "YELLOW 205",
      "cartValue": "YELLOW 205",
      "code": "",
      "priceDeltaCents": 0,
      "image": "",
      "imageAsset": "solea-memory-ring-configurator-yellow-205.webp",
      "thumbnail": "",
      "thumbnailAsset": ""
    },
    {
      "value": "RED-213",
      "display": "RED 213",
      "cartValue": "RED 213",
      "code": "",
      "priceDeltaCents": 0,
      "image": "",
      "imageAsset": "solea-memory-ring-configurator-red-213.webp",
      "thumbnail": "",
      "thumbnailAsset": ""
    },
    {
      "value": "RED-34",
      "display": "RED 34",
      "cartValue": "RED 34",
      "code": "",
      "priceDeltaCents": 0,
      "image": "",
      "imageAsset": "solea-memory-ring-configurator-red-34.webp",
      "thumbnail": "",
      "thumbnailAsset": ""
    },
    {
      "value": "RED-161",
      "display": "RED 161",
      "cartValue": "RED 161",
      "code": "",
      "priceDeltaCents": 0,
      "image": "",
      "imageAsset": "solea-memory-ring-configurator-red-161.webp",
      "thumbnail": "",
      "thumbnailAsset": ""
    },
    {
      "value": "RED-52",
      "display": "RED 52",
      "cartValue": "RED 52",
      "code": "",
      "priceDeltaCents": 0,
      "image": "",
      "imageAsset": "solea-memory-ring-configurator-red-52.webp",
      "thumbnail": "",
      "thumbnailAsset": ""
    },
    {
      "value": "RED-179",
      "display": "RED 179",
      "cartValue": "RED 179",
      "code": "",
      "priceDeltaCents": 0,
      "image": "",
      "imageAsset": "solea-memory-ring-configurator-red-179.webp",
      "thumbnail": "",
      "thumbnailAsset": ""
    },
    {
      "value": "RED-171",
      "display": "RED 171",
      "cartValue": "RED 171",
      "code": "",
      "priceDeltaCents": 0,
      "image": "",
      "imageAsset": "solea-memory-ring-configurator-red-171.webp",
      "thumbnail": "",
      "thumbnailAsset": ""
    },
    {
      "value": "RED-101",
      "display": "RED 101",
      "cartValue": "RED 101",
      "code": "",
      "priceDeltaCents": 0,
      "image": "",
      "imageAsset": "solea-memory-ring-configurator-red-101.webp",
      "thumbnail": "",
      "thumbnailAsset": ""
    },
    {
      "value": "GREEN-10",
      "display": "GREEN 10",
      "cartValue": "GREEN 10",
      "code": "",
      "priceDeltaCents": 0,
      "image": "",
      "imageAsset": "solea-memory-ring-configurator-green-10.webp",
      "thumbnail": "",
      "thumbnailAsset": ""
    },
    {
      "value": "GREEN-107",
      "display": "GREEN 107",
      "cartValue": "GREEN 107",
      "code": "",
      "priceDeltaCents": 0,
      "image": "",
      "imageAsset": "solea-memory-ring-configurator-green-107.webp",
      "thumbnail": "",
      "thumbnailAsset": ""
    },
    {
      "value": "GREEN-11",
      "display": "GREEN 11",
      "cartValue": "GREEN 11",
      "code": "",
      "priceDeltaCents": 0,
      "image": "",
      "imageAsset": "solea-memory-ring-configurator-green-11.webp",
      "thumbnail": "",
      "thumbnailAsset": ""
    },
    {
      "value": "GREEN-119",
      "display": "GREEN 119",
      "cartValue": "GREEN 119",
      "code": "",
      "priceDeltaCents": 0,
      "image": "",
      "imageAsset": "solea-memory-ring-configurator-green-119.webp",
      "thumbnail": "",
      "thumbnailAsset": ""
    },
    {
      "value": "GREEN-128",
      "display": "GREEN 128",
      "cartValue": "GREEN 128",
      "code": "",
      "priceDeltaCents": 0,
      "image": "",
      "imageAsset": "solea-memory-ring-configurator-green-128.webp",
      "thumbnail": "",
      "thumbnailAsset": ""
    },
    {
      "value": "GREEN-13",
      "display": "GREEN 13",
      "cartValue": "GREEN 13",
      "code": "",
      "priceDeltaCents": 0,
      "image": "",
      "imageAsset": "solea-memory-ring-configurator-green-13.webp",
      "thumbnail": "",
      "thumbnailAsset": ""
    },
    {
      "value": "GREEN-135",
      "display": "GREEN 135",
      "cartValue": "GREEN 135",
      "code": "",
      "priceDeltaCents": 0,
      "image": "",
      "imageAsset": "solea-memory-ring-configurator-green-135.webp",
      "thumbnail": "",
      "thumbnailAsset": ""
    },
    {
      "value": "GREEN-139",
      "display": "GREEN 139",
      "cartValue": "GREEN 139",
      "code": "",
      "priceDeltaCents": 0,
      "image": "",
      "imageAsset": "solea-memory-ring-configurator-green-139.webp",
      "thumbnail": "",
      "thumbnailAsset": ""
    },
    {
      "value": "GREEN-148",
      "display": "GREEN 148",
      "cartValue": "GREEN 148",
      "code": "",
      "priceDeltaCents": 0,
      "image": "",
      "imageAsset": "solea-memory-ring-configurator-green-148.webp",
      "thumbnail": "",
      "thumbnailAsset": ""
    },
    {
      "value": "GREEN-158",
      "display": "GREEN 158",
      "cartValue": "GREEN 158",
      "code": "",
      "priceDeltaCents": 0,
      "image": "",
      "imageAsset": "solea-memory-ring-configurator-green-158.webp",
      "thumbnail": "",
      "thumbnailAsset": ""
    },
    {
      "value": "GREEN-174",
      "display": "GREEN 174",
      "cartValue": "GREEN 174",
      "code": "",
      "priceDeltaCents": 0,
      "image": "",
      "imageAsset": "solea-memory-ring-configurator-green-174.webp",
      "thumbnail": "",
      "thumbnailAsset": ""
    },
    {
      "value": "GREEN-182",
      "display": "GREEN 182",
      "cartValue": "GREEN 182",
      "code": "",
      "priceDeltaCents": 0,
      "image": "",
      "imageAsset": "solea-memory-ring-configurator-green-182.webp",
      "thumbnail": "",
      "thumbnailAsset": ""
    },
    {
      "value": "GREEN-195",
      "display": "GREEN 195",
      "cartValue": "GREEN 195",
      "code": "",
      "priceDeltaCents": 0,
      "image": "",
      "imageAsset": "solea-memory-ring-configurator-green-195.webp",
      "thumbnail": "",
      "thumbnailAsset": ""
    },
    {
      "value": "GREEN-196",
      "display": "GREEN 196",
      "cartValue": "GREEN 196",
      "code": "",
      "priceDeltaCents": 0,
      "image": "",
      "imageAsset": "solea-memory-ring-configurator-green-196.webp",
      "thumbnail": "",
      "thumbnailAsset": ""
    },
    {
      "value": "GREEN-208",
      "display": "GREEN 208",
      "cartValue": "GREEN 208",
      "code": "",
      "priceDeltaCents": 0,
      "image": "",
      "imageAsset": "solea-memory-ring-configurator-green-208.webp",
      "thumbnail": "",
      "thumbnailAsset": ""
    },
    {
      "value": "GREEN-212",
      "display": "GREEN 212",
      "cartValue": "GREEN 212",
      "code": "",
      "priceDeltaCents": 0,
      "image": "",
      "imageAsset": "solea-memory-ring-configurator-green-212.webp",
      "thumbnail": "",
      "thumbnailAsset": ""
    },
    {
      "value": "GREEN-214",
      "display": "GREEN 214",
      "cartValue": "GREEN 214",
      "code": "",
      "priceDeltaCents": 0,
      "image": "",
      "imageAsset": "solea-memory-ring-configurator-green-214.webp",
      "thumbnail": "",
      "thumbnailAsset": ""
    },
    {
      "value": "GREEN-217",
      "display": "GREEN 217",
      "cartValue": "GREEN 217",
      "code": "",
      "priceDeltaCents": 0,
      "image": "",
      "imageAsset": "solea-memory-ring-configurator-green-217.webp",
      "thumbnail": "",
      "thumbnailAsset": ""
    },
    {
      "value": "GREEN-23",
      "display": "GREEN 23",
      "cartValue": "GREEN 23",
      "code": "",
      "priceDeltaCents": 0,
      "image": "",
      "imageAsset": "solea-memory-ring-configurator-green-23.webp",
      "thumbnail": "",
      "thumbnailAsset": ""
    },
    {
      "value": "GREEN-24",
      "display": "GREEN 24",
      "cartValue": "GREEN 24",
      "code": "",
      "priceDeltaCents": 0,
      "image": "",
      "imageAsset": "solea-memory-ring-configurator-green-24.webp",
      "thumbnail": "",
      "thumbnailAsset": ""
    },
    {
      "value": "GREEN-27",
      "display": "GREEN 27",
      "cartValue": "GREEN 27",
      "code": "",
      "priceDeltaCents": 0,
      "image": "",
      "imageAsset": "solea-memory-ring-configurator-green-27.webp",
      "thumbnail": "",
      "thumbnailAsset": ""
    },
    {
      "value": "GREEN-36",
      "display": "GREEN 36",
      "cartValue": "GREEN 36",
      "code": "",
      "priceDeltaCents": 0,
      "image": "",
      "imageAsset": "solea-memory-ring-configurator-green-36.webp",
      "thumbnail": "",
      "thumbnailAsset": ""
    },
    {
      "value": "GREEN-37",
      "display": "GREEN 37",
      "cartValue": "GREEN 37",
      "code": "",
      "priceDeltaCents": 0,
      "image": "",
      "imageAsset": "solea-memory-ring-configurator-green-37.webp",
      "thumbnail": "",
      "thumbnailAsset": ""
    },
    {
      "value": "GREEN-43",
      "display": "GREEN 43",
      "cartValue": "GREEN 43",
      "code": "",
      "priceDeltaCents": 0,
      "image": "",
      "imageAsset": "solea-memory-ring-configurator-green-43.webp",
      "thumbnail": "",
      "thumbnailAsset": ""
    },
    {
      "value": "GREEN-5",
      "display": "GREEN 5",
      "cartValue": "GREEN 5",
      "code": "",
      "priceDeltaCents": 0,
      "image": "",
      "imageAsset": "solea-memory-ring-configurator-green-5.webp",
      "thumbnail": "",
      "thumbnailAsset": ""
    },
    {
      "value": "GREEN-50",
      "display": "GREEN 50",
      "cartValue": "GREEN 50",
      "code": "",
      "priceDeltaCents": 0,
      "image": "",
      "imageAsset": "solea-memory-ring-configurator-green-50.webp",
      "thumbnail": "",
      "thumbnailAsset": ""
    },
    {
      "value": "GREEN-51",
      "display": "GREEN 51",
      "cartValue": "GREEN 51",
      "code": "",
      "priceDeltaCents": 0,
      "image": "",
      "imageAsset": "solea-memory-ring-configurator-green-51.webp",
      "thumbnail": "",
      "thumbnailAsset": ""
    },
    {
      "value": "GREEN-54",
      "display": "GREEN 54",
      "cartValue": "GREEN 54",
      "code": "",
      "priceDeltaCents": 0,
      "image": "",
      "imageAsset": "solea-memory-ring-configurator-green-54.webp",
      "thumbnail": "",
      "thumbnailAsset": ""
    },
    {
      "value": "GREEN-55",
      "display": "GREEN 55",
      "cartValue": "GREEN 55",
      "code": "",
      "priceDeltaCents": 0,
      "image": "",
      "imageAsset": "solea-memory-ring-configurator-green-55.webp",
      "thumbnail": "",
      "thumbnailAsset": ""
    },
    {
      "value": "GREEN-65",
      "display": "GREEN 65",
      "cartValue": "GREEN 65",
      "code": "",
      "priceDeltaCents": 0,
      "image": "",
      "imageAsset": "solea-memory-ring-configurator-green-65.webp",
      "thumbnail": "",
      "thumbnailAsset": ""
    },
    {
      "value": "GREEN-8",
      "display": "GREEN 8",
      "cartValue": "GREEN 8",
      "code": "",
      "priceDeltaCents": 0,
      "image": "",
      "imageAsset": "solea-memory-ring-configurator-green-8.webp",
      "thumbnail": "",
      "thumbnailAsset": ""
    },
    {
      "value": "GREEN-81",
      "display": "GREEN 81",
      "cartValue": "GREEN 81",
      "code": "",
      "priceDeltaCents": 0,
      "image": "",
      "imageAsset": "solea-memory-ring-configurator-green-81.webp",
      "thumbnail": "",
      "thumbnailAsset": ""
    },
    {
      "value": "GREEN-94",
      "display": "GREEN 94",
      "cartValue": "GREEN 94",
      "code": "",
      "priceDeltaCents": 0,
      "image": "",
      "imageAsset": "solea-memory-ring-configurator-green-94.webp",
      "thumbnail": "",
      "thumbnailAsset": ""
    },
    {
      "value": "BLUE-102",
      "display": "BLUE 102",
      "cartValue": "BLUE 102",
      "code": "",
      "priceDeltaCents": 0,
      "image": "",
      "imageAsset": "solea-memory-ring-configurator-blue-102.webp",
      "thumbnail": "",
      "thumbnailAsset": ""
    },
    {
      "value": "BLUE-103",
      "display": "BLUE 103",
      "cartValue": "BLUE 103",
      "code": "",
      "priceDeltaCents": 0,
      "image": "",
      "imageAsset": "solea-memory-ring-configurator-blue-103.webp",
      "thumbnail": "",
      "thumbnailAsset": ""
    },
    {
      "value": "BLUE-104",
      "display": "BLUE 104",
      "cartValue": "BLUE 104",
      "code": "",
      "priceDeltaCents": 0,
      "image": "",
      "imageAsset": "solea-memory-ring-configurator-blue-104.webp",
      "thumbnail": "",
      "thumbnailAsset": ""
    },
    {
      "value": "BLUE-110",
      "display": "BLUE 110",
      "cartValue": "BLUE 110",
      "code": "",
      "priceDeltaCents": 0,
      "image": "",
      "imageAsset": "solea-memory-ring-configurator-blue-110.webp",
      "thumbnail": "",
      "thumbnailAsset": ""
    },
    {
      "value": "BLUE-124",
      "display": "BLUE 124",
      "cartValue": "BLUE 124",
      "code": "",
      "priceDeltaCents": 0,
      "image": "",
      "imageAsset": "solea-memory-ring-configurator-blue-124.webp",
      "thumbnail": "",
      "thumbnailAsset": ""
    },
    {
      "value": "BLUE-145",
      "display": "BLUE 145",
      "cartValue": "BLUE 145",
      "code": "",
      "priceDeltaCents": 0,
      "image": "",
      "imageAsset": "solea-memory-ring-configurator-blue-145.webp",
      "thumbnail": "",
      "thumbnailAsset": ""
    },
    {
      "value": "BLUE-146",
      "display": "BLUE 146",
      "cartValue": "BLUE 146",
      "code": "",
      "priceDeltaCents": 0,
      "image": "",
      "imageAsset": "solea-memory-ring-configurator-blue-146.webp",
      "thumbnail": "",
      "thumbnailAsset": ""
    },
    {
      "value": "BLUE-147",
      "display": "BLUE 147",
      "cartValue": "BLUE 147",
      "code": "",
      "priceDeltaCents": 0,
      "image": "",
      "imageAsset": "solea-memory-ring-configurator-blue-147.webp",
      "thumbnail": "",
      "thumbnailAsset": ""
    },
    {
      "value": "BLUE-15",
      "display": "BLUE 15",
      "cartValue": "BLUE 15",
      "code": "",
      "priceDeltaCents": 0,
      "image": "",
      "imageAsset": "solea-memory-ring-configurator-blue-15.webp",
      "thumbnail": "",
      "thumbnailAsset": ""
    },
    {
      "value": "BLUE-150",
      "display": "BLUE 150",
      "cartValue": "BLUE 150",
      "code": "",
      "priceDeltaCents": 0,
      "image": "",
      "imageAsset": "solea-memory-ring-configurator-blue-150.webp",
      "thumbnail": "",
      "thumbnailAsset": ""
    },
    {
      "value": "BLUE-152",
      "display": "BLUE 152",
      "cartValue": "BLUE 152",
      "code": "",
      "priceDeltaCents": 0,
      "image": "",
      "imageAsset": "solea-memory-ring-configurator-blue-152.webp",
      "thumbnail": "",
      "thumbnailAsset": ""
    },
    {
      "value": "BLUE-153",
      "display": "BLUE 153",
      "cartValue": "BLUE 153",
      "code": "",
      "priceDeltaCents": 0,
      "image": "",
      "imageAsset": "solea-memory-ring-configurator-blue-153.webp",
      "thumbnail": "",
      "thumbnailAsset": ""
    },
    {
      "value": "BLUE-167",
      "display": "BLUE 167",
      "cartValue": "BLUE 167",
      "code": "",
      "priceDeltaCents": 0,
      "image": "",
      "imageAsset": "solea-memory-ring-configurator-blue-167.webp",
      "thumbnail": "",
      "thumbnailAsset": ""
    },
    {
      "value": "BLUE-193",
      "display": "BLUE 193",
      "cartValue": "BLUE 193",
      "code": "",
      "priceDeltaCents": 0,
      "image": "",
      "imageAsset": "solea-memory-ring-configurator-blue-193.webp",
      "thumbnail": "",
      "thumbnailAsset": ""
    },
    {
      "value": "BLUE-197",
      "display": "BLUE 197",
      "cartValue": "BLUE 197",
      "code": "",
      "priceDeltaCents": 0,
      "image": "",
      "imageAsset": "solea-memory-ring-configurator-blue-197.webp",
      "thumbnail": "",
      "thumbnailAsset": ""
    },
    {
      "value": "BLUE-200",
      "display": "BLUE 200",
      "cartValue": "BLUE 200",
      "code": "",
      "priceDeltaCents": 0,
      "image": "",
      "imageAsset": "solea-memory-ring-configurator-blue-200.webp",
      "thumbnail": "",
      "thumbnailAsset": ""
    },
    {
      "value": "BLUE-201",
      "display": "BLUE 201",
      "cartValue": "BLUE 201",
      "code": "",
      "priceDeltaCents": 0,
      "image": "",
      "imageAsset": "solea-memory-ring-configurator-blue-201.webp",
      "thumbnail": "",
      "thumbnailAsset": ""
    },
    {
      "value": "BLUE-21",
      "display": "BLUE 21",
      "cartValue": "BLUE 21",
      "code": "",
      "priceDeltaCents": 0,
      "image": "",
      "imageAsset": "solea-memory-ring-configurator-blue-21.webp",
      "thumbnail": "",
      "thumbnailAsset": ""
    },
    {
      "value": "BLUE-210",
      "display": "BLUE 210",
      "cartValue": "BLUE 210",
      "code": "",
      "priceDeltaCents": 0,
      "image": "",
      "imageAsset": "solea-memory-ring-configurator-blue-210.webp",
      "thumbnail": "",
      "thumbnailAsset": ""
    },
    {
      "value": "BLUE-215",
      "display": "BLUE 215",
      "cartValue": "BLUE 215",
      "code": "",
      "priceDeltaCents": 0,
      "image": "",
      "imageAsset": "solea-memory-ring-configurator-blue-215.webp",
      "thumbnail": "",
      "thumbnailAsset": ""
    },
    {
      "value": "BLUE-216",
      "display": "BLUE 216",
      "cartValue": "BLUE 216",
      "code": "",
      "priceDeltaCents": 0,
      "image": "",
      "imageAsset": "solea-memory-ring-configurator-blue-216.webp",
      "thumbnail": "",
      "thumbnailAsset": ""
    },
    {
      "value": "BLUE-22",
      "display": "BLUE 22",
      "cartValue": "BLUE 22",
      "code": "",
      "priceDeltaCents": 0,
      "image": "",
      "imageAsset": "solea-memory-ring-configurator-blue-22.webp",
      "thumbnail": "",
      "thumbnailAsset": ""
    },
    {
      "value": "BLUE-28",
      "display": "BLUE 28",
      "cartValue": "BLUE 28",
      "code": "",
      "priceDeltaCents": 0,
      "image": "",
      "imageAsset": "solea-memory-ring-configurator-blue-28.webp",
      "thumbnail": "",
      "thumbnailAsset": ""
    },
    {
      "value": "BLUE-29",
      "display": "BLUE 29",
      "cartValue": "BLUE 29",
      "code": "",
      "priceDeltaCents": 0,
      "image": "",
      "imageAsset": "solea-memory-ring-configurator-blue-29.webp",
      "thumbnail": "",
      "thumbnailAsset": ""
    },
    {
      "value": "BLUE-30",
      "display": "BLUE 30",
      "cartValue": "BLUE 30",
      "code": "",
      "priceDeltaCents": 0,
      "image": "",
      "imageAsset": "solea-memory-ring-configurator-blue-30.webp",
      "thumbnail": "",
      "thumbnailAsset": ""
    },
    {
      "value": "BLUE-31",
      "display": "BLUE 31",
      "cartValue": "BLUE 31",
      "code": "",
      "priceDeltaCents": 0,
      "image": "",
      "imageAsset": "solea-memory-ring-configurator-blue-31.webp",
      "thumbnail": "",
      "thumbnailAsset": ""
    },
    {
      "value": "BLUE-32",
      "display": "BLUE 32",
      "cartValue": "BLUE 32",
      "code": "",
      "priceDeltaCents": 0,
      "image": "",
      "imageAsset": "solea-memory-ring-configurator-blue-32.webp",
      "thumbnail": "",
      "thumbnailAsset": ""
    },
    {
      "value": "BLUE-33",
      "display": "BLUE 33",
      "cartValue": "BLUE 33",
      "code": "",
      "priceDeltaCents": 0,
      "image": "",
      "imageAsset": "solea-memory-ring-configurator-blue-33.webp",
      "thumbnail": "",
      "thumbnailAsset": ""
    },
    {
      "value": "BLUE-4",
      "display": "BLUE 4",
      "cartValue": "BLUE 4",
      "code": "",
      "priceDeltaCents": 0,
      "image": "",
      "imageAsset": "solea-memory-ring-configurator-blue-4.webp",
      "thumbnail": "",
      "thumbnailAsset": ""
    },
    {
      "value": "BLUE-57",
      "display": "BLUE 57",
      "cartValue": "BLUE 57",
      "code": "",
      "priceDeltaCents": 0,
      "image": "",
      "imageAsset": "solea-memory-ring-configurator-blue-57.webp",
      "thumbnail": "",
      "thumbnailAsset": ""
    },
    {
      "value": "BLUE-58",
      "display": "BLUE 58",
      "cartValue": "BLUE 58",
      "code": "",
      "priceDeltaCents": 0,
      "image": "",
      "imageAsset": "solea-memory-ring-configurator-blue-58.webp",
      "thumbnail": "",
      "thumbnailAsset": ""
    },
    {
      "value": "BLUE-59",
      "display": "BLUE 59",
      "cartValue": "BLUE 59",
      "code": "",
      "priceDeltaCents": 0,
      "image": "",
      "imageAsset": "solea-memory-ring-configurator-blue-59.webp",
      "thumbnail": "",
      "thumbnailAsset": ""
    },
    {
      "value": "BLUE-6",
      "display": "BLUE 6",
      "cartValue": "BLUE 6",
      "code": "",
      "priceDeltaCents": 0,
      "image": "",
      "imageAsset": "solea-memory-ring-configurator-blue-6.webp",
      "thumbnail": "",
      "thumbnailAsset": ""
    },
    {
      "value": "BLUE-60",
      "display": "BLUE 60",
      "cartValue": "BLUE 60",
      "code": "",
      "priceDeltaCents": 0,
      "image": "",
      "imageAsset": "solea-memory-ring-configurator-blue-60.webp",
      "thumbnail": "",
      "thumbnailAsset": ""
    },
    {
      "value": "BLUE-62",
      "display": "BLUE 62",
      "cartValue": "BLUE 62",
      "code": "",
      "priceDeltaCents": 0,
      "image": "",
      "imageAsset": "solea-memory-ring-configurator-blue-62.webp",
      "thumbnail": "",
      "thumbnailAsset": ""
    },
    {
      "value": "BLUE-64",
      "display": "BLUE 64",
      "cartValue": "BLUE 64",
      "code": "",
      "priceDeltaCents": 0,
      "image": "",
      "imageAsset": "solea-memory-ring-configurator-blue-64.webp",
      "thumbnail": "",
      "thumbnailAsset": ""
    },
    {
      "value": "BLUE-7",
      "display": "BLUE 7",
      "cartValue": "BLUE 7",
      "code": "",
      "priceDeltaCents": 0,
      "image": "",
      "imageAsset": "solea-memory-ring-configurator-blue-7.webp",
      "thumbnail": "",
      "thumbnailAsset": ""
    },
    {
      "value": "BLUE-71",
      "display": "BLUE 71",
      "cartValue": "BLUE 71",
      "code": "",
      "priceDeltaCents": 0,
      "image": "",
      "imageAsset": "solea-memory-ring-configurator-blue-71.webp",
      "thumbnail": "",
      "thumbnailAsset": ""
    },
    {
      "value": "BLUE-73",
      "display": "BLUE 73",
      "cartValue": "BLUE 73",
      "code": "",
      "priceDeltaCents": 0,
      "image": "",
      "imageAsset": "solea-memory-ring-configurator-blue-73.webp",
      "thumbnail": "",
      "thumbnailAsset": ""
    },
    {
      "value": "BLUE-76",
      "display": "BLUE 76",
      "cartValue": "BLUE 76",
      "code": "",
      "priceDeltaCents": 0,
      "image": "",
      "imageAsset": "solea-memory-ring-configurator-blue-76.webp",
      "thumbnail": "",
      "thumbnailAsset": ""
    },
    {
      "value": "BLUE-78",
      "display": "BLUE 78",
      "cartValue": "BLUE 78",
      "code": "",
      "priceDeltaCents": 0,
      "image": "",
      "imageAsset": "solea-memory-ring-configurator-blue-78.webp",
      "thumbnail": "",
      "thumbnailAsset": ""
    },
    {
      "value": "BLUE-79",
      "display": "BLUE 79",
      "cartValue": "BLUE 79",
      "code": "",
      "priceDeltaCents": 0,
      "image": "",
      "imageAsset": "solea-memory-ring-configurator-blue-79.webp",
      "thumbnail": "",
      "thumbnailAsset": ""
    },
    {
      "value": "BLUE-83",
      "display": "BLUE 83",
      "cartValue": "BLUE 83",
      "code": "",
      "priceDeltaCents": 0,
      "image": "",
      "imageAsset": "solea-memory-ring-configurator-blue-83.webp",
      "thumbnail": "",
      "thumbnailAsset": ""
    },
    {
      "value": "BLUE-9",
      "display": "BLUE 9",
      "cartValue": "BLUE 9",
      "code": "",
      "priceDeltaCents": 0,
      "image": "",
      "imageAsset": "solea-memory-ring-configurator-blue-9.webp",
      "thumbnail": "",
      "thumbnailAsset": ""
    },
    {
      "value": "BLUE-90",
      "display": "BLUE 90",
      "cartValue": "BLUE 90",
      "code": "",
      "priceDeltaCents": 0,
      "image": "",
      "imageAsset": "solea-memory-ring-configurator-blue-90.webp",
      "thumbnail": "",
      "thumbnailAsset": ""
    },
    {
      "value": "BLUE-92",
      "display": "BLUE 92",
      "cartValue": "BLUE 92",
      "code": "",
      "priceDeltaCents": 0,
      "image": "",
      "imageAsset": "solea-memory-ring-configurator-blue-92.webp",
      "thumbnail": "",
      "thumbnailAsset": ""
    },
    {
      "value": "BLUE-93",
      "display": "BLUE 93",
      "cartValue": "BLUE 93",
      "code": "",
      "priceDeltaCents": 0,
      "image": "",
      "imageAsset": "solea-memory-ring-configurator-blue-93.webp",
      "thumbnail": "",
      "thumbnailAsset": ""
    },
    {
      "value": "BLUE-95",
      "display": "BLUE 95",
      "cartValue": "BLUE 95",
      "code": "",
      "priceDeltaCents": 0,
      "image": "",
      "imageAsset": "solea-memory-ring-configurator-blue-95.webp",
      "thumbnail": "",
      "thumbnailAsset": ""
    },
    {
      "value": "BLUE-97",
      "display": "BLUE 97",
      "cartValue": "BLUE 97",
      "code": "",
      "priceDeltaCents": 0,
      "image": "",
      "imageAsset": "solea-memory-ring-configurator-blue-97.webp",
      "thumbnail": "",
      "thumbnailAsset": ""
    },
    {
      "value": "BLUE-99",
      "display": "BLUE 99",
      "cartValue": "BLUE 99",
      "code": "",
      "priceDeltaCents": 0,
      "image": "",
      "imageAsset": "solea-memory-ring-configurator-blue-99.webp",
      "thumbnail": "",
      "thumbnailAsset": ""
    },
    {
      "value": "VIOLET-100",
      "display": "VIOLET 100",
      "cartValue": "VIOLET 100",
      "code": "",
      "priceDeltaCents": 0,
      "image": "",
      "imageAsset": "solea-memory-ring-configurator-violet-100.webp",
      "thumbnail": "",
      "thumbnailAsset": ""
    },
    {
      "value": "VIOLET-137",
      "display": "VIOLET 137",
      "cartValue": "VIOLET 137",
      "code": "",
      "priceDeltaCents": 0,
      "image": "",
      "imageAsset": "solea-memory-ring-configurator-violet-137.webp",
      "thumbnail": "",
      "thumbnailAsset": ""
    },
    {
      "value": "VIOLET-181",
      "display": "VIOLET 181",
      "cartValue": "VIOLET 181",
      "code": "",
      "priceDeltaCents": 0,
      "image": "",
      "imageAsset": "solea-memory-ring-configurator-violet-181.webp",
      "thumbnail": "",
      "thumbnailAsset": ""
    },
    {
      "value": "VIOLET-19",
      "display": "VIOLET 19",
      "cartValue": "VIOLET 19",
      "code": "",
      "priceDeltaCents": 0,
      "image": "",
      "imageAsset": "solea-memory-ring-configurator-violet-19.webp",
      "thumbnail": "",
      "thumbnailAsset": ""
    },
    {
      "value": "VIOLET-2",
      "display": "VIOLET 2",
      "cartValue": "VIOLET 2",
      "code": "",
      "priceDeltaCents": 0,
      "image": "",
      "imageAsset": "solea-memory-ring-configurator-violet-2.webp",
      "thumbnail": "",
      "thumbnailAsset": ""
    },
    {
      "value": "VIOLET-209",
      "display": "VIOLET 209",
      "cartValue": "VIOLET 209",
      "code": "",
      "priceDeltaCents": 0,
      "image": "",
      "imageAsset": "solea-memory-ring-configurator-violet-209.webp",
      "thumbnail": "",
      "thumbnailAsset": ""
    },
    {
      "value": "VIOLET-26",
      "display": "VIOLET 26",
      "cartValue": "VIOLET 26",
      "code": "",
      "priceDeltaCents": 0,
      "image": "",
      "imageAsset": "solea-memory-ring-configurator-violet-26.webp",
      "thumbnail": "",
      "thumbnailAsset": ""
    },
    {
      "value": "VIOLET-49",
      "display": "VIOLET 49",
      "cartValue": "VIOLET 49",
      "code": "",
      "priceDeltaCents": 0,
      "image": "",
      "imageAsset": "solea-memory-ring-configurator-violet-49.webp",
      "thumbnail": "",
      "thumbnailAsset": ""
    },
    {
      "value": "VIOLET-61",
      "display": "VIOLET 61",
      "cartValue": "VIOLET 61",
      "code": "",
      "priceDeltaCents": 0,
      "image": "",
      "imageAsset": "solea-memory-ring-configurator-violet-61.webp",
      "thumbnail": "",
      "thumbnailAsset": ""
    },
    {
      "value": "VIOLET-74",
      "display": "VIOLET 74",
      "cartValue": "VIOLET 74",
      "code": "",
      "priceDeltaCents": 0,
      "image": "",
      "imageAsset": "solea-memory-ring-configurator-violet-74.webp",
      "thumbnail": "",
      "thumbnailAsset": ""
    },
    {
      "value": "VIOLET-75",
      "display": "VIOLET 75",
      "cartValue": "VIOLET 75",
      "code": "",
      "priceDeltaCents": 0,
      "image": "",
      "imageAsset": "solea-memory-ring-configurator-violet-75.webp",
      "thumbnail": "",
      "thumbnailAsset": ""
    },
    {
      "value": "VIOLET-77",
      "display": "VIOLET 77",
      "cartValue": "VIOLET 77",
      "code": "",
      "priceDeltaCents": 0,
      "image": "",
      "imageAsset": "solea-memory-ring-configurator-violet-77.webp",
      "thumbnail": "",
      "thumbnailAsset": ""
    },
    {
      "value": "VIOLET-86",
      "display": "VIOLET 86",
      "cartValue": "VIOLET 86",
      "code": "",
      "priceDeltaCents": 0,
      "image": "",
      "imageAsset": "solea-memory-ring-configurator-violet-86.webp",
      "thumbnail": "",
      "thumbnailAsset": ""
    },
    {
      "value": "VIOLET-88",
      "display": "VIOLET 88",
      "cartValue": "VIOLET 88",
      "code": "",
      "priceDeltaCents": 0,
      "image": "",
      "imageAsset": "solea-memory-ring-configurator-violet-88.webp",
      "thumbnail": "",
      "thumbnailAsset": ""
    },
    {
      "value": "PINK-1",
      "display": "PINK 1",
      "cartValue": "PINK 1",
      "code": "",
      "priceDeltaCents": 0,
      "image": "",
      "imageAsset": "solea-memory-ring-configurator-pink-1.webp",
      "thumbnail": "",
      "thumbnailAsset": ""
    },
    {
      "value": "PINK-122",
      "display": "PINK 122",
      "cartValue": "PINK 122",
      "code": "",
      "priceDeltaCents": 0,
      "image": "",
      "imageAsset": "solea-memory-ring-configurator-pink-122.webp",
      "thumbnail": "",
      "thumbnailAsset": ""
    },
    {
      "value": "PINK-140",
      "display": "PINK 140",
      "cartValue": "PINK 140",
      "code": "",
      "priceDeltaCents": 0,
      "image": "",
      "imageAsset": "solea-memory-ring-configurator-pink-140.webp",
      "thumbnail": "",
      "thumbnailAsset": ""
    },
    {
      "value": "PINK-141",
      "display": "PINK 141",
      "cartValue": "PINK 141",
      "code": "",
      "priceDeltaCents": 0,
      "image": "",
      "imageAsset": "solea-memory-ring-configurator-pink-141.webp",
      "thumbnail": "",
      "thumbnailAsset": ""
    },
    {
      "value": "PINK-143",
      "display": "PINK 143",
      "cartValue": "PINK 143",
      "code": "",
      "priceDeltaCents": 0,
      "image": "",
      "imageAsset": "solea-memory-ring-configurator-pink-143.webp",
      "thumbnail": "",
      "thumbnailAsset": ""
    },
    {
      "value": "PINK-156",
      "display": "PINK 156",
      "cartValue": "PINK 156",
      "code": "",
      "priceDeltaCents": 0,
      "image": "",
      "imageAsset": "solea-memory-ring-configurator-pink-156.webp",
      "thumbnail": "",
      "thumbnailAsset": ""
    },
    {
      "value": "PINK-45",
      "display": "PINK 45",
      "cartValue": "PINK 45",
      "code": "",
      "priceDeltaCents": 0,
      "image": "",
      "imageAsset": "solea-memory-ring-configurator-pink-45.webp",
      "thumbnail": "",
      "thumbnailAsset": ""
    },
    {
      "value": "PINK-82",
      "display": "PINK 82",
      "cartValue": "PINK 82",
      "code": "",
      "priceDeltaCents": 0,
      "image": "",
      "imageAsset": "solea-memory-ring-configurator-pink-82.webp",
      "thumbnail": "",
      "thumbnailAsset": ""
    },
    {
      "value": "DARK-105",
      "display": "DARK 105",
      "cartValue": "DARK 105",
      "code": "",
      "priceDeltaCents": 0,
      "image": "",
      "imageAsset": "solea-memory-ring-configurator-dark-105.webp",
      "thumbnail": "",
      "thumbnailAsset": ""
    },
    {
      "value": "DARK-111",
      "display": "DARK 111",
      "cartValue": "DARK 111",
      "code": "",
      "priceDeltaCents": 0,
      "image": "",
      "imageAsset": "solea-memory-ring-configurator-dark-111.webp",
      "thumbnail": "",
      "thumbnailAsset": ""
    },
    {
      "value": "DARK-112",
      "display": "DARK 112",
      "cartValue": "DARK 112",
      "code": "",
      "priceDeltaCents": 0,
      "image": "",
      "imageAsset": "solea-memory-ring-configurator-dark-112.webp",
      "thumbnail": "",
      "thumbnailAsset": ""
    },
    {
      "value": "DARK-115",
      "display": "DARK 115",
      "cartValue": "DARK 115",
      "code": "",
      "priceDeltaCents": 0,
      "image": "",
      "imageAsset": "solea-memory-ring-configurator-dark-115.webp",
      "thumbnail": "",
      "thumbnailAsset": ""
    },
    {
      "value": "DARK-117",
      "display": "DARK 117",
      "cartValue": "DARK 117",
      "code": "",
      "priceDeltaCents": 0,
      "image": "",
      "imageAsset": "solea-memory-ring-configurator-dark-117.webp",
      "thumbnail": "",
      "thumbnailAsset": ""
    },
    {
      "value": "DARK-159",
      "display": "DARK 159",
      "cartValue": "DARK 159",
      "code": "",
      "priceDeltaCents": 0,
      "image": "",
      "imageAsset": "solea-memory-ring-configurator-dark-159.webp",
      "thumbnail": "",
      "thumbnailAsset": ""
    },
    {
      "value": "DARK-18",
      "display": "DARK 18",
      "cartValue": "DARK 18",
      "code": "",
      "priceDeltaCents": 0,
      "image": "",
      "imageAsset": "solea-memory-ring-configurator-dark-18.webp",
      "thumbnail": "",
      "thumbnailAsset": ""
    },
    {
      "value": "DARK-20",
      "display": "DARK 20",
      "cartValue": "DARK 20",
      "code": "",
      "priceDeltaCents": 0,
      "image": "",
      "imageAsset": "solea-memory-ring-configurator-dark-20.webp",
      "thumbnail": "",
      "thumbnailAsset": ""
    },
    {
      "value": "DARK-206",
      "display": "DARK 206",
      "cartValue": "DARK 206",
      "code": "",
      "priceDeltaCents": 0,
      "image": "",
      "imageAsset": "solea-memory-ring-configurator-dark-206.webp",
      "thumbnail": "",
      "thumbnailAsset": ""
    },
    {
      "value": "DARK-41",
      "display": "DARK 41",
      "cartValue": "DARK 41",
      "code": "",
      "priceDeltaCents": 0,
      "image": "",
      "imageAsset": "solea-memory-ring-configurator-dark-41.webp",
      "thumbnail": "",
      "thumbnailAsset": ""
    },
    {
      "value": "DARK-46",
      "display": "DARK 46",
      "cartValue": "DARK 46",
      "code": "",
      "priceDeltaCents": 0,
      "image": "",
      "imageAsset": "solea-memory-ring-configurator-dark-46.webp",
      "thumbnail": "",
      "thumbnailAsset": ""
    },
    {
      "value": "DARK-48",
      "display": "DARK 48",
      "cartValue": "DARK 48",
      "code": "",
      "priceDeltaCents": 0,
      "image": "",
      "imageAsset": "solea-memory-ring-configurator-dark-48.webp",
      "thumbnail": "",
      "thumbnailAsset": ""
    },
    {
      "value": "DARK-66",
      "display": "DARK 66",
      "cartValue": "DARK 66",
      "code": "",
      "priceDeltaCents": 0,
      "image": "",
      "imageAsset": "solea-memory-ring-configurator-dark-66.webp",
      "thumbnail": "",
      "thumbnailAsset": ""
    },
    {
      "value": "DARK-67",
      "display": "DARK 67",
      "cartValue": "DARK 67",
      "code": "",
      "priceDeltaCents": 0,
      "image": "",
      "imageAsset": "solea-memory-ring-configurator-dark-67.webp",
      "thumbnail": "",
      "thumbnailAsset": ""
    },
    {
      "value": "DARK-91",
      "display": "DARK 91",
      "cartValue": "DARK 91",
      "code": "",
      "priceDeltaCents": 0,
      "image": "",
      "imageAsset": "solea-memory-ring-configurator-dark-91.webp",
      "thumbnail": "",
      "thumbnailAsset": ""
    },
    {
      "value": "DARK-98",
      "display": "DARK 98",
      "cartValue": "DARK 98",
      "code": "",
      "priceDeltaCents": 0,
      "image": "",
      "imageAsset": "solea-memory-ring-configurator-dark-98.webp",
      "thumbnail": "",
      "thumbnailAsset": ""
    },
    {
      "value": "LIGHT-v2-129",
      "display": "LIGHT v2 129",
      "cartValue": "LIGHT v2 129",
      "code": "",
      "priceDeltaCents": 0,
      "image": "",
      "imageAsset": "solea-memory-ring-configurator-light-v2-129.webp",
      "thumbnail": "",
      "thumbnailAsset": ""
    },
    {
      "value": "LIGHT-v2-131",
      "display": "LIGHT v2 131",
      "cartValue": "LIGHT v2 131",
      "code": "",
      "priceDeltaCents": 0,
      "image": "",
      "imageAsset": "solea-memory-ring-configurator-light-v2-131.webp",
      "thumbnail": "",
      "thumbnailAsset": ""
    },
    {
      "value": "LIGHT-v2-134",
      "display": "LIGHT v2 134",
      "cartValue": "LIGHT v2 134",
      "code": "",
      "priceDeltaCents": 0,
      "image": "",
      "imageAsset": "solea-memory-ring-configurator-light-v2-134.webp",
      "thumbnail": "",
      "thumbnailAsset": ""
    },
    {
      "value": "LIGHT-v2-138",
      "display": "LIGHT v2 138",
      "cartValue": "LIGHT v2 138",
      "code": "",
      "priceDeltaCents": 0,
      "image": "",
      "imageAsset": "solea-memory-ring-configurator-light-v2-138.webp",
      "thumbnail": "",
      "thumbnailAsset": ""
    },
    {
      "value": "LIGHT-v2-168",
      "display": "LIGHT v2 168",
      "cartValue": "LIGHT v2 168",
      "code": "",
      "priceDeltaCents": 0,
      "image": "",
      "imageAsset": "solea-memory-ring-configurator-light-v2-168.webp",
      "thumbnail": "",
      "thumbnailAsset": ""
    },
    {
      "value": "LIGHT-v2-17",
      "display": "LIGHT v2 17",
      "cartValue": "LIGHT v2 17",
      "code": "",
      "priceDeltaCents": 0,
      "image": "",
      "imageAsset": "solea-memory-ring-configurator-light-v2-17.webp",
      "thumbnail": "",
      "thumbnailAsset": ""
    },
    {
      "value": "LIGHT-v2-175",
      "display": "LIGHT v2 175",
      "cartValue": "LIGHT v2 175",
      "code": "",
      "priceDeltaCents": 0,
      "image": "",
      "imageAsset": "solea-memory-ring-configurator-light-v2-175.webp",
      "thumbnail": "",
      "thumbnailAsset": ""
    },
    {
      "value": "LIGHT-v2-176",
      "display": "LIGHT v2 176",
      "cartValue": "LIGHT v2 176",
      "code": "",
      "priceDeltaCents": 0,
      "image": "",
      "imageAsset": "solea-memory-ring-configurator-light-v2-176.webp",
      "thumbnail": "",
      "thumbnailAsset": ""
    },
    {
      "value": "LIGHT-v2-180",
      "display": "LIGHT v2 180",
      "cartValue": "LIGHT v2 180",
      "code": "",
      "priceDeltaCents": 0,
      "image": "",
      "imageAsset": "solea-memory-ring-configurator-light-v2-180.webp",
      "thumbnail": "",
      "thumbnailAsset": ""
    },
    {
      "value": "LIGHT-v3-185",
      "display": "LIGHT v3 185",
      "cartValue": "LIGHT v3 185",
      "code": "",
      "priceDeltaCents": 0,
      "image": "",
      "imageAsset": "solea-memory-ring-configurator-light-v3-185.webp",
      "thumbnail": "",
      "thumbnailAsset": ""
    },
    {
      "value": "LIGHT-v2-187",
      "display": "LIGHT v2 187",
      "cartValue": "LIGHT v2 187",
      "code": "",
      "priceDeltaCents": 0,
      "image": "",
      "imageAsset": "solea-memory-ring-configurator-light-v2-187.webp",
      "thumbnail": "",
      "thumbnailAsset": ""
    },
    {
      "value": "LIGHT-v2-189",
      "display": "LIGHT v2 189",
      "cartValue": "LIGHT v2 189",
      "code": "",
      "priceDeltaCents": 0,
      "image": "",
      "imageAsset": "solea-memory-ring-configurator-light-v2-189.webp",
      "thumbnail": "",
      "thumbnailAsset": ""
    },
    {
      "value": "LIGHT-v2-192",
      "display": "LIGHT v2 192",
      "cartValue": "LIGHT v2 192",
      "code": "",
      "priceDeltaCents": 0,
      "image": "",
      "imageAsset": "solea-memory-ring-configurator-light-v2-192.webp",
      "thumbnail": "",
      "thumbnailAsset": ""
    },
    {
      "value": "LIGHT-v2-198",
      "display": "LIGHT v2 198",
      "cartValue": "LIGHT v2 198",
      "code": "",
      "priceDeltaCents": 0,
      "image": "",
      "imageAsset": "solea-memory-ring-configurator-light-v2-198.webp",
      "thumbnail": "",
      "thumbnailAsset": ""
    },
    {
      "value": "LIGHT-v2-203",
      "display": "LIGHT v2 203",
      "cartValue": "LIGHT v2 203",
      "code": "",
      "priceDeltaCents": 0,
      "image": "",
      "imageAsset": "solea-memory-ring-configurator-light-v2-203.webp",
      "thumbnail": "",
      "thumbnailAsset": ""
    },
    {
      "value": "LIGHT-v2-204",
      "display": "LIGHT v2 204",
      "cartValue": "LIGHT v2 204",
      "code": "",
      "priceDeltaCents": 0,
      "image": "",
      "imageAsset": "solea-memory-ring-configurator-light-v2-204.webp",
      "thumbnail": "",
      "thumbnailAsset": ""
    },
    {
      "value": "LIGHT-v2-25",
      "display": "LIGHT v2 25",
      "cartValue": "LIGHT v2 25",
      "code": "",
      "priceDeltaCents": 0,
      "image": "",
      "imageAsset": "solea-memory-ring-configurator-light-v2-25.webp",
      "thumbnail": "",
      "thumbnailAsset": ""
    },
    {
      "value": "LIGHT-v2-35",
      "display": "LIGHT v2 35",
      "cartValue": "LIGHT v2 35",
      "code": "",
      "priceDeltaCents": 0,
      "image": "",
      "imageAsset": "solea-memory-ring-configurator-light-v2-35.webp",
      "thumbnail": "",
      "thumbnailAsset": ""
    },
    {
      "value": "LIGHT-v2-42",
      "display": "LIGHT v2 42",
      "cartValue": "LIGHT v2 42",
      "code": "",
      "priceDeltaCents": 0,
      "image": "",
      "imageAsset": "solea-memory-ring-configurator-light-v2-42.webp",
      "thumbnail": "",
      "thumbnailAsset": ""
    },
    {
      "value": "LIGHT-v2-44",
      "display": "LIGHT v2 44",
      "cartValue": "LIGHT v2 44",
      "code": "",
      "priceDeltaCents": 0,
      "image": "",
      "imageAsset": "solea-memory-ring-configurator-light-v2-44.webp",
      "thumbnail": "",
      "thumbnailAsset": ""
    },
    {
      "value": "LIGHT-v2-47",
      "display": "LIGHT v2 47",
      "cartValue": "LIGHT v2 47",
      "code": "",
      "priceDeltaCents": 0,
      "image": "",
      "imageAsset": "solea-memory-ring-configurator-light-v2-47.webp",
      "thumbnail": "",
      "thumbnailAsset": ""
    },
    {
      "value": "LIGHT-v2-53",
      "display": "LIGHT v2 53",
      "cartValue": "LIGHT v2 53",
      "code": "",
      "priceDeltaCents": 0,
      "image": "",
      "imageAsset": "solea-memory-ring-configurator-light-v2-53.webp",
      "thumbnail": "",
      "thumbnailAsset": ""
    },
    {
      "value": "LIGHT-v2-63",
      "display": "LIGHT v2 63",
      "cartValue": "LIGHT v2 63",
      "code": "",
      "priceDeltaCents": 0,
      "image": "",
      "imageAsset": "solea-memory-ring-configurator-light-v2-63.webp",
      "thumbnail": "",
      "thumbnailAsset": ""
    },
    {
      "value": "LIGHT-v2-68",
      "display": "LIGHT v2 68",
      "cartValue": "LIGHT v2 68",
      "code": "",
      "priceDeltaCents": 0,
      "image": "",
      "imageAsset": "solea-memory-ring-configurator-light-v2-68.webp",
      "thumbnail": "",
      "thumbnailAsset": ""
    },
    {
      "value": "LIGHT-v2-69",
      "display": "LIGHT v2 69",
      "cartValue": "LIGHT v2 69",
      "code": "",
      "priceDeltaCents": 0,
      "image": "",
      "imageAsset": "solea-memory-ring-configurator-light-v2-69.webp",
      "thumbnail": "",
      "thumbnailAsset": ""
    },
    {
      "value": "LIGHT-v2-70",
      "display": "LIGHT v2 70",
      "cartValue": "LIGHT v2 70",
      "code": "",
      "priceDeltaCents": 0,
      "image": "",
      "imageAsset": "solea-memory-ring-configurator-light-v2-70.webp",
      "thumbnail": "",
      "thumbnailAsset": ""
    },
    {
      "value": "LIGHT-v2-72",
      "display": "LIGHT v2 72",
      "cartValue": "LIGHT v2 72",
      "code": "",
      "priceDeltaCents": 0,
      "image": "",
      "imageAsset": "solea-memory-ring-configurator-light-v2-72.webp",
      "thumbnail": "",
      "thumbnailAsset": ""
    },
    {
      "value": "LIGHT-v2-80",
      "display": "LIGHT v2 80",
      "cartValue": "LIGHT v2 80",
      "code": "",
      "priceDeltaCents": 0,
      "image": "",
      "imageAsset": "solea-memory-ring-configurator-light-v2-80.webp",
      "thumbnail": "",
      "thumbnailAsset": ""
    },
    {
      "value": "LIGHT-v2-84",
      "display": "LIGHT v2 84",
      "cartValue": "LIGHT v2 84",
      "code": "",
      "priceDeltaCents": 0,
      "image": "",
      "imageAsset": "solea-memory-ring-configurator-light-v2-84.webp",
      "thumbnail": "",
      "thumbnailAsset": ""
    },
    {
      "value": "LIGHT-v2-85",
      "display": "LIGHT v2 85",
      "cartValue": "LIGHT v2 85",
      "code": "",
      "priceDeltaCents": 0,
      "image": "",
      "imageAsset": "solea-memory-ring-configurator-light-v2-85.webp",
      "thumbnail": "",
      "thumbnailAsset": ""
    },
    {
      "value": "LIGHT-v2-87",
      "display": "LIGHT v2 87",
      "cartValue": "LIGHT v2 87",
      "code": "",
      "priceDeltaCents": 0,
      "image": "",
      "imageAsset": "solea-memory-ring-configurator-light-v2-87.webp",
      "thumbnail": "",
      "thumbnailAsset": ""
    },
    {
      "value": "LIGHT-v2-127",
      "display": "LIGHT v2 127",
      "cartValue": "LIGHT v2 127",
      "code": "",
      "priceDeltaCents": 0,
      "image": "",
      "imageAsset": "solea-memory-ring-configurator-light-v2-127.webp",
      "thumbnail": "",
      "thumbnailAsset": ""
    },
    {
      "value": "COLORSHIFT-114",
      "display": "COLORSHIFT 114",
      "cartValue": "COLORSHIFT 114",
      "code": "",
      "priceDeltaCents": 0,
      "image": "",
      "imageAsset": "solea-memory-ring-configurator-colorshift-114.webp",
      "thumbnail": "",
      "thumbnailAsset": ""
    },
    {
      "value": "COLORSHIFT-12",
      "display": "COLORSHIFT 12",
      "cartValue": "COLORSHIFT 12",
      "code": "",
      "priceDeltaCents": 0,
      "image": "",
      "imageAsset": "solea-memory-ring-configurator-colorshift-12.webp",
      "thumbnail": "",
      "thumbnailAsset": ""
    },
    {
      "value": "COLORSHIFT-38",
      "display": "COLORSHIFT 38",
      "cartValue": "COLORSHIFT 38",
      "code": "",
      "priceDeltaCents": 0,
      "image": "",
      "imageAsset": "solea-memory-ring-configurator-colorshift-38.webp",
      "thumbnail": "",
      "thumbnailAsset": ""
    },
    {
      "value": "COLORSHIFT-207",
      "display": "COLORSHIFT 207",
      "cartValue": "COLORSHIFT 207",
      "code": "",
      "priceDeltaCents": 0,
      "image": "",
      "imageAsset": "solea-memory-ring-configurator-colorshift-207.webp",
      "thumbnail": "",
      "thumbnailAsset": ""
    },
    {
      "value": "COLORSHIFT-108",
      "display": "COLORSHIFT 108",
      "cartValue": "COLORSHIFT 108",
      "code": "",
      "priceDeltaCents": 0,
      "image": "",
      "imageAsset": "solea-memory-ring-configurator-colorshift-108.webp",
      "thumbnail": "",
      "thumbnailAsset": ""
    },
    {
      "value": "COLORSHIFT-191",
      "display": "COLORSHIFT 191",
      "cartValue": "COLORSHIFT 191",
      "code": "",
      "priceDeltaCents": 0,
      "image": "",
      "imageAsset": "solea-memory-ring-configurator-colorshift-191.webp",
      "thumbnail": "",
      "thumbnailAsset": ""
    },
    {
      "value": "COLORSHIFT-106",
      "display": "COLORSHIFT 106",
      "cartValue": "COLORSHIFT 106",
      "code": "",
      "priceDeltaCents": 0,
      "image": "",
      "imageAsset": "solea-memory-ring-configurator-colorshift-106.webp",
      "thumbnail": "",
      "thumbnailAsset": ""
    },
    {
      "value": "COLORSHIFT-39",
      "display": "COLORSHIFT 39",
      "cartValue": "COLORSHIFT 39",
      "code": "",
      "priceDeltaCents": 0,
      "image": "",
      "imageAsset": "solea-memory-ring-configurator-colorshift-39.webp",
      "thumbnail": "",
      "thumbnailAsset": ""
    },
    {
      "value": "COLORSHIFT-40",
      "display": "COLORSHIFT 40",
      "cartValue": "COLORSHIFT 40",
      "code": "",
      "priceDeltaCents": 0,
      "image": "",
      "imageAsset": "solea-memory-ring-configurator-colorshift-40.webp",
      "thumbnail": "",
      "thumbnailAsset": ""
    },
    {
      "value": "COLORSHIFT-16",
      "display": "COLORSHIFT 16",
      "cartValue": "COLORSHIFT 16",
      "code": "",
      "priceDeltaCents": 0,
      "image": "",
      "imageAsset": "solea-memory-ring-configurator-colorshift-16.webp",
      "thumbnail": "",
      "thumbnailAsset": ""
    },
    {
      "value": "COLORSHIFT-188",
      "display": "COLORSHIFT 188",
      "cartValue": "COLORSHIFT 188",
      "code": "",
      "priceDeltaCents": 0,
      "image": "",
      "imageAsset": "solea-memory-ring-configurator-colorshift-188.webp",
      "thumbnail": "",
      "thumbnailAsset": ""
    },
    {
      "value": "COLORSHIFT-149",
      "display": "COLORSHIFT 149",
      "cartValue": "COLORSHIFT 149",
      "code": "",
      "priceDeltaCents": 0,
      "image": "",
      "imageAsset": "solea-memory-ring-configurator-colorshift-149.webp",
      "thumbnail": "",
      "thumbnailAsset": ""
    },
    {
      "value": "COLORSHIFT-109",
      "display": "COLORSHIFT 109",
      "cartValue": "COLORSHIFT 109",
      "code": "",
      "priceDeltaCents": 0,
      "image": "",
      "imageAsset": "solea-memory-ring-configurator-colorshift-109.webp",
      "thumbnail": "",
      "thumbnailAsset": ""
    },
    {
      "value": "COLORSHIFT-125",
      "display": "COLORSHIFT 125",
      "cartValue": "COLORSHIFT 125",
      "code": "",
      "priceDeltaCents": 0,
      "image": "",
      "imageAsset": "solea-memory-ring-configurator-colorshift-125.webp",
      "thumbnail": "",
      "thumbnailAsset": ""
    },
    {
      "value": "COLORSHIFT-170",
      "display": "COLORSHIFT 170",
      "cartValue": "COLORSHIFT 170",
      "code": "",
      "priceDeltaCents": 0,
      "image": "",
      "imageAsset": "solea-memory-ring-configurator-colorshift-170.webp",
      "thumbnail": "",
      "thumbnailAsset": ""
    },
    {
      "value": "COLORSHIFT-154",
      "display": "COLORSHIFT 154",
      "cartValue": "COLORSHIFT 154",
      "code": "",
      "priceDeltaCents": 0,
      "image": "",
      "imageAsset": "solea-memory-ring-configurator-colorshift-154.webp",
      "thumbnail": "",
      "thumbnailAsset": ""
    },
    {
      "value": "COLORSHIFT-14",
      "display": "COLORSHIFT 14",
      "cartValue": "COLORSHIFT 14",
      "code": "",
      "priceDeltaCents": 0,
      "image": "",
      "imageAsset": "solea-memory-ring-configurator-colorshift-14.webp",
      "thumbnail": "",
      "thumbnailAsset": ""
    },
    {
      "value": "COLORSHIFT-121",
      "display": "COLORSHIFT 121",
      "cartValue": "COLORSHIFT 121",
      "code": "",
      "priceDeltaCents": 0,
      "image": "",
      "imageAsset": "solea-memory-ring-configurator-colorshift-121.webp",
      "thumbnail": "",
      "thumbnailAsset": ""
    },
    {
      "value": "COLORSHIFT-173",
      "display": "COLORSHIFT 173",
      "cartValue": "COLORSHIFT 173",
      "code": "",
      "priceDeltaCents": 0,
      "image": "",
      "imageAsset": "solea-memory-ring-configurator-colorshift-173.webp",
      "thumbnail": "",
      "thumbnailAsset": ""
    },
    {
      "value": "COLORSHIFT-169",
      "display": "COLORSHIFT 169",
      "cartValue": "COLORSHIFT 169",
      "code": "",
      "priceDeltaCents": 0,
      "image": "",
      "imageAsset": "solea-memory-ring-configurator-colorshift-169.webp",
      "thumbnail": "",
      "thumbnailAsset": ""
    },
    {
      "value": "COLORSHIFT-164",
      "display": "COLORSHIFT 164",
      "cartValue": "COLORSHIFT 164",
      "code": "",
      "priceDeltaCents": 0,
      "image": "",
      "imageAsset": "solea-memory-ring-configurator-colorshift-164.webp",
      "thumbnail": "",
      "thumbnailAsset": ""
    },
    {
      "value": "-black",
      "display": " black",
      "cartValue": " black",
      "code": "",
      "priceDeltaCents": 0,
      "image": "",
      "imageAsset": "solea-memory-ring-configurator-black.webp",
      "thumbnail": "",
      "thumbnailAsset": ""
    },
    {
      "value": "-blue",
      "display": " blue",
      "cartValue": " blue",
      "code": "",
      "priceDeltaCents": 0,
      "image": "",
      "imageAsset": "solea-memory-ring-configurator-blue.webp",
      "thumbnail": "",
      "thumbnailAsset": ""
    },
    {
      "value": "-lightblue",
      "display": " lightblue",
      "cartValue": " lightblue",
      "code": "",
      "priceDeltaCents": 0,
      "image": "",
      "imageAsset": "solea-memory-ring-configurator-lightblue.webp",
      "thumbnail": "",
      "thumbnailAsset": ""
    },
    {
      "value": "-lightgreen",
      "display": " lightgreen",
      "cartValue": " lightgreen",
      "code": "",
      "priceDeltaCents": 0,
      "image": "",
      "imageAsset": "solea-memory-ring-configurator-lightgreen.webp",
      "thumbnail": "",
      "thumbnailAsset": ""
    },
    {
      "value": "-orange",
      "display": " orange",
      "cartValue": " orange",
      "code": "",
      "priceDeltaCents": 0,
      "image": "",
      "imageAsset": "solea-memory-ring-configurator-orange.webp",
      "thumbnail": "",
      "thumbnailAsset": ""
    },
    {
      "value": "-red",
      "display": " red",
      "cartValue": " red",
      "code": "",
      "priceDeltaCents": 0,
      "image": "",
      "imageAsset": "solea-memory-ring-configurator-red.webp",
      "thumbnail": "",
      "thumbnailAsset": ""
    },
    {
      "value": "-pink",
      "display": " pink",
      "cartValue": " pink",
      "code": "",
      "priceDeltaCents": 0,
      "image": "",
      "imageAsset": "solea-memory-ring-configurator-pink.webp",
      "thumbnail": "",
      "thumbnailAsset": ""
    },
    {
      "value": "-violet",
      "display": " violet",
      "cartValue": " violet",
      "code": "",
      "priceDeltaCents": 0,
      "image": "",
      "imageAsset": "solea-memory-ring-configurator-violet.webp",
      "thumbnail": "",
      "thumbnailAsset": ""
    },
    {
      "value": "-white",
      "display": " white",
      "cartValue": " white",
      "code": "",
      "priceDeltaCents": 0,
      "image": "",
      "imageAsset": "solea-memory-ring-configurator-white.webp",
      "thumbnail": "",
      "thumbnailAsset": ""
    },
    {
      "value": "-yellow",
      "display": " yellow",
      "cartValue": " yellow",
      "code": "",
      "priceDeltaCents": 0,
      "image": "",
      "imageAsset": "solea-memory-ring-configurator-yellow.webp",
      "thumbnail": "",
      "thumbnailAsset": ""
    },
    {
      "value": "-green",
      "display": " green",
      "cartValue": " green",
      "code": "",
      "priceDeltaCents": 0,
      "image": "",
      "imageAsset": "solea-memory-ring-configurator-green.webp",
      "thumbnail": "",
      "thumbnailAsset": ""
    },
    {
      "value": "BLUE-CABOCHON-1",
      "display": "BLUE Cabochon 1",
      "cartValue": "BLUE-CABOCHON-1",
      "code": "",
      "priceDeltaCents": 0,
      "image": "",
      "imageAsset": "solea-memory-ring-configurator-cabochon-1.webp",
      "thumbnail": "",
      "thumbnailAsset": ""
    },
    {
      "value": "BLUE-CABOCHON-2",
      "display": "BLUE Cabochon 2",
      "cartValue": "BLUE-CABOCHON-2",
      "code": "",
      "priceDeltaCents": 0,
      "image": "",
      "imageAsset": "solea-memory-ring-configurator-cabochon-2.webp",
      "thumbnail": "",
      "thumbnailAsset": ""
    },
    {
      "value": "BLUE-CABOCHON-3",
      "display": "BLUE Cabochon 3",
      "cartValue": "BLUE-CABOCHON-3",
      "code": "",
      "priceDeltaCents": 0,
      "image": "",
      "imageAsset": "solea-memory-ring-configurator-cabochon-3.webp",
      "thumbnail": "",
      "thumbnailAsset": ""
    },
    {
      "value": "BLUE-CABOCHON-4",
      "display": "BLUE Cabochon 4",
      "cartValue": "BLUE-CABOCHON-4",
      "code": "",
      "priceDeltaCents": 0,
      "image": "",
      "imageAsset": "solea-memory-ring-configurator-cabochon-4.webp",
      "thumbnail": "",
      "thumbnailAsset": ""
    },
    {
      "value": "BLUE-CABOCHON-5",
      "display": "BLUE Cabochon 5",
      "cartValue": "BLUE-CABOCHON-5",
      "code": "",
      "priceDeltaCents": 0,
      "image": "",
      "imageAsset": "solea-memory-ring-configurator-cabochon-5.webp",
      "thumbnail": "",
      "thumbnailAsset": ""
    },
    {
      "value": "BLUE-CABOCHON-6",
      "display": "BLUE Cabochon 6",
      "cartValue": "BLUE-CABOCHON-6",
      "code": "",
      "priceDeltaCents": 0,
      "image": "",
      "imageAsset": "solea-memory-ring-configurator-cabochon-6.webp",
      "thumbnail": "",
      "thumbnailAsset": ""
    },
    {
      "value": "BLUE-CABOCHON-7",
      "display": "BLUE Cabochon 7",
      "cartValue": "BLUE-CABOCHON-7",
      "code": "",
      "priceDeltaCents": 0,
      "image": "",
      "imageAsset": "solea-memory-ring-configurator-cabochon-7.webp",
      "thumbnail": "",
      "thumbnailAsset": ""
    },
    {
      "value": "BLUE-CABOCHON-8",
      "display": "BLUE Cabochon 8",
      "cartValue": "BLUE-CABOCHON-8",
      "code": "",
      "priceDeltaCents": 0,
      "image": "",
      "imageAsset": "solea-memory-ring-configurator-cabochon-8.webp",
      "thumbnail": "",
      "thumbnailAsset": ""
    },
    {
      "value": "BLUE-CABOCHON-9",
      "display": "BLUE Cabochon 9",
      "cartValue": "BLUE-CABOCHON-9",
      "code": "",
      "priceDeltaCents": 0,
      "image": "",
      "imageAsset": "solea-memory-ring-configurator-cabochon-9.webp",
      "thumbnail": "",
      "thumbnailAsset": ""
    },
    {
      "value": "BLUE-CABOCHON-10",
      "display": "BLUE Cabochon 10",
      "cartValue": "BLUE-CABOCHON-10",
      "code": "",
      "priceDeltaCents": 0,
      "image": "",
      "imageAsset": "solea-memory-ring-configurator-cabochon-10.webp",
      "thumbnail": "",
      "thumbnailAsset": ""
    },
    {
      "value": "BLUE-CABOCHON-11",
      "display": "BLUE Cabochon 11",
      "cartValue": "BLUE-CABOCHON-11",
      "code": "",
      "priceDeltaCents": 0,
      "image": "",
      "imageAsset": "solea-memory-ring-configurator-cabochon-11.webp",
      "thumbnail": "",
      "thumbnailAsset": ""
    },
    {
      "value": "BLUE-CABOCHON-12",
      "display": "BLUE Cabochon 12",
      "cartValue": "BLUE-CABOCHON-12",
      "code": "",
      "priceDeltaCents": 0,
      "image": "",
      "imageAsset": "solea-memory-ring-configurator-cabochon-12.webp",
      "thumbnail": "",
      "thumbnailAsset": ""
    },
    {
      "value": "BLUE-CABOCHON-13",
      "display": "BLUE Cabochon 13",
      "cartValue": "BLUE-CABOCHON-13",
      "code": "",
      "priceDeltaCents": 0,
      "image": "",
      "imageAsset": "solea-memory-ring-configurator-cabochon-13.webp",
      "thumbnail": "",
      "thumbnailAsset": ""
    },
    {
      "value": "BLUE-CABOCHON-14",
      "display": "BLUE Cabochon 14",
      "cartValue": "BLUE-CABOCHON-14",
      "code": "",
      "priceDeltaCents": 0,
      "image": "",
      "imageAsset": "solea-memory-ring-configurator-cabochon-14.webp",
      "thumbnail": "",
      "thumbnailAsset": ""
    },
    {
      "value": "BLUE-CABOCHON-15",
      "display": "BLUE Cabochon 15",
      "cartValue": "BLUE-CABOCHON-15",
      "code": "",
      "priceDeltaCents": 0,
      "image": "",
      "imageAsset": "solea-memory-ring-configurator-cabochon-15.webp",
      "thumbnail": "",
      "thumbnailAsset": ""
    },
    {
      "value": "BLUE-CABOCHON-16",
      "display": "BLUE Cabochon 16",
      "cartValue": "BLUE-CABOCHON-16",
      "code": "",
      "priceDeltaCents": 0,
      "image": "",
      "imageAsset": "solea-memory-ring-configurator-cabochon-16.webp",
      "thumbnail": "",
      "thumbnailAsset": ""
    },
    {
      "value": "BLUE-CABOCHON-17",
      "display": "BLUE Cabochon 17",
      "cartValue": "BLUE-CABOCHON-17",
      "code": "",
      "priceDeltaCents": 0,
      "image": "",
      "imageAsset": "solea-memory-ring-configurator-cabochon-17.webp",
      "thumbnail": "",
      "thumbnailAsset": ""
    },
    {
      "value": "BLUE-CABOCHON-18",
      "display": "BLUE Cabochon 18",
      "cartValue": "BLUE-CABOCHON-18",
      "code": "",
      "priceDeltaCents": 0,
      "image": "",
      "imageAsset": "solea-memory-ring-configurator-cabochon-18.webp",
      "thumbnail": "",
      "thumbnailAsset": ""
    },
    {
      "value": "BLUE-CABOCHON-19",
      "display": "BLUE Cabochon 19",
      "cartValue": "BLUE-CABOCHON-19",
      "code": "",
      "priceDeltaCents": 0,
      "image": "",
      "imageAsset": "solea-memory-ring-configurator-cabochon-19.webp",
      "thumbnail": "",
      "thumbnailAsset": ""
    },
    {
      "value": "BLUE-CABOCHON-20",
      "display": "BLUE Cabochon 20",
      "cartValue": "BLUE-CABOCHON-20",
      "code": "",
      "priceDeltaCents": 0,
      "image": "",
      "imageAsset": "solea-memory-ring-configurator-cabochon-20.webp",
      "thumbnail": "",
      "thumbnailAsset": ""
    },
    {
      "value": "BLUE-CABOCHON-21",
      "display": "BLUE Cabochon 21",
      "cartValue": "BLUE-CABOCHON-21",
      "code": "",
      "priceDeltaCents": 0,
      "image": "",
      "imageAsset": "solea-memory-ring-configurator-cabochon-21.webp",
      "thumbnail": "",
      "thumbnailAsset": ""
    },
    {
      "value": "BLUE-CABOCHON-22",
      "display": "BLUE Cabochon 22",
      "cartValue": "BLUE-CABOCHON-22",
      "code": "",
      "priceDeltaCents": 0,
      "image": "",
      "imageAsset": "solea-memory-ring-configurator-cabochon-22.webp",
      "thumbnail": "",
      "thumbnailAsset": ""
    },
    {
      "value": "BLUE-CABOCHON-23",
      "display": "BLUE Cabochon 23",
      "cartValue": "BLUE-CABOCHON-23",
      "code": "",
      "priceDeltaCents": 0,
      "image": "",
      "imageAsset": "solea-memory-ring-configurator-cabochon-23.webp",
      "thumbnail": "",
      "thumbnailAsset": ""
    },
    {
      "value": "BLUE-CABOCHON-24",
      "display": "BLUE Cabochon 24",
      "cartValue": "BLUE-CABOCHON-24",
      "code": "",
      "priceDeltaCents": 0,
      "image": "",
      "imageAsset": "solea-memory-ring-configurator-cabochon-24.webp",
      "thumbnail": "",
      "thumbnailAsset": ""
    },
    {
      "value": "BLUE-CABOCHON-25",
      "display": "BLUE Cabochon 25",
      "cartValue": "BLUE-CABOCHON-25",
      "code": "",
      "priceDeltaCents": 0,
      "image": "",
      "imageAsset": "solea-memory-ring-configurator-cabochon-25.webp",
      "thumbnail": "",
      "thumbnailAsset": ""
    },
    {
      "value": "BLUE-CABOCHON-26",
      "display": "BLUE Cabochon 26",
      "cartValue": "BLUE-CABOCHON-26",
      "code": "",
      "priceDeltaCents": 0,
      "image": "",
      "imageAsset": "solea-memory-ring-configurator-cabochon-26.webp",
      "thumbnail": "",
      "thumbnailAsset": ""
    },
    {
      "value": "BLUE-CABOCHON-27",
      "display": "BLUE Cabochon 27",
      "cartValue": "BLUE-CABOCHON-27",
      "code": "",
      "priceDeltaCents": 0,
      "image": "",
      "imageAsset": "solea-memory-ring-configurator-cabochon-27.webp",
      "thumbnail": "",
      "thumbnailAsset": ""
    },
    {
      "value": "BLUE-CABOCHON-28",
      "display": "BLUE Cabochon 28",
      "cartValue": "BLUE-CABOCHON-28",
      "code": "",
      "priceDeltaCents": 0,
      "image": "",
      "imageAsset": "solea-memory-ring-configurator-cabochon-28.webp",
      "thumbnail": "",
      "thumbnailAsset": ""
    },
    {
      "value": "BLUE-CABOCHON-29",
      "display": "BLUE Cabochon 29",
      "cartValue": "BLUE-CABOCHON-29",
      "code": "",
      "priceDeltaCents": 0,
      "image": "",
      "imageAsset": "solea-memory-ring-configurator-cabochon-29.webp",
      "thumbnail": "",
      "thumbnailAsset": ""
    },
    {
      "value": "BLUE-CABOCHON-30",
      "display": "BLUE Cabochon 30",
      "cartValue": "BLUE-CABOCHON-30",
      "code": "",
      "priceDeltaCents": 0,
      "image": "",
      "imageAsset": "solea-memory-ring-configurator-cabochon-30.webp",
      "thumbnail": "",
      "thumbnailAsset": ""
    },
    {
      "value": "BLUE-CABOCHON-31",
      "display": "BLUE Cabochon 31",
      "cartValue": "BLUE-CABOCHON-31",
      "code": "",
      "priceDeltaCents": 0,
      "image": "",
      "imageAsset": "solea-memory-ring-configurator-cabochon-31.webp",
      "thumbnail": "",
      "thumbnailAsset": ""
    },
    {
      "value": "BLUE-CABOCHON-32",
      "display": "BLUE Cabochon 32",
      "cartValue": "BLUE-CABOCHON-32",
      "code": "",
      "priceDeltaCents": 0,
      "image": "",
      "imageAsset": "solea-memory-ring-configurator-cabochon-32.webp",
      "thumbnail": "",
      "thumbnailAsset": ""
    },
    {
      "value": "BLUE-CABOCHON-33",
      "display": "BLUE Cabochon 33",
      "cartValue": "BLUE-CABOCHON-33",
      "code": "",
      "priceDeltaCents": 0,
      "image": "",
      "imageAsset": "solea-memory-ring-configurator-cabochon-33.webp",
      "thumbnail": "",
      "thumbnailAsset": ""
    },
    {
      "value": "BLUE-CABOCHON-35",
      "display": "BLUE Cabochon 35",
      "cartValue": "BLUE-CABOCHON-35",
      "code": "",
      "priceDeltaCents": 0,
      "image": "",
      "imageAsset": "solea-memory-ring-configurator-cabochon-35.webp",
      "thumbnail": "",
      "thumbnailAsset": ""
    },
    {
      "value": "BLUE-CABOCHON-36",
      "display": "BLUE Cabochon 36",
      "cartValue": "BLUE-CABOCHON-36",
      "code": "",
      "priceDeltaCents": 0,
      "image": "",
      "imageAsset": "solea-memory-ring-configurator-cabochon-36.webp",
      "thumbnail": "",
      "thumbnailAsset": ""
    },
    {
      "value": "BLUE-CABOCHON-37",
      "display": "BLUE Cabochon 37",
      "cartValue": "BLUE-CABOCHON-37",
      "code": "",
      "priceDeltaCents": 0,
      "image": "",
      "imageAsset": "solea-memory-ring-configurator-cabochon-37.webp",
      "thumbnail": "",
      "thumbnailAsset": ""
    },
    {
      "value": "GREEN-CABOCHON-38",
      "display": "GREEN Cabochon 38",
      "cartValue": "GREEN-CABOCHON-38",
      "code": "",
      "priceDeltaCents": 0,
      "image": "",
      "imageAsset": "solea-memory-ring-configurator-cabochon-38.webp",
      "thumbnail": "",
      "thumbnailAsset": ""
    },
    {
      "value": "GREEN-CABOCHON-39",
      "display": "GREEN Cabochon 39",
      "cartValue": "GREEN-CABOCHON-39",
      "code": "",
      "priceDeltaCents": 0,
      "image": "",
      "imageAsset": "solea-memory-ring-configurator-cabochon-39.webp",
      "thumbnail": "",
      "thumbnailAsset": ""
    },
    {
      "value": "GREEN-CABOCHON-40",
      "display": "GREEN Cabochon 40",
      "cartValue": "GREEN-CABOCHON-40",
      "code": "",
      "priceDeltaCents": 0,
      "image": "",
      "imageAsset": "solea-memory-ring-configurator-cabochon-40.webp",
      "thumbnail": "",
      "thumbnailAsset": ""
    },
    {
      "value": "GREEN-CABOCHON-41",
      "display": "GREEN Cabochon 41",
      "cartValue": "GREEN-CABOCHON-41",
      "code": "",
      "priceDeltaCents": 0,
      "image": "",
      "imageAsset": "solea-memory-ring-configurator-cabochon-41.webp",
      "thumbnail": "",
      "thumbnailAsset": ""
    },
    {
      "value": "GREEN-CABOCHON-42",
      "display": "GREEN Cabochon 42",
      "cartValue": "GREEN-CABOCHON-42",
      "code": "",
      "priceDeltaCents": 0,
      "image": "",
      "imageAsset": "solea-memory-ring-configurator-cabochon-42.webp",
      "thumbnail": "",
      "thumbnailAsset": ""
    },
    {
      "value": "GREEN-CABOCHON-43",
      "display": "GREEN Cabochon 43",
      "cartValue": "GREEN-CABOCHON-43",
      "code": "",
      "priceDeltaCents": 0,
      "image": "",
      "imageAsset": "solea-memory-ring-configurator-cabochon-43.webp",
      "thumbnail": "",
      "thumbnailAsset": ""
    },
    {
      "value": "GREEN-CABOCHON-44",
      "display": "GREEN Cabochon 44",
      "cartValue": "GREEN-CABOCHON-44",
      "code": "",
      "priceDeltaCents": 0,
      "image": "",
      "imageAsset": "solea-memory-ring-configurator-cabochon-44.webp",
      "thumbnail": "",
      "thumbnailAsset": ""
    },
    {
      "value": "GREEN-CABOCHON-45",
      "display": "GREEN Cabochon 45",
      "cartValue": "GREEN-CABOCHON-45",
      "code": "",
      "priceDeltaCents": 0,
      "image": "",
      "imageAsset": "solea-memory-ring-configurator-cabochon-45.webp",
      "thumbnail": "",
      "thumbnailAsset": ""
    },
    {
      "value": "GREEN-CABOCHON-46",
      "display": "GREEN Cabochon 46",
      "cartValue": "GREEN-CABOCHON-46",
      "code": "",
      "priceDeltaCents": 0,
      "image": "",
      "imageAsset": "solea-memory-ring-configurator-cabochon-46.webp",
      "thumbnail": "",
      "thumbnailAsset": ""
    },
    {
      "value": "GREEN-CABOCHON-47",
      "display": "GREEN Cabochon 47",
      "cartValue": "GREEN-CABOCHON-47",
      "code": "",
      "priceDeltaCents": 0,
      "image": "",
      "imageAsset": "solea-memory-ring-configurator-cabochon-47.webp",
      "thumbnail": "",
      "thumbnailAsset": ""
    },
    {
      "value": "GREEN-CABOCHON-48",
      "display": "GREEN Cabochon 48",
      "cartValue": "GREEN-CABOCHON-48",
      "code": "",
      "priceDeltaCents": 0,
      "image": "",
      "imageAsset": "solea-memory-ring-configurator-cabochon-48.webp",
      "thumbnail": "",
      "thumbnailAsset": ""
    },
    {
      "value": "GREEN-CABOCHON-49",
      "display": "GREEN Cabochon 49",
      "cartValue": "GREEN-CABOCHON-49",
      "code": "",
      "priceDeltaCents": 0,
      "image": "",
      "imageAsset": "solea-memory-ring-configurator-cabochon-49.webp",
      "thumbnail": "",
      "thumbnailAsset": ""
    },
    {
      "value": "GREEN-CABOCHON-50",
      "display": "GREEN Cabochon 50",
      "cartValue": "GREEN-CABOCHON-50",
      "code": "",
      "priceDeltaCents": 0,
      "image": "",
      "imageAsset": "solea-memory-ring-configurator-cabochon-50.webp",
      "thumbnail": "",
      "thumbnailAsset": ""
    },
    {
      "value": "LIGHT-CABOCHON-51",
      "display": "LIGHT Cabochon 51",
      "cartValue": "LIGHT-CABOCHON-51",
      "code": "",
      "priceDeltaCents": 0,
      "image": "",
      "imageAsset": "solea-memory-ring-configurator-cabochon-51.webp",
      "thumbnail": "",
      "thumbnailAsset": ""
    },
    {
      "value": "LIGHT-CABOCHON-54",
      "display": "LIGHT Cabochon 54",
      "cartValue": "LIGHT-CABOCHON-54",
      "code": "",
      "priceDeltaCents": 0,
      "image": "",
      "imageAsset": "solea-memory-ring-configurator-cabochon-54.webp",
      "thumbnail": "",
      "thumbnailAsset": ""
    },
    {
      "value": "LIGHT-CABOCHON-55",
      "display": "LIGHT Cabochon 55",
      "cartValue": "LIGHT-CABOCHON-55",
      "code": "",
      "priceDeltaCents": 0,
      "image": "",
      "imageAsset": "solea-memory-ring-configurator-cabochon-55.webp",
      "thumbnail": "",
      "thumbnailAsset": ""
    },
    {
      "value": "LIGHT-CABOCHON-56",
      "display": "LIGHT Cabochon 56",
      "cartValue": "LIGHT-CABOCHON-56",
      "code": "",
      "priceDeltaCents": 0,
      "image": "",
      "imageAsset": "solea-memory-ring-configurator-cabochon-56.webp",
      "thumbnail": "",
      "thumbnailAsset": ""
    },
    {
      "value": "LIGHT-CABOCHON-57",
      "display": "LIGHT Cabochon 57",
      "cartValue": "LIGHT-CABOCHON-57",
      "code": "",
      "priceDeltaCents": 0,
      "image": "",
      "imageAsset": "solea-memory-ring-configurator-cabochon-57.webp",
      "thumbnail": "",
      "thumbnailAsset": ""
    },
    {
      "value": "LIGHT-CABOCHON-58",
      "display": "LIGHT Cabochon 58",
      "cartValue": "LIGHT-CABOCHON-58",
      "code": "",
      "priceDeltaCents": 0,
      "image": "",
      "imageAsset": "solea-memory-ring-configurator-cabochon-58.webp",
      "thumbnail": "",
      "thumbnailAsset": ""
    },
    {
      "value": "GOLD-CABOCHON-60",
      "display": "GOLD Cabochon 60",
      "cartValue": "GOLD-CABOCHON-60",
      "code": "",
      "priceDeltaCents": 0,
      "image": "",
      "imageAsset": "solea-memory-ring-configurator-cabochon-60.webp",
      "thumbnail": "",
      "thumbnailAsset": ""
    },
    {
      "value": "GOLD-CABOCHON-61",
      "display": "GOLD Cabochon 61",
      "cartValue": "GOLD-CABOCHON-61",
      "code": "",
      "priceDeltaCents": 0,
      "image": "",
      "imageAsset": "solea-memory-ring-configurator-cabochon-61.webp",
      "thumbnail": "",
      "thumbnailAsset": ""
    },
    {
      "value": "GOLD-CABOCHON-65",
      "display": "GOLD Cabochon 65",
      "cartValue": "GOLD-CABOCHON-65",
      "code": "",
      "priceDeltaCents": 0,
      "image": "",
      "imageAsset": "solea-memory-ring-configurator-cabochon-65.webp",
      "thumbnail": "",
      "thumbnailAsset": ""
    },
    {
      "value": "GOLD-CABOCHON-67",
      "display": "GOLD Cabochon 67",
      "cartValue": "GOLD-CABOCHON-67",
      "code": "",
      "priceDeltaCents": 0,
      "image": "",
      "imageAsset": "solea-memory-ring-configurator-cabochon-67.webp",
      "thumbnail": "",
      "thumbnailAsset": ""
    },
    {
      "value": "GOLD-CABOCHON-69",
      "display": "GOLD Cabochon 69",
      "cartValue": "GOLD-CABOCHON-69",
      "code": "",
      "priceDeltaCents": 0,
      "image": "",
      "imageAsset": "solea-memory-ring-configurator-cabochon-69.webp",
      "thumbnail": "",
      "thumbnailAsset": ""
    },
    {
      "value": "GOLD-CABOCHON-71",
      "display": "GOLD Cabochon 71",
      "cartValue": "GOLD-CABOCHON-71",
      "code": "",
      "priceDeltaCents": 0,
      "image": "",
      "imageAsset": "solea-memory-ring-configurator-cabochon-71.webp",
      "thumbnail": "",
      "thumbnailAsset": ""
    },
    {
      "value": "GOLD-CABOCHON-72",
      "display": "GOLD Cabochon 72",
      "cartValue": "GOLD-CABOCHON-72",
      "code": "",
      "priceDeltaCents": 0,
      "image": "",
      "imageAsset": "solea-memory-ring-configurator-cabochon-72.webp",
      "thumbnail": "",
      "thumbnailAsset": ""
    },
    {
      "value": "GOLD-CABOCHON-73",
      "display": "GOLD Cabochon 73",
      "cartValue": "GOLD-CABOCHON-73",
      "code": "",
      "priceDeltaCents": 0,
      "image": "",
      "imageAsset": "solea-memory-ring-configurator-cabochon-73.webp",
      "thumbnail": "",
      "thumbnailAsset": ""
    },
    {
      "value": "GOLD-CABOCHON-80",
      "display": "GOLD Cabochon 80",
      "cartValue": "GOLD-CABOCHON-80",
      "code": "",
      "priceDeltaCents": 0,
      "image": "",
      "imageAsset": "solea-memory-ring-configurator-cabochon-80.webp",
      "thumbnail": "",
      "thumbnailAsset": ""
    },
    {
      "value": "DARK-CABOCHON-62",
      "display": "DARK Cabochon 62",
      "cartValue": "DARK-CABOCHON-62",
      "code": "",
      "priceDeltaCents": 0,
      "image": "",
      "imageAsset": "solea-memory-ring-configurator-cabochon-62.webp",
      "thumbnail": "",
      "thumbnailAsset": ""
    },
    {
      "value": "DARK-CABOCHON-64",
      "display": "DARK Cabochon 64",
      "cartValue": "DARK-CABOCHON-64",
      "code": "",
      "priceDeltaCents": 0,
      "image": "",
      "imageAsset": "solea-memory-ring-configurator-cabochon-64.webp",
      "thumbnail": "",
      "thumbnailAsset": ""
    },
    {
      "value": "DARK-CABOCHON-70",
      "display": "DARK Cabochon 70",
      "cartValue": "DARK-CABOCHON-70",
      "code": "",
      "priceDeltaCents": 0,
      "image": "",
      "imageAsset": "solea-memory-ring-configurator-cabochon-70.webp",
      "thumbnail": "",
      "thumbnailAsset": ""
    },
    {
      "value": "DARK-CABOCHON-86",
      "display": "DARK Cabochon 86",
      "cartValue": "DARK-CABOCHON-86",
      "code": "",
      "priceDeltaCents": 0,
      "image": "",
      "imageAsset": "solea-memory-ring-configurator-cabochon-86.webp",
      "thumbnail": "",
      "thumbnailAsset": ""
    },
    {
      "value": "VIOLET-CABOCHON-74",
      "display": "VIOLET Cabochon 74",
      "cartValue": "VIOLET-CABOCHON-74",
      "code": "",
      "priceDeltaCents": 0,
      "image": "",
      "imageAsset": "solea-memory-ring-configurator-cabochon-74.webp",
      "thumbnail": "",
      "thumbnailAsset": ""
    },
    {
      "value": "COLORSHIFT-CABOCHON-76",
      "display": "COLORSHIFT Cabochon 76",
      "cartValue": "COLORSHIFT-CABOCHON-76",
      "code": "",
      "priceDeltaCents": 0,
      "image": "",
      "imageAsset": "solea-memory-ring-configurator-cabochon-76.webp",
      "thumbnail": "",
      "thumbnailAsset": ""
    },
    {
      "value": "COLORSHIFT-CABOCHON-78",
      "display": "COLORSHIFT Cabochon 78",
      "cartValue": "COLORSHIFT-CABOCHON-78",
      "code": "",
      "priceDeltaCents": 0,
      "image": "",
      "imageAsset": "solea-memory-ring-configurator-cabochon-78.webp",
      "thumbnail": "",
      "thumbnailAsset": ""
    },
    {
      "value": "COLORSHIFT-CABOCHON-79",
      "display": "COLORSHIFT Cabochon 79",
      "cartValue": "COLORSHIFT-CABOCHON-79",
      "code": "",
      "priceDeltaCents": 0,
      "image": "",
      "imageAsset": "solea-memory-ring-configurator-cabochon-79.webp",
      "thumbnail": "",
      "thumbnailAsset": ""
    },
    {
      "value": "COLORSHIFT-CABOCHON-82",
      "display": "COLORSHIFT Cabochon 82",
      "cartValue": "COLORSHIFT-CABOCHON-82",
      "code": "",
      "priceDeltaCents": 0,
      "image": "",
      "imageAsset": "solea-memory-ring-configurator-cabochon-82.webp",
      "thumbnail": "",
      "thumbnailAsset": ""
    },
    {
      "value": "PINK-CABOCHON-84",
      "display": "PINK Cabochon 84",
      "cartValue": "PINK-CABOCHON-84",
      "code": "",
      "priceDeltaCents": 0,
      "image": "",
      "imageAsset": "solea-memory-ring-configurator-cabochon-84.webp",
      "thumbnail": "",
      "thumbnailAsset": ""
    },
    {
      "value": "PINK-CABOCHON-90",
      "display": "PINK Cabochon 90",
      "cartValue": "PINK-CABOCHON-90",
      "code": "",
      "priceDeltaCents": 0,
      "image": "",
      "imageAsset": "solea-memory-ring-configurator-cabochon-90.webp",
      "thumbnail": "",
      "thumbnailAsset": ""
    },
    {
      "value": "PINK-CABOCHON-88",
      "display": "PINK Cabochon 88",
      "cartValue": "PINK-CABOCHON-88",
      "code": "",
      "priceDeltaCents": 0,
      "image": "",
      "imageAsset": "solea-memory-ring-configurator-cabochon-88.webp",
      "thumbnail": "",
      "thumbnailAsset": ""
    },
    {
      "value": "UNICOLOR-CABOCHON-91",
      "display": "UNICOLOR Cabochon 91",
      "cartValue": "UNICOLOR-CABOCHON-91",
      "code": "",
      "priceDeltaCents": 0,
      "image": "",
      "imageAsset": "solea-memory-ring-configurator-cabochon-91.webp",
      "thumbnail": "",
      "thumbnailAsset": ""
    },
    {
      "value": "UNICOLOR-CABOCHON-92",
      "display": "UNICOLOR Cabochon 92",
      "cartValue": "UNICOLOR-CABOCHON-92",
      "code": "",
      "priceDeltaCents": 0,
      "image": "",
      "imageAsset": "solea-memory-ring-configurator-cabochon-92.webp",
      "thumbnail": "",
      "thumbnailAsset": ""
    },
    {
      "value": "UNICOLOR-CABOCHON-93",
      "display": "UNICOLOR Cabochon 93",
      "cartValue": "UNICOLOR-CABOCHON-93",
      "code": "",
      "priceDeltaCents": 0,
      "image": "",
      "imageAsset": "solea-memory-ring-configurator-cabochon-93.webp",
      "thumbnail": "",
      "thumbnailAsset": ""
    },
    {
      "value": "UNICOLOR-CABOCHON-94",
      "display": "UNICOLOR Cabochon 94",
      "cartValue": "UNICOLOR-CABOCHON-94",
      "code": "",
      "priceDeltaCents": 0,
      "image": "",
      "imageAsset": "solea-memory-ring-configurator-cabochon-94.webp",
      "thumbnail": "",
      "thumbnailAsset": ""
    },
    {
      "value": "UNICOLOR-CABOCHON-95",
      "display": "UNICOLOR Cabochon 95",
      "cartValue": "UNICOLOR-CABOCHON-95",
      "code": "",
      "priceDeltaCents": 0,
      "image": "",
      "imageAsset": "solea-memory-ring-configurator-cabochon-95.webp",
      "thumbnail": "",
      "thumbnailAsset": ""
    },
    {
      "value": "UNICOLOR-CABOCHON-98",
      "display": "UNICOLOR Cabochon 98",
      "cartValue": "UNICOLOR-CABOCHON-98",
      "code": "",
      "priceDeltaCents": 0,
      "image": "",
      "imageAsset": "solea-memory-ring-configurator-cabochon-98.webp",
      "thumbnail": "",
      "thumbnailAsset": ""
    },
    {
      "value": "UNICOLOR-CABOCHON-34",
      "display": "UNICOLOR Cabochon 34",
      "cartValue": "UNICOLOR-CABOCHON-34",
      "code": "",
      "priceDeltaCents": 0,
      "image": "",
      "imageAsset": "solea-memory-ring-configurator-cabochon-34.webp",
      "thumbnail": "",
      "thumbnailAsset": ""
    },
    {
      "value": "UNICOLOR-RINGFARBE-Black",
      "display": "UNICOLOR Black",
      "cartValue": "UNICOLOR-RINGFARBE-Black",
      "code": "",
      "priceDeltaCents": 0,
      "image": "",
      "imageAsset": "solea-memory-ring-configurator-ringfarbe-black.webp",
      "thumbnail": "",
      "thumbnailAsset": ""
    },
    {
      "value": "UNICOLOR-RINGFARBE-Green",
      "display": "UNICOLOR Green",
      "cartValue": "UNICOLOR-RINGFARBE-Green",
      "code": "",
      "priceDeltaCents": 0,
      "image": "",
      "imageAsset": "solea-memory-ring-configurator-ringfarbe-green.webp",
      "thumbnail": "",
      "thumbnailAsset": ""
    },
    {
      "value": "UNICOLOR-RINGFARBE-Lightblue",
      "display": "UNICOLOR Lightblue",
      "cartValue": "UNICOLOR-RINGFARBE-Lightblue",
      "code": "",
      "priceDeltaCents": 0,
      "image": "",
      "imageAsset": "solea-memory-ring-configurator-ringfarbe-lightblue.webp",
      "thumbnail": "",
      "thumbnailAsset": ""
    },
    {
      "value": "UNICOLOR-RINGFARBE-Lightgreen",
      "display": "UNICOLOR Lightgreen",
      "cartValue": "UNICOLOR-RINGFARBE-Lightgreen",
      "code": "",
      "priceDeltaCents": 0,
      "image": "",
      "imageAsset": "solea-memory-ring-configurator-ringfarbe-lightgreen.webp",
      "thumbnail": "",
      "thumbnailAsset": ""
    },
    {
      "value": "UNICOLOR-RINGFARBE-Orange",
      "display": "UNICOLOR Orange",
      "cartValue": "UNICOLOR-RINGFARBE-Orange",
      "code": "",
      "priceDeltaCents": 0,
      "image": "",
      "imageAsset": "solea-memory-ring-configurator-ringfarbe-orange.webp",
      "thumbnail": "",
      "thumbnailAsset": ""
    },
    {
      "value": "UNICOLOR-RINGFARBE-Pink",
      "display": "UNICOLOR Pink",
      "cartValue": "UNICOLOR-RINGFARBE-Pink",
      "code": "",
      "priceDeltaCents": 0,
      "image": "",
      "imageAsset": "solea-memory-ring-configurator-ringfarbe-pink.webp",
      "thumbnail": "",
      "thumbnailAsset": ""
    },
    {
      "value": "UNICOLOR-RINGFARBE-Red",
      "display": "UNICOLOR Red",
      "cartValue": "UNICOLOR-RINGFARBE-Red",
      "code": "",
      "priceDeltaCents": 0,
      "image": "",
      "imageAsset": "solea-memory-ring-configurator-ringfarbe-red.webp",
      "thumbnail": "",
      "thumbnailAsset": ""
    },
    {
      "value": "UNICOLOR-RINGFARBE-Violet",
      "display": "UNICOLOR Violet",
      "cartValue": "UNICOLOR-RINGFARBE-Violet",
      "code": "",
      "priceDeltaCents": 0,
      "image": "",
      "imageAsset": "solea-memory-ring-configurator-ringfarbe-violet.webp",
      "thumbnail": "",
      "thumbnailAsset": ""
    },
    {
      "value": "UNICOLOR-RINGFARBE-White",
      "display": "UNICOLOR White",
      "cartValue": "UNICOLOR-RINGFARBE-White",
      "code": "",
      "priceDeltaCents": 0,
      "image": "",
      "imageAsset": "solea-memory-ring-configurator-ringfarbe-white.webp",
      "thumbnail": "",
      "thumbnailAsset": ""
    },
    {
      "value": "UNICOLOR-RINGFARBE-Yellow",
      "display": "UNICOLOR Yellow",
      "cartValue": "UNICOLOR-RINGFARBE-Yellow",
      "code": "",
      "priceDeltaCents": 0,
      "image": "",
      "imageAsset": "solea-memory-ring-configurator-ringfarbe-yellow.webp",
      "thumbnail": "",
      "thumbnailAsset": ""
    },
    {
      "value": "UNICOLOR-RINGFARBE-G-Blue",
      "display": "UNICOLOR G Blue",
      "cartValue": "UNICOLOR-RINGFARBE-G-Blue",
      "code": "",
      "priceDeltaCents": 0,
      "image": "",
      "imageAsset": "solea-memory-ring-configurator-ringfarbe-g-blue.webp",
      "thumbnail": "",
      "thumbnailAsset": ""
    }
  ]
};
  // SOLEA memory ring shared epoxy groups
  Object.keys(MATRIX.epoxyPatternGroups).forEach(function (groupName) {
    if (MATRIX.epoxyPatternGroups[groupName] === null) {
      MATRIX.epoxyPatternGroups[groupName] = MATRIX.epoxyPatterns;
    }
  });
  var GENERATED_INPUT_SELECTOR = "[data-solea-configurator-generated]";
  var PRODUCT_PRICE_SELECTOR = ".product__price .money, .product-single__price .money, [data-product-price], [data-price-wrapper] .money, .price-item--regular, .price-item--sale";
  var PRODUCT_MEDIA_SELECTOR = ".product__photos, [data-product-images], .product-single__photos, .product__media";
  var SEARCHABLE_INITIAL_LIMIT = 18;
  var SEARCHABLE_PAGE_SIZE = 48;
  var ASSET_VERSION = String(MATRIX.generatedAt || "").replace(/[^0-9A-Za-z]+/g, "");
  var DEFAULT_PREVIEW_PLACEMENT = { x: 50, y: 50, size: 18, scaleX: 1, scaleY: 1, rotate: 0 };
  var CALIBRATION_STORAGE_KEY = "solea-memory-ring-preview-placements-v1";
  var PREVIEW_PLACEMENTS = {
    "AB_1": { x: 49.46, y: 79.72, size: 14.8, scaleX: 1.44, scaleY: 1.26, rotate: 0 },
    "AB_2": { x: 45.87, y: 78.02, size: 14.8, scaleX: 1.09, scaleY: 1, rotate: 0 },
    "AB_3": { x: 46.53, y: 81.61, size: 14.8, scaleX: 1.15, scaleY: 1.01, rotate: 0 },
    "AB_4": { x: 43.13, y: 80.66, size: 14.8, scaleX: 1.31, scaleY: 1.14, rotate: 0 },
    "AB_5": { x: 43.41, y: 81.32, size: 14.8, scaleX: 1.19, scaleY: 1.09, rotate: 0 },
    "AB_6": { x: 48.32, y: 78.96, size: 14.8, scaleX: 1.54, scaleY: 1.41, rotate: 0 },
    "AB_7": { x: 49.93, y: 81.14, size: 14.8, scaleX: 1.2, scaleY: 1.05, rotate: 0 },
    "AB_8": { x: 46.62, y: 79.43, size: 14.8, scaleX: 1.52, scaleY: 1.34, rotate: 0 },
    "AB_9": { x: 43.6, y: 80.47, size: 14.8, scaleX: 1.23, scaleY: 1.14, rotate: 0 },
    "AB_10": { x: 47.85, y: 80.47, size: 14.8, scaleX: 1.09, scaleY: 0.96, rotate: 0 },
    "AB_11": { x: 49.84, y: 80.38, size: 14.88, scaleX: 1.26, scaleY: 1.14, rotate: 0 },
    "AB_12": { x: 47.66, y: 79.06, size: 14.8, scaleX: 1.48, scaleY: 1.35, rotate: 0 },
    "AB_13": { x: 45.77, y: 80.85, size: 14.8, scaleX: 1.26, scaleY: 1.1, rotate: 0 },
    "AB_14": { x: 46.91, y: 80.1, size: 14.8, scaleX: 1.24, scaleY: 1.13, rotate: -11.2 },
    "AB_15": { x: 41.33, y: 82.36, size: 14.8, scaleX: 0.84, scaleY: 0.74, rotate: 0 },
    "AB_16": { x: 50.4, y: 79.06, size: 14.8, scaleX: 1.5, scaleY: 1.33, rotate: 0 },
    "AB_17": { x: 48.8, y: 78.58, size: 14.8, scaleX: 1.47, scaleY: 1.27, rotate: -14.2 },
    "AB_18": { x: 45.3, y: 80.19, size: 14.8, scaleX: 1.34, scaleY: 1.2, rotate: 0 },
    "AB_19": { x: 52.86, y: 76.79, size: 14.8, scaleX: 1.54, scaleY: 1.34, rotate: 0 },
    "AB_20": { x: 43.13, y: 78.3, size: 14.8, scaleX: 1.34, scaleY: 1.17, rotate: 0 },
    "AB_21": { x: 46.81, y: 81.99, size: 14.8, scaleX: 1.04, scaleY: 0.9, rotate: 0 },
    "AB_22": { x: 46.25, y: 78.81, size: 14.8, scaleX: 1.32, scaleY: 1.17, rotate: 0 },
    "AB_23": { x: 45.21, y: 80.28, size: 14.8, scaleX: 1.29, scaleY: 1.13, rotate: 7.7 },
    "AB_24": { x: 43.32, y: 79.81, size: 14.8, scaleX: 1.14, scaleY: 0.98, rotate: 0 },
    "AB_25": { x: 46.34, y: 80.0, size: 14.8, scaleX: 1.4, scaleY: 1.18, rotate: 0 },
    "AB_26": { x: 42.75, y: 80.38, size: 14.8, scaleX: 1.31, scaleY: 1.14, rotate: 0 },
    "AB_27": { x: 45.68, y: 78.68, size: 18.56, scaleX: 1.23, scaleY: 1.08, rotate: 0 },
    "AB_28": { x: 48.89, y: 77.64, size: 14.8, scaleX: 1.24, scaleY: 1.07, rotate: 0 },
    "AB_29": { x: 47.1, y: 79.15, size: 14.8, scaleX: 1.13, scaleY: 1.03, rotate: 0 },
    "AB_30": { x: 46.25, y: 77.83, size: 14.8, scaleX: 1.07, scaleY: 0.96, rotate: 0 },
    "AB_31": { x: 46.15, y: 77.92, size: 14.8, scaleX: 1.12, scaleY: 0.98, rotate: 0 },
    "AB_32": { x: 46.53, y: 76.88, size: 14.8, scaleX: 1.11, scaleY: 1.01, rotate: 0 },
    "AB_33": { x: 46.81, y: 81.7, size: 14.8, scaleX: 1.12, scaleY: 1.02, rotate: 0 },
    "AB_34": { x: 45.96, y: 78.58, size: 14.8, scaleX: 1.03, scaleY: 0.94, rotate: 0 },
    "AB_35": { x: 44.36, y: 80.76, size: 14.8, scaleX: 1.13, scaleY: 1.02, rotate: 4.5 },
    "AB_36": { x: 46.81, y: 80.28, size: 14.8, scaleX: 1.31, scaleY: 1.16, rotate: 0 },
    "AB_37": { x: 50.88, y: 80.66, size: 16.8, scaleX: 1.15, scaleY: 1, rotate: 0 },
    "AB_38": { x: 48.51, y: 80.85, size: 16.52, scaleX: 1.13, scaleY: 1, rotate: 0 },
    "AB_39": { x: 46.15, y: 78.02, size: 14.8, scaleX: 1.6, scaleY: 1.47, rotate: 0 },
    "AB_40": { x: 44.73, y: 77.17, size: 14.8, scaleX: 1.31, scaleY: 1.25, rotate: -35.2 },
    "AB_41": { x: 45.68, y: 80.28, size: 16.8, scaleX: 1.13, scaleY: 1.02, rotate: 0 },
    "AB_42": { x: 47.76, y: 80.38, size: 14.8, scaleX: 1.34, scaleY: 1.19, rotate: 0 },
    "AB_43": { x: 47.95, y: 81.04, size: 14.8, scaleX: 1.21, scaleY: 1.12, rotate: 0 },
    "AB_44": { x: 44.64, y: 80.28, size: 14.8, scaleX: 1.33, scaleY: 1.16, rotate: 0 },
    "AB_45": { x: 45.77, y: 81.14, size: 14.8, scaleX: 1.21, scaleY: 1.08, rotate: 0 },
    "AB_46": { x: 43.22, y: 80.47, size: 14.8, scaleX: 1.33, scaleY: 1.11, rotate: 0 },
    "AB_47": { x: 49.55, y: 80.57, size: 14.8, scaleX: 1.27, scaleY: 1.15, rotate: -3.2 },
    "AB_48": { x: 47.95, y: 80.47, size: 14.8, scaleX: 1.35, scaleY: 1.19, rotate: -5.4 },
    "AB_49": { x: 42.28, y: 80.66, size: 14.8, scaleX: 1.24, scaleY: 1.12, rotate: 10.6 }
  };
  PREVIEW_PLACEMENTS = Object.assign({}, PREVIEW_PLACEMENTS, MATRIX.previewPlacements || {});

  function isActive() {
    return true;
  }

  function isCalibrationMode() {
    try {
      var params = new URLSearchParams(window.location.search);
      return params.get("solea_preview_helper") === "1" || params.get("solea_calibrator") === "1";
    } catch (error) {
      return false;
    }
  }

  function clampNumber(value, min, max, fallback) {
    var number = Number.parseFloat(value);
    if (!Number.isFinite(number)) return fallback;
    return Math.max(min, Math.min(max, number));
  }

  function normalizePlacementValue(value) {
    if (!value || typeof value !== "object") return null;
    return {
      x: clampNumber(value.x, 0, 100, DEFAULT_PREVIEW_PLACEMENT.x),
      y: clampNumber(value.y, 0, 100, DEFAULT_PREVIEW_PLACEMENT.y),
      size: clampNumber(value.size, 6, 28, DEFAULT_PREVIEW_PLACEMENT.size),
      scaleX: clampNumber(value.scaleX, 0.5, 1.6, DEFAULT_PREVIEW_PLACEMENT.scaleX),
      scaleY: clampNumber(value.scaleY, 0.5, 1.6, DEFAULT_PREVIEW_PLACEMENT.scaleY),
      rotate: clampNumber(value.rotate, -180, 180, DEFAULT_PREVIEW_PLACEMENT.rotate),
    };
  }

  function readCalibrationMap() {
    if (!isCalibrationMode()) return Object.create(null);
    try {
      var raw = window.localStorage && window.localStorage.getItem(CALIBRATION_STORAGE_KEY);
      var parsed = raw ? JSON.parse(raw) : {};
      var map = Object.create(null);
      Object.keys(parsed || {}).forEach(function (code) {
        var placement = normalizePlacementValue(parsed[code]);
        if (placement) map[code] = placement;
      });
      return map;
    } catch (error) {
      return Object.create(null);
    }
  }

  function writeCalibrationMap(map) {
    if (!isCalibrationMode()) return;
    try {
      window.localStorage.setItem(CALIBRATION_STORAGE_KEY, JSON.stringify(map || {}));
    } catch (error) {
      /* localStorage can be disabled in private contexts. */
    }
  }

  function copyText(text) {
    if (navigator.clipboard && navigator.clipboard.writeText) {
      return navigator.clipboard.writeText(text);
    }
    return new Promise(function (resolve, reject) {
      try {
        var textarea = document.createElement("textarea");
        textarea.value = text;
        textarea.setAttribute("readonly", "readonly");
        textarea.style.position = "fixed";
        textarea.style.left = "-9999px";
        document.body.append(textarea);
        textarea.select();
        document.execCommand("copy");
        textarea.remove();
        resolve();
      } catch (error) {
        reject(error);
      }
    });
  }

  function formatMoney(cents) {
    return new Intl.NumberFormat("de-AT", {
      style: "currency",
      currency: MATRIX.currency,
    }).format(cents / 100);
  }

  function assetBaseUrl(root) {
    return String(root.dataset.assetBaseUrl || "").replace(/[^/]*$/, "");
  }

  function resolveAssetUrl(root, assetName) {
    if (!assetName) return "";
    var base = assetBaseUrl(root);
    if (!base) return "";
    return base + assetName + (ASSET_VERSION ? "?v=" + ASSET_VERSION : "");
  }

  function resizedThemeAssetUrl(url, width) {
    if (!url || !width || !/\/cdn\/shop\/t\/\d+\/assets\//.test(url) || /[?&]width=/.test(url)) return url;
    return url + (url.indexOf("?") === -1 ? "?" : "&") + "width=" + Math.round(width);
  }

  function optionImageUrl(root, option, key) {
    if (!option) return "";
    if (key === "thumbnail" && option.thumbnailAsset) return resizedThemeAssetUrl(resolveAssetUrl(root, option.thumbnailAsset), 240);
    if (key === "thumbnail" && option.thumbnail) return option.thumbnail;
    if (option.imageAsset) {
      var imageAssetUrl = resolveAssetUrl(root, option.imageAsset);
      return key === "thumbnail" ? resizedThemeAssetUrl(imageAssetUrl, 240) : imageAssetUrl;
    }
    return option.image || "";
  }

  function fieldValue(fieldIndex, state) {
    if (fieldIndex === 1) return state.material || "";
    if (fieldIndex >= 2 && fieldIndex <= 4) return state.shellSize || "";
    if (fieldIndex >= 5 && fieldIndex <= 16) return state.epoxyPattern || "";
    if (fieldIndex === 17) return state.memoryObject || "";
    if (fieldIndex === 18) return state.memoryVisibility || "";
    return "";
  }

  function matchesCondition(condition, state) {
    if (!condition) return true;
    var checks = condition.clauses.map(function (clause) {
      var value = fieldValue(clause.fieldIndex, state);
      return clause.values.indexOf(value) !== -1;
    });
    return condition.type === "or" ? checks.some(Boolean) : checks.every(Boolean);
  }

  function activeBranch(state) {
    return (MATRIX.chainBranches || []).find(function (branch) {
      return matchesCondition(branch.condition, state);
    }) || null;
  }

  function firstMatchingRule(rules, state) {
    return rules.find(function (rule) {
      return matchesCondition(rule.condition, state);
    }) || null;
  }

  function selectedOption(options, value) {
    return (options || []).find(function (option) {
      return option.value === value;
    }) || null;
  }

  function epoxyOptionsForRule(rule) {
    if (!rule) return MATRIX.epoxyPatterns;
    return (MATRIX.epoxyPatternGroups && MATRIX.epoxyPatternGroups[rule.optionGroup]) || MATRIX.epoxyPatterns;
  }

  function currentFields(state) {
    var fields = [
      {
        id: "material",
        property: "Material w\u00e4hlen",
        label: "Material w\u00e4hlen",
        options: MATRIX.materials,
        required: true,
      },
    ];

    var shellRule = state.material ? firstMatchingRule(MATRIX.shellRules, state) : null;
    if (shellRule) {
      fields.push({
        id: "shellSize",
        property: "Schalengr\u00f6\u00dfe w\u00e4hlen",
        label: "Schalengr\u00f6\u00dfe w\u00e4hlen",
        options: shellRule.options,
        required: true,
        autoSelectSingle: true,
      });
    }

    var epoxyRule = state.shellSize ? firstMatchingRule(MATRIX.epoxyRules, state) : null;
    if (epoxyRule) {
      fields.push({
        id: "epoxyPattern",
        property: "Epoxiddesign w\u00e4hlen",
        label: "Epoxiddesign w\u00e4hlen",
        options: epoxyOptionsForRule(epoxyRule),
        required: true,
        searchable: true,
      });
    }

    if (state.epoxyPattern) {
      fields.push({
        id: "memoryObject",
        property: "Erinnerung beschreiben",
        label: "Erinnerung beschreiben",
        options: MATRIX.memoryObjectOptions,
        required: true,
      });
    }

    if (state.memoryObject) {
      fields.push({
        id: "memoryVisibility",
        property: "Sichtbarkeit der Erinnerung",
        label: "Sichtbarkeit der Erinnerung",
        options: MATRIX.memoryVisibilityOptions,
        required: true,
      });
    }

    if (state.memoryVisibility) {
      fields.push({
        id: "additionalInfo",
        property: "Zus\u00e4tzliche Infos an uns (optional)",
        label: "Zus\u00e4tzliche Infos an uns (optional)",
        type: "textarea",
        placeholder: "Falls du uns noch etwas zur Erinnerung oder Gestaltung sagen m\u00f6chtest, kannst du es hier eintragen.",
        required: false,
      });
    }

    return fields;
  }

  function normalizeState(state) {
    var changed = true;
    var guard = 0;

    while (changed && guard < 12) {
      changed = false;
      guard += 1;

      var fields = currentFields(state);
      var visibleIds = fields.map(function (field) { return field.id; });
      Object.keys(state).forEach(function (key) {
        if (visibleIds.indexOf(key) === -1) {
          delete state[key];
          changed = true;
        }
      });

      fields.forEach(function (field) {
        if (field.type === "textarea") return;
        var current = state[field.id];
        var stillValid = current && field.options.some(function (option) {
          return option.value === current;
        });
        if (current && !stillValid) {
          delete state[field.id];
          changed = true;
        }
        if (!state[field.id] && field.autoSelectSingle && field.options.length === 1) {
          state[field.id] = field.options[0].value;
          changed = true;
        }
      });
    }
  }

  var START_SUGGESTION_FIELD_IDS = {
    material: true,
    braceletType: true,
    chainStyle: true,
    length: true,
    shellSize: true,
    ringSize: true,
    epoxyPattern: true,
  };

  function firstStartSuggestionOption(field) {
    if (!field || field.type === "textarea" || !START_SUGGESTION_FIELD_IDS[field.id]) return null;
    if (!field.options || !field.options.length) return null;
    return field.options.find(function (option) {
      return option && option.value;
    }) || null;
  }

  function applyStartSuggestion(state) {
    var guard = 0;
    while (guard < 12) {
      guard += 1;
      normalizeState(state);
      var fields = currentFields(state);
      var missing = fields.find(function (field) {
        return !state[field.id] && firstStartSuggestionOption(field);
      });
      if (!missing) break;
      state[missing.id] = firstStartSuggestionOption(missing).value;
    }
    normalizeState(state);
  }

  function ensureStartSuggestionNote(root) {
    if (root.querySelector("[data-start-suggestion-note]")) return;
    var status = root.querySelector("[data-status]");
    if (!status || !status.parentElement) return;
    var note = document.createElement("div");
    note.className = "solea-configurator__start-note";
    note.dataset.startSuggestionNote = "true";
    note.textContent = "Startvorschlag - du kannst alles anpassen.";
    status.parentElement.insertBefore(note, status);
  }

  function localizedPropertyText(value) {
    var text = String(value || "");
    var i18n = MATRIX.soleaI18n || {};
    var exact = i18n.exact || {};
    var templates = i18n.templates || {};
    if (exact[text]) return exact[text];
    var extension = text.match(/^(.+?cm); inkl\. (.+?mm) Verl\u00e4ngerungskettchen$/);
    if (extension && templates.braceletLengthExtension) {
      return templates.braceletLengthExtension.replace("{length}", extension[1]).replace("{extension}", extension[2]);
    }
    var layers = text.match(/^(.+?)(:|;)\s*(Double-Layer|Triple-Layer)$/);
    if (layers && exact[layers[3]]) return layers[1] + layers[2] + " " + exact[layers[3]];
    return text;
  }

  function selectedProperties(state) {
    return currentFields(state).reduce(function (properties, field) {
      if (field.type === "textarea") {
        var textValue = String(state[field.id] || "").trim();
        if (textValue) properties[localizedPropertyText(field.property)] = textValue;
        return properties;
      }

      var option = selectedOption(field.options, state[field.id]);
      var propertyLabel = localizedPropertyText(field.property);
      if (option && field.id === "epoxyPattern") {
        properties[propertyLabel] = localizedPropertyText("Ausgew\u00e4hlt");
        properties["_SOLEA Epoxiddesign"] = option.cartValue || option.value;
      } else if (option) {
        properties[propertyLabel] = localizedPropertyText(option.cartValue || option.value);
      }
      return properties;
    }, {});
  }

  function priceParts(state) {
    var fields = currentFields(state);
    var selected = fields
      .map(function (field) {
        if (field.type === "textarea") return null;
        var option = selectedOption(field.options, state[field.id]);
        return option ? { field: field, option: option } : null;
      })
      .filter(Boolean);
    var extras = selected.reduce(function (sum, item) {
      return sum + (item.option.priceDeltaCents || 0);
    }, 0);

    return {
      base: MATRIX.basePriceCents,
      extras: extras,
      total: MATRIX.basePriceCents + extras,
      selected: selected,
    };
  }



  function soleaConfigOptionText(option) {
    if (!option) return "";
    return option.cartValue || option.display || option.value || "";
  }

  function soleaConfigSelectedField(field, state) {
    var value = state[field.id] || "";
    if (field.type === "textarea") {
      return {
        label: field.label || field.property || field.id,
        value: value,
        display: String(value || "").trim(),
        cartValue: String(value || "").trim(),
        code: "",
        imageAsset: "",
        thumbnailAsset: "",
        priceDeltaCents: 0
      };
    }

    var option = selectedOption(field.options, value);
    return {
      label: field.label || field.property || field.id,
      value: value,
      display: soleaConfigOptionText(option),
      cartValue: option ? (option.cartValue || option.value || "") : "",
      code: option && option.code ? option.code : "",
      imageAsset: option && option.imageAsset ? option.imageAsset : "",
      thumbnailAsset: option && option.thumbnailAsset ? option.thumbnailAsset : "",
      priceDeltaCents: option && option.priceDeltaCents ? option.priceDeltaCents : 0
    };
  }

  function soleaConfigShellOption(state) {
    if (!MATRIX.shellRules || !MATRIX.shellRules.length || typeof firstMatchingRule !== "function") return null;
    var shellRule = firstMatchingRule(MATRIX.shellRules, state);
    return selectedOption((shellRule || { options: [] }).options, state.shellSize);
  }

  function soleaConfigChainOption(state) {
    if (!state.chainStyle || typeof activeBranch !== "function") return null;
    return selectedOption((activeBranch(state) || { options: [] }).options, state.chainStyle);
  }

  function soleaConfigPlacementSnapshot(code, epoxyOption) {
    if (!code) return null;
    var base = Object.assign({}, DEFAULT_PREVIEW_PLACEMENT || {}, (PREVIEW_PLACEMENTS && PREVIEW_PLACEMENTS[code]) || {});
    var previewScale = epoxyOption && Number.isFinite(Number(epoxyOption.previewScale)) ? Number(epoxyOption.previewScale) : 1;
    return {
      x: Number(base.x || 0),
      y: Number(base.y || 0),
      size: Number((Number(base.size || 0) * previewScale).toFixed(4)),
      scaleX: Number(base.scaleX || 1),
      scaleY: Number(base.scaleY || 1),
      rotate: Number(base.rotate || 0)
    };
  }

  function buildSoleaConfigSnapshot(state) {
    var prices = priceParts(state);
    var selections = {};
    currentFields(state).forEach(function (field) {
      selections[field.id] = soleaConfigSelectedField(field, state);
    });

    var chain = soleaConfigChainOption(state);
    var shell = soleaConfigShellOption(state);
    var epoxy = selectedOption(MATRIX.epoxyPatterns || [], state.epoxyPattern);
    var placementCode = (chain && chain.code) || (shell && (shell.code || shell.value || shell.display)) || "";

    return {
      version: 1,
      handle: MATRIX.targetHandle || "",
      source: MATRIX.source || "",
      generatedAt: new Date().toISOString(),
      currency: MATRIX.currency || "EUR",
      basePriceCents: prices.base || 0,
      extrasCents: prices.extras || 0,
      totalCents: prices.total || 0,
      selections: selections,
      preview: {
        chainCode: chain && chain.code ? chain.code : "",
        placementCode: placementCode,
        chainImageAsset: chain && chain.imageAsset ? chain.imageAsset : "",
        shellSize: shell ? (shell.cartValue || shell.value || shell.display || "") : "",
        shellImageAsset: shell && shell.imageAsset ? shell.imageAsset : "",
        epoxyDesign: epoxy ? (epoxy.cartValue || epoxy.display || epoxy.value || "") : "",
        epoxyImageAsset: epoxy && epoxy.imageAsset ? epoxy.imageAsset : "",
        epoxyThumbnailAsset: epoxy && epoxy.thumbnailAsset ? epoxy.thumbnailAsset : "",
        placement: soleaConfigPlacementSnapshot(placementCode, epoxy)
      }
    };
  }

  function configuredProperties(state) {
    var properties = selectedProperties(state);
    var prices = priceParts(state);
    properties["_SOLEA Konfiguratorpreis EUR"] = (prices.total / 100).toFixed(2);
    properties["_SOLEA Aufpreis EUR"] = (prices.extras / 100).toFixed(2);

    var soleaConfigSnapshot = buildSoleaConfigSnapshot(state);
    properties["_SOLEA Config Version"] = String(soleaConfigSnapshot.version || 1);
    properties["_SOLEA Config JSON"] = JSON.stringify(soleaConfigSnapshot);

    return properties;
  }

  function formQuantity(cartForm) {
    var quantityInput = cartForm.querySelector("[name='quantity']");
    var quantity = quantityInput ? Number.parseInt(quantityInput.value, 10) : 1;
    return Number.isFinite(quantity) && quantity > 0 ? quantity : 1;
  }

  function randomPricingRef() {
    return String(Math.floor((Math.random() * 1000000000) + 1));
  }

  var soleaSurchargeVariantMapCache = null;

  function soleaSurchargeVariantMap() {
    if (soleaSurchargeVariantMapCache) return soleaSurchargeVariantMapCache;
    var node = document.querySelector("script[data-solea-surcharge-variant-map]");
    var map = null;
    try {
      map = node ? JSON.parse(node.textContent || "{}") : null;
    } catch (error) {
      map = null;
    }
    if (!map || typeof map !== "object" || Array.isArray(map)) {
      throw new Error("Die gewählte Designoption ist derzeit nicht verfügbar. Bitte lade die Seite neu und versuche es erneut.");
    }
    soleaSurchargeVariantMapCache = map;
    return map;
  }

  function exactSurchargeLine(state) {
    var prices = priceParts(state);
    var cartBasePrice = MATRIX.shopifyBasePriceCents || MATRIX.basePriceCents || 0;
    var surchargeCents = Math.max(0, prices.total - cartBasePrice);
    if (surchargeCents === 0) return null;
    var variantId = Number(soleaSurchargeVariantMap()[String(surchargeCents)]);
    if (!Number.isSafeInteger(variantId) || variantId <= 0) {
      throw new Error("Die gewählte Designoption ist derzeit nicht verfügbar. Bitte lade die Seite neu und versuche es erneut.");
    }
    return {
      variantId: variantId,
      surchargeCents: surchargeCents,
    };
  }

  function buildCartItems(state, cartForm) {
    var quantity = formQuantity(cartForm);
    var properties = configuredProperties(state);
    var surchargeLine = exactSurchargeLine(state);
    var items = [];

    if (surchargeLine) {
      if (quantity !== 1) {
        throw new Error("Konfigurierte Schmuckstücke können nur einzeln in den Warenkorb gelegt werden.");
      }
      var pricingRef = randomPricingRef();
      properties._pc_pricing_ref = pricingRef;
      items.push({
        id: surchargeLine.variantId,
        quantity: 1,
        properties: {
          _pc_pricing_ref: pricingRef,
        },
      });
    }

    items.push({
      id: Number(MATRIX.variantId),
      quantity: quantity,
      properties: properties,
    });

    return items;
  }

  function disableSubmit(cartForm, disabled) {
    cartForm.querySelectorAll("button[type='submit'], [name='add'], input[type='submit']").forEach(function (button) {
      button.disabled = disabled;
      if (disabled) {
        button.dataset.soleaSubmitting = "true";
      } else {
        delete button.dataset.soleaSubmitting;
      }
    });
  }

  function formSubmitControls(cartForm) {
    return Array.from(cartForm.querySelectorAll("button[name='add'], [name='add'], button[type='submit'], input[type='submit']"))
      .filter(function (button) {
        return !button.dataset.soleaMemorySubmit;
      });
  }

  function parseCartError(response, payload) {
    if (payload && typeof payload === "object") {
      return payload.description || payload.message || "Shopify hat die Warenkorb-Aktion abgelehnt.";
    }
    return response.status + " " + response.statusText;
  }

  function addConfiguredItems(items) {
    return fetch("/cart/add.js", {
      method: "POST",
      credentials: "same-origin",
      headers: {
        accept: "application/json",
        "content-type": "application/json",
      },
      body: JSON.stringify({ items: items }),
    }).then(function (response) {
      return response.json().catch(function () {
        return {};
      }).then(function (payload) {
        if (!response.ok) {
          throw new Error(parseCartError(response, payload));
        }
        return payload;
      });
    });
  }

  function missingFields(state) {
    return currentFields(state)
      .filter(function (field) {
        return field.required && !state[field.id];
      })
      .map(function (field) {
        return field.label;
      });
  }

  function createGeneratedInput(name, value) {
    var input = document.createElement("input");
    input.type = "hidden";
    input.name = name;
    input.value = value;
    input.dataset.soleaConfiguratorGenerated = "true";
    return input;
  }

  function findCartForm(root) {
    var section = root.closest("[data-section-type='product'], .product-section") || document;
    var byId = root.dataset.productFormId ? document.getElementById(root.dataset.productFormId) : null;
    return byId || section.querySelector("form[action*='/cart/add'], form.product-single__form") || document.querySelector("form[action*='/cart/add'], form.product-single__form");
  }

  function updateCartInputs(cartForm, state) {
    cartForm.querySelectorAll(GENERATED_INPUT_SELECTOR).forEach(function (input) {
      input.remove();
    });

    Object.entries(configuredProperties(state)).forEach(function (entry) {
      cartForm.append(createGeneratedInput("properties[" + entry[0] + "]", entry[1]));
    });

    var variantInput = cartForm.querySelector("[name='id']");
    if (variantInput && MATRIX.variantId) {
      variantInput.value = MATRIX.variantId;
    }
  }

  function updateProductPrice(total) {
    document.querySelectorAll(PRODUCT_PRICE_SELECTOR).forEach(function (element) {
      if (!element.dataset.soleaOriginalPrice) {
        element.dataset.soleaOriginalPrice = element.textContent;
      }
      element.textContent = formatMoney(total);
    });
  }

  function restoreProductPrice() {
    document.querySelectorAll(PRODUCT_PRICE_SELECTOR).forEach(function (element) {
      if (element.dataset.soleaOriginalPrice) {
        element.textContent = element.dataset.soleaOriginalPrice;
      }
    });
  }

  function initRoot(root) {
    if (root.dataset.productHandle !== MATRIX.targetHandle) return;

    var cartForm = findCartForm(root);
    if (!cartForm) return;

    var soleaI18n = { exact: {} };
    var soleaI18nNode = document.querySelector("script[data-solea-configurator-i18n]");
    if (soleaI18nNode) {
      try { soleaI18n = JSON.parse(soleaI18nNode.textContent || "{}"); } catch (error) {}
    }
    MATRIX.soleaI18n = soleaI18n;

    function configuratorText(source) {
      var exact = soleaI18n.exact || {};
      return exact[source] || source;
    }

    var state = Object.create(null);
    var searchQueries = Object.create(null);
    var optionLimits = Object.create(null);
    var epoxyPatternGroup = "";
    var epoxyGroupScrollLeft = 0;
    var activeFieldId = "";
    var calibrationMode = isCalibrationMode();
    var calibrationMap = readCalibrationMap();
    var calibrationDrafts = Object.create(null);
    var fieldsRoot = root.querySelector("[data-fields]");
    var progressBar = root.querySelector("[data-progress-bar]");
    var status = root.querySelector("[data-status]");
    var resetButton = root.querySelector("[data-reset]");
    var priceTotal = root.querySelector("[data-price-total]");
    var priceNote = root.querySelector("[data-price-note]");
    var preview = ensureProductPreview(root);
    var previewZoomMode = "detail";
    var previewZoom = createPreviewZoom();
    var previewZoomPreviousFocus = null;
    var previewSyncFrame = 0;

    applyStartSuggestion(state);
    ensureStartSuggestionNote(root);
    root.hidden = false;
    document.documentElement.classList.add("solea-configurator-active");
    if (document.body) document.body.classList.add("solea-configurator-active");
    if (calibrationMode) {
      root.classList.add("solea-configurator--calibration");
      document.documentElement.classList.add("solea-configurator-calibration-active");
    }

    function productPreviewHost() {
      var host = document.querySelector(".product__photos") || document.querySelector("[data-product-images]");
      if (host) host.classList.add("solea-configurator-preview-host");
      return host;
    }

    function syncPreviewHost() {
      if (!preview) return;
      var productHost = productPreviewHost();
      var mobile = isMobileLayout();
      var target = mobile ? root : productHost || root;
      preview.classList.toggle("solea-configurator-preview-media--mobile-sticky", mobile && target === root);
      if (preview.parentElement !== target) {
        target.insertBefore(preview, target.firstChild);
      }
    }

    function schedulePreviewHostSync() {
      if (previewSyncFrame) return;
      previewSyncFrame = window.requestAnimationFrame(function () {
        previewSyncFrame = 0;
        syncPreviewHost();
        renderPreview();
      });
    }

    function setStatus(message, stateName) {
      status.textContent = message;
      if (stateName) {
        status.dataset.state = stateName;
      } else {
        delete status.dataset.state;
      }
    }

    function calibrationControl(key, label, min, max, step) {
      var wrapper = document.createElement("label");
      wrapper.className = "solea-configurator-calibrator__control";

      var text = document.createElement("span");
      text.textContent = label;

      var input = document.createElement("input");
      input.type = "number";
      input.min = String(min);
      input.max = String(max);
      input.step = String(step);
      input.dataset.calibrationInput = key;
      input.addEventListener("input", function () {
        updateCalibrationDraft(key, input.value);
      });

      wrapper.append(text, input);
      return wrapper;
    }

    function createCalibrationPanel() {
      var panel = document.createElement("div");
      panel.className = "solea-configurator-calibrator";
      panel.dataset.previewCalibrator = "true";
      panel.hidden = true;

      var header = document.createElement("div");
      header.className = "solea-configurator-calibrator__header";

      var title = document.createElement("strong");
      title.dataset.calibrationTitle = "true";
      title.textContent = "Overlay-Kalibrierung";

      var hint = document.createElement("span");
      hint.textContent = "Im Bild ziehen, Gr\u00f6\u00dfe, Ellipse und Drehung feinjustieren.";

      header.append(title, hint);

      var controls = document.createElement("div");
      controls.className = "solea-configurator-calibrator__controls";
      controls.append(
        calibrationControl("x", "X", 0, 100, 0.05),
        calibrationControl("y", "Y", 0, 100, 0.05),
        calibrationControl("size", "Gr\u00f6\u00dfe", 6, 28, 0.05),
        calibrationControl("scaleX", "Ellipse B", 0.5, 1.6, 0.01),
        calibrationControl("scaleY", "Ellipse H", 0.5, 1.6, 0.01),
        calibrationControl("rotate", "Drehung", -45, 45, 0.1)
      );

      var actions = document.createElement("div");
      actions.className = "solea-configurator-calibrator__actions";

      var save = document.createElement("button");
      save.type = "button";
      save.dataset.calibrationSave = "true";
      save.textContent = "OK speichern";
      save.addEventListener("click", saveCalibrationPlacement);

      var reset = document.createElement("button");
      reset.type = "button";
      reset.dataset.calibrationReset = "true";
      reset.textContent = "Reset";
      reset.addEventListener("click", resetCalibrationPlacement);

      var copy = document.createElement("button");
      copy.type = "button";
      copy.dataset.calibrationCopy = "true";
      copy.textContent = "JSON kopieren";
      copy.addEventListener("click", copyCalibrationPlacements);

      actions.append(save, reset, copy);

      var status = document.createElement("p");
      status.className = "solea-configurator-calibrator__status";
      status.dataset.calibrationStatus = "true";
      status.textContent = "Noch kein Ring ausgew\u00e4hlt.";

      panel.append(header, controls, actions, status);
      return panel;
    }

    function createPreviewZoom() {
      var overlay = document.createElement("div");
      overlay.className = "solea-configurator-preview-zoom solea-configurator-preview-zoom--necklace";
      overlay.hidden = true;
      overlay.setAttribute("aria-hidden", "true");
      overlay.setAttribute("role", "dialog");
      overlay.setAttribute("aria-modal", "true");
      overlay.setAttribute("aria-label", configuratorText("Vorschau vergr\u00f6\u00dfern"));

      var dialog = document.createElement("div");
      dialog.className = "solea-configurator-preview-zoom__dialog";
      dialog.setAttribute("role", "document");

      var close = document.createElement("button");
      close.type = "button";
      close.className = "solea-configurator-preview-zoom__close";
      close.setAttribute("aria-label", configuratorText("Vorschau schliessen"));
      close.textContent = "X";
      close.addEventListener("click", closePreviewZoom);

      var modes = document.createElement("div");
      modes.className = "solea-configurator-preview-zoom__modes";

      function zoomModeButton(mode, label) {
        var button = document.createElement("button");
        button.type = "button";
        button.className = "solea-configurator-preview-zoom__mode";
        button.dataset.previewZoomMode = mode;
        button.textContent = label;
        button.addEventListener("click", function () {
          previewZoomMode = mode;
          populatePreviewZoom();
        });
        return button;
      }

      modes.append(
        zoomModeButton("detail", configuratorText("Detailansicht")),
        zoomModeButton("full", configuratorText("Gesamtansicht"))
      );

      var content = document.createElement("div");
      content.className = "solea-configurator-preview-zoom__content";
      content.dataset.previewZoomContent = "true";

      dialog.append(close, modes, content);
      overlay.append(dialog);
      overlay.addEventListener("click", function (event) {
        if (event.target === overlay) closePreviewZoom();
      });

      document.addEventListener("keydown", function (event) {
        if (!overlay.hidden && event.key === "Escape") closePreviewZoom();
      });

      if (document.body) document.body.append(overlay);
      return overlay;
    }

    function bindPreviewNode(panel) {
      if (!panel) return panel;
      var stage = panel.querySelector("[data-preview-zoom-trigger]");
      if (stage && stage.dataset.soleaPreviewBound !== "true") {
        stage.dataset.soleaPreviewBound = "true";
        stage.addEventListener("click", openPreviewZoom);
        stage.addEventListener("keydown", function (event) {
          if (event.key !== "Enter" && event.key !== " ") return;
          event.preventDefault();
          openPreviewZoom();
        });
      }
      if (calibrationMode && !panel.querySelector("[data-preview-calibrator]")) {
        panel.append(createCalibrationPanel());
      }
      panel.removeAttribute("data-solea-ssr-preview");
      return panel;
    }

    function createPreviewNode() {
      var panel = document.createElement("section");
      panel.className = "solea-configurator-preview-media";
      panel.dataset.soleaPreview = "true";
      panel.setAttribute("aria-label", configuratorText("Live-Vorschau deiner Ring-Konfiguration"));

      var stage = document.createElement("div");
      stage.className = "solea-configurator-preview-media__stage";
      stage.tabIndex = 0;
      stage.setAttribute("role", "button");
      stage.dataset.previewZoomTrigger = "true";

      var chainImage = document.createElement("img");
      chainImage.className = "solea-configurator-preview-media__chain";
      chainImage.dataset.previewChain = "true";
      chainImage.alt = "";
      chainImage.loading = "eager";
      chainImage.fetchPriority = "high";

      var pendant = document.createElement("div");
      pendant.className = "solea-configurator-preview-media__pendant";
      pendant.dataset.previewPendant = "true";

      var epoxyImage = document.createElement("img");
      epoxyImage.dataset.previewEpoxy = "true";
      epoxyImage.alt = "";
      epoxyImage.loading = "eager";
      pendant.append(epoxyImage);

      var placeholder = document.createElement("div");
      placeholder.className = "solea-configurator-preview-media__placeholder";
      placeholder.textContent = configuratorText("W\u00e4hle Material, Gr\u00f6\u00dfe und Epoxiddesign");

      var zoomHint = document.createElement("span");
      zoomHint.className = "visually-hidden";
      zoomHint.textContent = configuratorText("Vorschau vergr\u00f6\u00dfern");

      stage.append(chainImage, pendant, placeholder, zoomHint);

      var caption = document.createElement("div");
      caption.className = "solea-configurator-preview-media__caption";

      var title = document.createElement("strong");
      title.dataset.previewTitle = "true";
      title.textContent = configuratorText("Vorschau");

      var details = document.createElement("span");
      details.dataset.previewDetails = "true";
      details.textContent = configuratorText("Noch keine Auswahl");

      caption.append(title, details);
      panel.append(stage, caption);
      return bindPreviewNode(panel);
    }

    function isMobileLayout() {
      return window.matchMedia && window.matchMedia("(max-width: 749px)").matches;
    }

    function ensureProductPreview(rootNode) {
      var productHost = document.querySelector(".product__photos") || document.querySelector("[data-product-images]");
      if (productHost) productHost.classList.add("solea-configurator-preview-host");

      var host = isMobileLayout() ? rootNode : productHost || rootNode;
      var previous = rootNode.previousElementSibling;
      var existing = previous && previous.matches("[data-solea-preview][data-solea-ssr-preview]")
        ? previous
        : rootNode.querySelector("[data-solea-preview]");
      if (!existing && productHost) existing = productHost.querySelector("[data-solea-preview]");
      if (!existing) {
        existing = Array.prototype.find.call(document.querySelectorAll("[data-solea-preview][data-solea-ssr-preview]"), function (candidate) {
          return candidate.dataset.productHandle === rootNode.dataset.productHandle
            && (!candidate.dataset.previewFormId || candidate.dataset.previewFormId === rootNode.dataset.productFormId);
        }) || null;
      }

      var node = bindPreviewNode(existing || createPreviewNode());
      if (host === rootNode && isMobileLayout()) {
        node.classList.add("solea-configurator-preview-media--mobile-sticky");
      } else {
        node.classList.remove("solea-configurator-preview-media--mobile-sticky");
      }
      if (node.parentElement !== host && host === rootNode) {
        rootNode.insertBefore(node, rootNode.firstChild);
      } else if (node.parentElement !== host) {
        host.insertBefore(node, host.firstChild);
      }
      document.documentElement.classList.add("solea-configurator-preview-active");
      return node;
    }

    function previewDetailScale(placement) {
      var size = placement && Number.isFinite(Number(placement.size)) ? Number(placement.size) : DEFAULT_PREVIEW_PLACEMENT.size;
      return Math.max(3.7, Math.min(5.4, 40 / Math.max(size, 1)));
    }

    function updatePreviewZoomModeButtons() {
      if (!previewZoom) return;
      previewZoom.classList.toggle("is-detail", previewZoomMode === "detail");
      previewZoom.classList.toggle("is-full", previewZoomMode !== "detail");
      previewZoom.querySelectorAll("[data-preview-zoom-mode]").forEach(function (button) {
        var active = button.dataset.previewZoomMode === previewZoomMode;
        button.classList.toggle("is-active", active);
        button.setAttribute("aria-pressed", active ? "true" : "false");
      });
    }

    function applyDetailPreviewZoom(stageClone) {
      var chain = selectedPreviewChain();
      if (previewZoomMode !== "detail" || !chain) return;

      var shell = selectedShell(state);
      var placement = previewPlacement(chain, shell);
      var detailScale = previewDetailScale(placement);
      var layer = document.createElement("div");
      layer.className = "solea-configurator-preview-zoom__detail-layer";

      stageClone.classList.add("solea-configurator-preview-zoom__stage--detail");
      stageClone.style.setProperty("--detail-zoom-scale", detailScale);
      stageClone.style.setProperty("--detail-zoom-left", (50 - (placement.x * detailScale)) + "%");
      stageClone.style.setProperty("--detail-zoom-top", (50 - (placement.y * detailScale)) + "%");

      while (stageClone.firstChild) {
        layer.append(stageClone.firstChild);
      }
      stageClone.append(layer);
    }

    function populatePreviewZoom() {
      if (!previewZoom || !preview) return false;
      var content = previewZoom.querySelector("[data-preview-zoom-content]");
      if (!content) return false;
      var stage = preview.querySelector(".solea-configurator-preview-media__stage");
      if (!stage) return false;
      if (!selectedPreviewChain()) previewZoomMode = "full";
      updatePreviewZoomModeButtons();

      content.textContent = "";
      var stageClone = stage.cloneNode(true);
      stageClone.classList.add("solea-configurator-preview-zoom__stage");
      stageClone.removeAttribute("tabindex");
      stageClone.removeAttribute("role");
      stageClone.removeAttribute("aria-label");
      stageClone.removeAttribute("data-preview-zoom-trigger");
      stageClone.querySelectorAll("img[data-full-src]").forEach(function (image) {
        image.removeAttribute("srcset");
        image.removeAttribute("sizes");
        image.src = image.dataset.fullSrc;
      });
      applyDetailPreviewZoom(stageClone);
      content.append(stageClone);

      var caption = preview.querySelector(".solea-configurator-preview-media__caption");
      if (caption) {
        var captionClone = caption.cloneNode(true);
        captionClone.classList.add("solea-configurator-preview-zoom__caption");
        content.append(captionClone);
      }
      return true;
    }

    function openPreviewZoom() {
      previewZoomMode = selectedPreviewChain() ? "detail" : "full";
      if (!previewZoom || calibrationMode || !populatePreviewZoom()) return;
      previewZoomPreviousFocus = document.activeElement;
      previewZoom.hidden = false;
      previewZoom.setAttribute("aria-hidden", "false");
      document.documentElement.classList.add("solea-configurator-preview-zoom-open");
      if (document.body) document.body.classList.add("solea-configurator-preview-zoom-open");
      var close = previewZoom.querySelector(".solea-configurator-preview-zoom__close");
      if (close) close.focus({ preventScroll: true });
    }

    function closePreviewZoom() {
      if (!previewZoom || previewZoom.hidden) return;
      previewZoom.hidden = true;
      previewZoom.setAttribute("aria-hidden", "true");
      document.documentElement.classList.remove("solea-configurator-preview-zoom-open");
      if (document.body) document.body.classList.remove("solea-configurator-preview-zoom-open");
      if (previewZoomPreviousFocus && typeof previewZoomPreviousFocus.focus === "function") {
        previewZoomPreviousFocus.focus({ preventScroll: true });
      }
    }

    function setPreviewImage(image, src, alt, previewWidth) {
      if (!image) return;
      if (src) {
        image.hidden = false;
        var previewMode = previewWidth ? String(previewWidth) : "full";
        var hasMatchingResponsiveSource = image.dataset.fullSrc === src && image.hasAttribute("srcset");
        if (image.dataset.fullSrc !== src
          || (!hasMatchingResponsiveSource && image.dataset.soleaPreviewMode !== previewMode)) {
          image.removeAttribute("srcset");
          image.removeAttribute("sizes");
          image.dataset.fullSrc = src;
          image.dataset.soleaPreviewMode = previewMode;
          image.src = previewWidth ? resizedThemeAssetUrl(src, previewWidth) : src;
        }
        image.alt = alt || "";
      } else {
        image.hidden = true;
        image.removeAttribute("src");
        image.removeAttribute("data-full-src");
        image.removeAttribute("data-solea-preview-mode");
        image.alt = "";
      }
    }

    function selectedShellRule(state) {
      return state.material ? firstMatchingRule(MATRIX.shellRules, state) : null;
    }

    function selectedShell(state) {
      var shellRule = selectedShellRule(state);
      return selectedOption((shellRule || { options: [] }).options, state.shellSize);
    }

    function selectedPreviewChain() {
      var shell = selectedShell(state);
      if (!shell) return null;
      return Object.assign({}, shell, { code: shell.value || shell.code || shell.display });
    }

    function roundedPlacement(placement) {
      var normalized = normalizePlacementValue(placement) || DEFAULT_PREVIEW_PLACEMENT;
      return {
        x: Number(normalized.x.toFixed(2)),
        y: Number(normalized.y.toFixed(2)),
        size: Number(normalized.size.toFixed(2)),
        scaleX: Number(normalized.scaleX.toFixed(3)),
        scaleY: Number(normalized.scaleY.toFixed(3)),
        rotate: Number(normalized.rotate.toFixed(2)),
      };
    }

    function previewPlacement(chain, shell) {
      var code = chain && chain.code ? chain.code : "";
      var saved = calibrationMode && code ? calibrationMap[code] : null;
      var draft = calibrationMode && code ? calibrationDrafts[code] : null;
      var placement = Object.assign({}, DEFAULT_PREVIEW_PLACEMENT, PREVIEW_PLACEMENTS[code] || {}, saved || {}, draft || {});
      return normalizePlacementValue(placement) || Object.assign({}, DEFAULT_PREVIEW_PLACEMENT);
    }

    function applyPreviewPlacement(pendant, chain, shell, epoxy) {
      if (!pendant) return;
      var placement = previewPlacement(chain, shell);
      var previewScale = epoxy && Number.isFinite(Number(epoxy.previewScale)) ? Number(epoxy.previewScale) : 1;
      pendant.style.setProperty("--preview-shell-x", placement.x + "%");
      pendant.style.setProperty("--preview-shell-y", placement.y + "%");
      pendant.style.setProperty("--preview-shell-size", (placement.size * previewScale) + "%");
      pendant.style.setProperty("--preview-shell-scale-x", placement.scaleX);
      pendant.style.setProperty("--preview-shell-scale-y", placement.scaleY);
      pendant.style.setProperty("--preview-shell-rotate", placement.rotate + "deg");
    }

    function renderCalibrationPanel(chain, placement, message) {
      if (!calibrationMode || !preview) return;
      var panel = preview.querySelector("[data-preview-calibrator]");
      if (!panel) return;
      if (!chain || !chain.code) {
        panel.hidden = true;
        preview.classList.remove("is-calibrating");
        return;
      }

      panel.hidden = false;
      preview.classList.add("is-calibrating");

      var normalized = normalizePlacementValue(placement) || previewPlacement(chain, selectedShell(state));
      var title = panel.querySelector("[data-calibration-title]");
      var statusLine = panel.querySelector("[data-calibration-status]");
      if (title) title.textContent = "Overlay-Kalibrierung: " + optionLabel(chain);
      panel.querySelectorAll("[data-calibration-input]").forEach(function (input) {
        var key = input.dataset.calibrationInput;
        var value = normalized[key];
        input.value = Number.isFinite(value) ? String(Number(value.toFixed(key === "scaleX" || key === "scaleY" ? 3 : 2))) : "";
      });
      if (statusLine) {
        statusLine.textContent = message || "Ziehen, Gr\u00f6\u00dfe anpassen, dann OK speichern. Die Schalengr\u00f6\u00dfe \u00e4ndert diese Bildgr\u00f6\u00dfe nicht.";
      }
    }

    function applyCalibrationPatch(patch, message) {
      var chain = selectedPreviewChain();
      if (!chain || !chain.code) return;
      var current = Object.assign({}, previewPlacement(chain, selectedShell(state)));
      Object.keys(patch).forEach(function (key) {
        current[key] = patch[key];
      });
      var placement = normalizePlacementValue(current);
      if (!placement) return;
      calibrationDrafts[chain.code] = placement;
      applyPreviewPlacement(preview.querySelector("[data-preview-pendant]"), chain, selectedShell(state), selectedOption(MATRIX.epoxyPatterns, state.epoxyPattern));
      renderCalibrationPanel(chain, placement, message || "Noch nicht gespeichert.");
    }

    function updateCalibrationDraft(key, value) {
      var patch = {};
      patch[key] = value;
      applyCalibrationPatch(patch, "Noch nicht gespeichert.");
    }

    function saveCalibrationPlacement() {
      var chain = selectedPreviewChain();
      if (!chain || !chain.code) return;
      var placement = roundedPlacement(calibrationDrafts[chain.code] || previewPlacement(chain, selectedShell(state)));
      calibrationMap[chain.code] = placement;
      calibrationDrafts[chain.code] = placement;
      writeCalibrationMap(calibrationMap);
      renderCalibrationPanel(chain, placement, "Gespeichert für " + chain.code + ". Danach JSON kopieren, damit wir es fest ins Theme übernehmen können.");
    }

    function resetCalibrationPlacement() {
      var chain = selectedPreviewChain();
      if (!chain || !chain.code) return;
      delete calibrationMap[chain.code];
      delete calibrationDrafts[chain.code];
      writeCalibrationMap(calibrationMap);
      renderPreview();
      renderCalibrationPanel(chain, previewPlacement(chain, selectedShell(state)), "Lokale Kalibrierung für " + chain.code + " entfernt.");
    }

    function copyCalibrationPlacements() {
      var chain = selectedPreviewChain();
      var exportMap = Object.assign({}, calibrationMap);
      if (chain && chain.code && calibrationDrafts[chain.code]) {
        exportMap[chain.code] = roundedPlacement(calibrationDrafts[chain.code]);
      }
      var ordered = {};
      Object.keys(exportMap).sort().forEach(function (code) {
        ordered[code] = roundedPlacement(exportMap[code]);
      });
      var json = JSON.stringify(ordered, null, 2);
      copyText(json).then(function () {
        renderCalibrationPanel(chain, chain ? previewPlacement(chain, selectedShell(state)) : null, "JSON wurde in die Zwischenablage kopiert.");
      }).catch(function () {
        renderCalibrationPanel(chain, chain ? previewPlacement(chain, selectedShell(state)) : null, "Kopieren fehlgeschlagen. Bitte Browser-Berechtigung pruefen.");
      });
    }

    function bindCalibrationDrag() {
      if (!calibrationMode || !preview) return;
      var stage = preview.querySelector(".solea-configurator-preview-media__stage");
      if (!stage) return;
      stage.addEventListener("pointerdown", function (event) {
        var chain = selectedPreviewChain();
        if (!chain || !chain.code) return;
        event.preventDefault();
        if (stage.setPointerCapture) stage.setPointerCapture(event.pointerId);

        function move(clientX, clientY) {
          var rect = stage.getBoundingClientRect();
          applyCalibrationPatch({
            x: ((clientX - rect.left) / rect.width) * 100,
            y: ((clientY - rect.top) / rect.height) * 100,
          }, "Position gezogen. OK speichern, wenn sie passt.");
        }

        function onMove(moveEvent) {
          if (moveEvent.pointerId !== event.pointerId) return;
          move(moveEvent.clientX, moveEvent.clientY);
        }

        function onUp(upEvent) {
          if (upEvent.pointerId !== event.pointerId) return;
          stage.removeEventListener("pointermove", onMove);
          stage.removeEventListener("pointerup", onUp);
          stage.removeEventListener("pointercancel", onUp);
        }

        move(event.clientX, event.clientY);
        stage.addEventListener("pointermove", onMove);
        stage.addEventListener("pointerup", onUp);
        stage.addEventListener("pointercancel", onUp);
      });
    }

    function renderPreview() {
      if (!preview) return;

      var material = selectedOption(MATRIX.materials, state.material);
      var chain = selectedPreviewChain();
      var shell = selectedShell(state);
      var memoryObject = selectedOption(MATRIX.memoryObjectOptions, state.memoryObject);
      var epoxy = selectedOption(MATRIX.epoxyPatterns, state.epoxyPattern);
      var base = chain || material;

      var chainImage = preview.querySelector("[data-preview-chain]");
      var epoxyImage = preview.querySelector("[data-preview-epoxy]");
      var pendant = preview.querySelector("[data-preview-pendant]");
      var title = preview.querySelector("[data-preview-title]");
      var details = preview.querySelector("[data-preview-details]");

      setPreviewImage(chainImage, optionImageUrl(root, base, "image"), base ? optionLabel(base) : "", isMobileLayout() ? 480 : 0);
      setPreviewImage(epoxyImage, optionImageUrl(root, epoxy, "image"), epoxy ? optionLabel(epoxy) : "", isMobileLayout() ? 240 : 0);

      preview.classList.toggle("has-base", Boolean(base));
      preview.classList.toggle("has-chain", Boolean(chain));
      preview.classList.toggle("has-epoxy", Boolean(epoxy));
      applyPreviewPlacement(pendant, chain, shell, epoxy);
      if (pendant) pendant.hidden = !chain;
      renderCalibrationPanel(chain, chain ? previewPlacement(chain, shell) : null);

      if (title) title.textContent = chain ? optionLabel(chain) : base ? optionLabel(base) : configuratorText("Vorschau");
      if (details) {
        var parts = [
          material ? optionLabel(material) : "",
          shell ? optionLabel(shell) : "",
          memoryObject ? optionLabel(memoryObject) : "",
        ].filter(Boolean);
        details.textContent = parts.length ? parts.join(" - ") : configuratorText("Noch keine Auswahl");
      }
      if (previewZoom && !previewZoom.hidden) populatePreviewZoom();
    }

    function optionLabel(option) {
      return localizedPropertyText(option.display);
    }

    function variantLabel(field, option) {
      if (!field || field.id !== "chainStyle" || !option) return "";
      var index = field.options.findIndex(function (item) {
        return item.value === option.value;
      });
      if (index < 0) return optionLabel(option);
      return "Variante " + (index + 1);
    }

    function customerChoiceLabel(field, option) {
      if (!option) return "";
      return field && field.id === "chainStyle" ? variantLabel(field, option) : optionLabel(option);
    }

    function customerSelectionLabel(field, option) {
      if (!option) return "";
      if (field.id === "epoxyPattern") {
        return ((soleaI18n.exact || {})["Ausgewählt"] || "Ausgewählt");
      }
      return customerChoiceLabel(field, option);
    }

    function epoxyGroupName(option) {
      var label = String((option && (option.display || option.value)) || "").trim();
      var match = label.match(/^([A-Za-z]+)/);
      var group = match ? match[1].toUpperCase() : "OTHER";
      return EPOXY_GROUP_ALIASES[group] || group;
    }

    var EPOXY_GROUP_ALIASES = {
      BLACK: "DARK",
      LIGHTBLUE: "BLUE",
      LIGHTGREEN: "GREEN",
      ORANGE: "YELLOW",
      WHITE: "LIGHT",
    };

    var EPOXY_GROUP_LABELS = {
      BLUE: "Blau",
      LIGHT: "Hell",
      GOLD: "Gold",
      COPPER: "Kupfer",
      YELLOW: "Gelb",
      RED: "Rot",
      GREEN: "Gr\u00fcn",
      VIOLET: "Violett",
      PINK: "Rosa",
      DARK: "Dunkel",
      COLORSHIFT: "Farbwechsel",
      UNICOLOR: "Einfarbig",
      OTHER: "Sonstige",
    };

    var EPOXY_GROUP_ORDER = [
      "BLUE",
      "LIGHT",
      "GOLD",
      "COPPER",
      "YELLOW",
      "RED",
      "GREEN",
      "VIOLET",
      "PINK",
      "DARK",
      "COLORSHIFT",
      "UNICOLOR",
      "OTHER",
    ];

    function epoxyGroupLabel(groupName) {
      return EPOXY_GROUP_LABELS[groupName] || groupName;
    }

    function epoxyGroupRank(groupName) {
      var index = EPOXY_GROUP_ORDER.indexOf(groupName);
      return index === -1 ? EPOXY_GROUP_ORDER.length : index;
    }

    function epoxyGroups(options) {
      var groups = [];
      var seen = Object.create(null);
      (options || MATRIX.epoxyPatterns).forEach(function (option) {
        var group = epoxyGroupName(option);
        if (!seen[group]) {
          seen[group] = { name: group, count: 0 };
          groups.push(seen[group]);
        }
        seen[group].count += 1;
      });
      return groups.sort(function (a, b) {
        var rank = epoxyGroupRank(a.name) - epoxyGroupRank(b.name);
        return rank || epoxyGroupLabel(a.name).localeCompare(epoxyGroupLabel(b.name), "de");
      });
    }

    function baseOptionsForField(field) {
      if (field.id !== "epoxyPattern" || !epoxyPatternGroup) return field.options;
      return field.options.filter(function (option) {
        return epoxyGroupName(option) === epoxyPatternGroup;
      });
    }

    function clearEpoxySelectionOutsideGroup() {
      if (!epoxyPatternGroup || !state.epoxyPattern) return;
      var selected = selectedOption(MATRIX.epoxyPatterns, state.epoxyPattern);
      if (!selected || epoxyGroupName(selected) !== epoxyPatternGroup) {
        delete state.epoxyPattern;
      }
    }

    function activeFieldFor(fields) {
      if (activeFieldId && fields.some(function (field) { return field.id === activeFieldId; })) {
        return activeFieldId;
      }
      var firstMissing = fields.find(function (field) {
        return field.required && !state[field.id];
      });
      if (firstMissing) return firstMissing.id;
      return fields.length ? fields[fields.length - 1].id : "";
    }

    function filteredOptions(field) {
      var query = String(searchQueries[field.id] || "").trim().toLowerCase();
      var baseOptions = baseOptionsForField(field);
      if (!query) {
        if (!field.searchable) return baseOptions;
        var limit = optionLimits[field.id] || SEARCHABLE_INITIAL_LIMIT;
        return baseOptions.slice(0, Math.min(baseOptions.length, limit));
      }
      return baseOptions.filter(function (option) {
        return [option.display, option.value, option.code].join(" ").toLowerCase().indexOf(query) !== -1;
      });
    }

    function renderChoice(field, option) {
      var button = document.createElement("button");
      button.type = "button";
      button.className = "solea-configurator__choice";
      button.setAttribute("aria-pressed", String(state[field.id] === option.value));
      var visibleLabel = customerChoiceLabel(field, option);
      var epoxyChoiceLabel = ((soleaI18n.exact || {})["Epoxiddesign ausw\u00e4hlen"] || "Epoxiddesign ausw\u00e4hlen") + ": " + visibleLabel;
      if (field.id === "epoxyPattern") button.setAttribute("aria-label", epoxyChoiceLabel);
      if (field.id === "chainStyle") button.title = optionLabel(option);
      if (state[field.id] === option.value) button.classList.add("is-selected");

      var swatch = document.createElement("span");
      swatch.className = "solea-configurator__swatch";
      var image = optionImageUrl(root, option, "thumbnail");
      if (image) {
        swatch.classList.add("is-image");
        swatch.style.setProperty("--choice-image", "url('" + image + "')");
      } else {
        swatch.style.setProperty("--choice-color", "#e7ecef");
      }

      button.append(swatch);
      if (field.id !== "epoxyPattern") {
        var label = document.createElement("span");
        label.className = "solea-configurator__choice-label";
        label.textContent = visibleLabel;
        button.append(label);
      }

      if (option.priceDeltaCents) {
        var price = document.createElement("span");
        price.className = "solea-configurator__choice-note";
        price.textContent = "+ " + formatMoney(option.priceDeltaCents);
        button.append(price);
      }

      button.addEventListener("click", function () {
        state[field.id] = option.value;
        var fields = currentFields(state);
        activeFieldId = "";
        var fieldIds = fields.map(function (item) { return item.id; });
        var index = fieldIds.indexOf(field.id);
        fieldIds.slice(index + 1).forEach(function (nextId) {
          delete state[nextId];
          delete searchQueries[nextId];
          delete optionLimits[nextId];
        });
        render();
      });

      return button;
    }

    function renderEpoxyGroupFilter(field) {
      var wrap = document.createElement("div");
      wrap.className = "solea-configurator__pattern-groups";
      wrap.setAttribute("aria-label", "Farbgruppe filtern");
      wrap.addEventListener("scroll", function () {
        epoxyGroupScrollLeft = wrap.scrollLeft || 0;
      }, { passive: true });
      if (epoxyGroupScrollLeft > 0) {
        window.requestAnimationFrame(function () {
          wrap.scrollLeft = epoxyGroupScrollLeft;
        });
      }

      var all = document.createElement("button");
      all.type = "button";
      all.textContent = "Alle (" + field.options.length + ")";
      all.setAttribute("aria-pressed", String(!epoxyPatternGroup));
      if (!epoxyPatternGroup) all.classList.add("is-selected");
      all.addEventListener("click", function () {
        epoxyGroupScrollLeft = wrap.scrollLeft || epoxyGroupScrollLeft;
        epoxyPatternGroup = "";
        delete optionLimits.epoxyPattern;
        render();
      });
      wrap.append(all);

      epoxyGroups(field.options).forEach(function (group) {
        var button = document.createElement("button");
        button.type = "button";
        button.textContent = epoxyGroupLabel(group.name) + " (" + group.count + ")";
        button.setAttribute("aria-pressed", String(epoxyPatternGroup === group.name));
        if (epoxyPatternGroup === group.name) button.classList.add("is-selected");
        button.addEventListener("click", function () {
          epoxyGroupScrollLeft = wrap.scrollLeft || epoxyGroupScrollLeft;
          epoxyPatternGroup = group.name;
          clearEpoxySelectionOutsideGroup();
          delete optionLimits.epoxyPattern;
          render();
        });
        wrap.append(button);
      });

      return wrap;
    }

    function restoreEpoxyGroupScroll() {
      if (!epoxyGroupScrollLeft) return;
      var wrap = fieldsRoot.querySelector(".solea-configurator__pattern-groups");
      if (!wrap) return;
      var target = Math.min(epoxyGroupScrollLeft, Math.max(0, wrap.scrollWidth - wrap.clientWidth));
      function apply() {
        wrap.scrollLeft = target;
      }
      apply();
      window.requestAnimationFrame(apply);
      window.setTimeout(apply, 0);
    }

    function renderOptionPaging(field, shownCount) {
      var wrap = document.createElement("div");
      wrap.className = "solea-configurator__field-actions";

      var more = document.createElement("button");
      more.type = "button";
      more.textContent = "Weitere Designs anzeigen";
      more.addEventListener("click", function () {
        optionLimits[field.id] = Math.min(field.options.length, shownCount + SEARCHABLE_PAGE_SIZE);
        render();
      });

      var all = document.createElement("button");
      all.type = "button";
      all.textContent = "Alle Designs anzeigen";
      all.addEventListener("click", function () {
        optionLimits[field.id] = field.options.length;
        render();
      });

      wrap.append(more, all);
      return wrap;
    }

    function renderField(field, activeId) {
      var isOpen = field.id === activeId;
      var section = document.createElement("section");
      section.className = "solea-configurator__field";
      section.classList.add(isOpen ? "is-open" : "is-collapsed");
      section.dataset.field = field.id;

      var header = document.createElement("button");
      header.type = "button";
      header.className = "solea-configurator__field-header";
      header.setAttribute("aria-expanded", String(isOpen));
      header.addEventListener("click", function () {
        activeFieldId = field.id;
        render();
      });

      var label = document.createElement("span");
      label.className = "solea-configurator__field-label";
      label.textContent = field.label;

      var selected = document.createElement("span");
      selected.className = "solea-configurator__field-state";
      if (field.type === "textarea") {
        selected.textContent = state[field.id] ? "Ausgef\u00fcllt" : "Optional";
      } else {
        var selectedChoice = selectedOption(field.options, state[field.id]);
        selected.textContent = selectedChoice ? customerSelectionLabel(field, selectedChoice) : "Noch offen";
      }

      header.append(label, selected);
      section.append(header);

      var body = document.createElement("div");
      body.className = "solea-configurator__field-body";
      body.hidden = !isOpen;
      if (!isOpen) {
        section.append(body);
        return section;
      }

      if (field.id === "epoxyPattern") body.append(renderEpoxyGroupFilter(field));

      if (field.type === "textarea") {
        var textarea = document.createElement("textarea");
        textarea.className = "solea-configurator__textarea";
        textarea.rows = 4;
        textarea.maxLength = 600;
        textarea.placeholder = field.placeholder || "";
        textarea.value = state[field.id] || "";
        textarea.addEventListener("input", function () {
          if (textarea.value) {
            state[field.id] = textarea.value;
          } else {
            delete state[field.id];
          }
        });
        textarea.addEventListener("blur", render);
        body.append(textarea);
        section.append(body);
        return section;
      }

      var options = filteredOptions(field);
      var baseOptions = baseOptionsForField(field);
      var grid = document.createElement("div");
      grid.className = "solea-configurator__choice-grid";
      if (field.id === "epoxyPattern") grid.classList.add("is-patterns");
      if (field.id === "length") grid.classList.add("is-lengths");
      options.forEach(function (option) {
        grid.append(renderChoice(field, option));
      });
      body.append(grid);

      if (field.searchable && !searchQueries[field.id] && baseOptions.length > options.length) {
        var hint = document.createElement("p");
        hint.className = "solea-configurator__field-hint";
        hint.textContent = "Zeige " + options.length + " von " + baseOptions.length + " Designs. Du kannst weitere Designs laden.";
        body.append(hint);
        body.append(renderOptionPaging(field, options.length));
      } else if (field.searchable) {
        var count = document.createElement("p");
        count.className = "solea-configurator__field-hint";
        var groupText = field.id === "epoxyPattern" && epoxyPatternGroup ? " in " + epoxyGroupLabel(epoxyPatternGroup) : "";
        count.textContent = options.length + " Designs" + groupText + " verfügbar.";
        body.append(count);
      }

      section.append(body);
      return section;
    }

    function updateProgress() {
      var requiredFields = currentFields(state).filter(function (field) { return field.required; });
      var done = requiredFields.filter(function (field) { return state[field.id]; }).length;
      var percent = requiredFields.length ? Math.round((done / requiredFields.length) * 100) : 0;
      progressBar.style.width = percent + "%";
    }

    function renderStatus() {
      var missing = missingFields(state);
      if (missing.length === 0) {
        setStatus("Auswahl bereit für den Warenkorb.", "ready");
      } else if (missing.length === 1) {
        setStatus("Noch 1 Schritt offen: " + missing[0] + ".");
      } else {
        setStatus("Noch " + missing.length + " Schritte offen.");
      }
    }

    function renderPrice() {
      var prices = priceParts(state);
      if (priceTotal) priceTotal.textContent = formatMoney(prices.total);
      if (priceNote) {
        priceNote.textContent = prices.extras ? "inkl. " + formatMoney(prices.extras) + " Optionsaufschlag" : "ohne Optionsaufschlag";
      }
      updateProductPrice(prices.total);
    }

    function render() {
      normalizeState(state);
      fieldsRoot.replaceChildren();
      var fields = currentFields(state);
      activeFieldId = activeFieldFor(fields);
      fields.forEach(function (field) {
        fieldsRoot.append(renderField(field, activeFieldId));
      });
      restoreEpoxyGroupScroll();
      updateProgress();
      renderStatus();
      renderPrice();
      renderPreview();
      updateCartInputs(cartForm, state);
    }

    function ensurePilotSubmitButton() {
      var existing = cartForm.querySelector("[data-solea-memory-submit='true']");
      if (existing) return existing;

      var nativeButtons = formSubmitControls(cartForm);
      var referenceButton = nativeButtons.find(function (button) {
        return button.offsetWidth || button.offsetHeight || button.getClientRects().length;
      }) || nativeButtons[0];

      var button = document.createElement("button");
      button.type = "button";
      button.dataset.soleaMemorySubmit = "true";
      button.className = referenceButton && referenceButton.className
        ? referenceButton.className
        : "btn btn--full add-to-cart";
      button.classList.add("solea-configurator__cart-button");
      button.textContent = "IN DEN EINKAUFSWAGEN LEGEN";
      button.setAttribute("aria-label", "Konfigurierten Erinnerungsring in den Einkaufswagen legen");
      button.addEventListener("click", handleConfiguredSubmit, true);

      if (referenceButton && referenceButton.parentNode) {
        referenceButton.parentNode.insertBefore(button, referenceButton);
      } else {
        root.insertAdjacentElement("afterend", button);
      }
      button.setAttribute("type", "button");

      nativeButtons.forEach(function (nativeButton) {
        nativeButton.dataset.soleaPilotHiddenSubmit = "true";
        nativeButton.setAttribute("aria-hidden", "true");
        nativeButton.tabIndex = -1;
        nativeButton.style.display = "none";
      });

      return button;
    }

    function disablePilotSubmit(button, disabled) {
      if (!button) return;
      button.disabled = disabled;
      if (disabled) {
        button.dataset.soleaSubmitting = "true";
      } else {
        delete button.dataset.soleaSubmitting;
      }
    }

    function handleConfiguredSubmit(event) {
      if (event) {
        event.preventDefault();
        event.stopImmediatePropagation();
      }

      var missing = missingFields(state);
      if (missing.length > 0) {
        var firstMissing = currentFields(state).find(function (field) {
          return field.required && !state[field.id];
        });
        if (firstMissing) {
          activeFieldId = firstMissing.id;
          render();
        }
        setStatus("Bitte zuerst auswählen: " + missing.join(", ") + ".", "error");
        root.scrollIntoView({ behavior: "smooth", block: "center" });
        return;
      }

      updateCartInputs(cartForm, state);
      var items;
      try {
        items = buildCartItems(state, cartForm);
      } catch (error) {
        setStatus(error.message, "error");
        return;
      }

      disableSubmit(cartForm, true);
      disablePilotSubmit(pilotSubmitButton, true);
      setStatus("Lege Auswahl in den Warenkorb ...", "ready");
      addConfiguredItems(items)
        .then(function () {
          window.location.href = (window.theme && window.theme.routes && window.theme.routes.cartPage) || "/cart";
        })
        .catch(function (error) {
          var hasAddOn = priceParts(state).extras > 0;
          var message = hasAddOn
            ? "Der Aufpreis konnte nicht in den Warenkorb gelegt werden: " + error.message + ". Die Auswahl wurde nicht zum Basispreis hinzugefügt."
            : "Die Auswahl konnte nicht in den Warenkorb gelegt werden: " + error.message;
          setStatus(message, "error");
          disableSubmit(cartForm, false);
          disablePilotSubmit(pilotSubmitButton, false);
        });
    }

    window.addEventListener("click", function (event) {
      var target = event.target && event.target.closest
        ? event.target.closest("[data-solea-memory-submit='true']")
        : null;
      if (target) handleConfiguredSubmit(event);
    }, true);

    var pilotSubmitButton = ensurePilotSubmitButton();
    cartForm.addEventListener("submit", handleConfiguredSubmit, true);
    cartForm.querySelectorAll("button[name='add'], [name='add'], button[type='submit']").forEach(function (button) {
      button.addEventListener("click", handleConfiguredSubmit, true);
    });

    resetButton.addEventListener("click", function () {
      Object.keys(state).forEach(function (key) { delete state[key]; });
      Object.keys(searchQueries).forEach(function (key) { delete searchQueries[key]; });
      Object.keys(optionLimits).forEach(function (key) { delete optionLimits[key]; });
      epoxyPatternGroup = "";
      epoxyGroupScrollLeft = 0;
      activeFieldId = "";
      restoreProductPrice();
      applyStartSuggestion(state);
      render();
    });

    bindCalibrationDrag();
    syncPreviewHost();
    window.addEventListener("resize", schedulePreviewHostSync, { passive: true });
    render();
  }

  if (!isActive()) return;

  document.querySelectorAll("[data-solea-configurator-root]").forEach(initRoot);
})();
